// FormApp.js - Updated Full Code with DEFAULT VALUE SUPPORT & FREQUENCY SELECTION MODAL

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from "@ant-design/icons";
import Navbar from "./Navbar";
// import Sidebar from "./Sidebar";
import {
  InboxOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  ThunderboltOutlined,LockOutlined,
  FileTextOutlined,
  FileImageOutlined,
  PlusOutlined,
  UploadOutlined,
  ClockCircleOutlined,
  CopyFilled,
  FieldTimeOutlined,
  CheckCircleOutlined,
  CloseOutlined,
  EyeOutlined,
  DeleteOutlined,
  StarOutlined,
  StarFilled,
  LoadingOutlined,
  WarningOutlined,
  ExclamationCircleOutlined,
  AlertOutlined,
  CalendarOutlined,
  HourglassOutlined,
                          CalculatorOutlined,
  FontSizeOutlined,

  InfoCircleOutlined,
  SaveOutlined,
  ApiOutlined,
  SearchOutlined,
  CheckSquareOutlined,
  SwapOutlined,AppstoreOutlined,TableOutlined,
  NumberOutlined,       
  CloseCircleOutlined,  
  FunctionOutlined,ShareAltOutlined
} from "@ant-design/icons";
import { Tooltip as AntTooltip, Upload, Button, message, Tag, Space, Divider, Typography, Modal, Spin, Badge, Progress, Radio, Select, Checkbox, Table, Card, Row, Col } from "antd";

// Add session keep-alive function

const { Text } = Typography;
const { Option } = Select;

// Get API base URL from environment variable
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Comparison operators
const COMPARISON_OPERATORS = [
  { value: "equals", label: "Equals (=)", symbol: "=" },
  { value: "not_equals", label: "Not Equals (≠)", symbol: "≠" },
  { value: "greater_than", label: "Greater Than (>)", symbol: ">" },
  { value: "less_than", label: "Less Than (<)", symbol: "<" },
  { value: "greater_than_equal", label: "Greater Than or Equal (≥)", symbol: "≥" },
  { value: "less_than_equal", label: "Less Than or Equal (≤)", symbol: "≤" },
];

// Date comparison operators
const DATE_COMPARISON_OPERATORS = [
  { value: "equals", label: "Equals (=)", symbol: "=" },
  { value: "not_equals", label: "Not Equals (≠)", symbol: "≠" },
  { value: "before", label: "Before (<)", symbol: "<" },
  { value: "after", label: "After (>)", symbol: ">" },
  { value: "on_or_before", label: "On or Before (≤)", symbol: "≤" },
  { value: "on_or_after", label: "On or After (≥)", symbol: "≥" },
  { value: "between", label: "Between", symbol: "between" },
  { value: "current_date", label: "Current Date (Today)", symbol: "📅" },
];

// Arithmetic operators
const ARITHMETIC_OPERATORS = [
  { value: "add", label: "Addition (+)", symbol: "+" },
  { value: "subtract", label: "Subtraction (-)", symbol: "-" },
  { value: "multiply", label: "Multiplication (×)", symbol: "×" },
  { value: "divide", label: "Division (÷)", symbol: "÷" },
  { value: "average", label: "Average", symbol: "avg" },
];

// File type icons mapping
const FILE_TYPE_ICONS = {
  '.pdf': <FilePdfOutlined style={{ color: '#ff4d4f' }} />,
  '.doc': <FileWordOutlined style={{ color: '#1890ff' }} />,
  '.docx': <FileWordOutlined style={{ color: '#1890ff' }} />,
  '.xls': <FileExcelOutlined style={{ color: '#52c41a' }} />,
  '.xlsx': <FileExcelOutlined style={{ color: '#52c41a' }} />,
  '.txt': <FileTextOutlined style={{ color: '#fa8c16' }} />,
  '.jpg': <FileImageOutlined style={{ color: '#722ed1' }} />,
  '.jpeg': <FileImageOutlined style={{ color: '#722ed1' }} />,
  '.png': <FileImageOutlined style={{ color: '#722ed1' }} />,
  '.gif': <FileImageOutlined style={{ color: '#eb2f96' }} />,
  '.bmp': <FileImageOutlined style={{ color: '#13c2c2' }} />,
  'default': <FileOutlined />
};

// Unit options for number fields
const UNIT_OPTIONS = [
  { value: 'none', label: 'No Unit', labelMr: 'युनिट नाही', symbol: '' },
  { value: 'thousand', label: 'Thousand', labelMr: 'हजार', symbol: 'K' },
  { value: 'lakh', label: 'Lakh', labelMr: 'लाख', symbol: 'L' },
  { value: 'crore', label: 'Crore', labelMr: 'कोटी', symbol: 'Cr' },
];
const hasFormAccess = (form, user) => {
  if (!user || !form) return false;

  const userId = user.id;
  const userRoleId = String(user.role_id);
  const userRoleName = user.role_name || user.role;

  // User's location IDs
  const userUlbId = user.ulb_id;
  const userDistrictId = user.district_id;
  const userDivisionId = user.division_id;

  console.log(`:mag: Checking form ${form.id} (${form.form_name})`);
  console.log(`   User: ID=${userId}, Role=${userRoleName}(${userRoleId})`);
  console.log(`   ULB ID: ${userUlbId}, District ID: ${userDistrictId}, Division ID: ${userDivisionId}`);

  // For SUPER_ADMIN (role_id 5) - allow all forms
  if (userRoleId === '5') {
    console.log(`   SUPER_ADMIN user, showing all forms`);
    return true;
  }

  // For users with no location restrictions (DMA roles), allow all forms
  const dmaRoles = ['4', '6', '12']; // DMA_DESK_OFFICER, DMA_DESK_USER, DMA_ADMIN
  if (dmaRoles.includes(userRoleId) && !userUlbId && !userDistrictId && !userDivisionId) {
    console.log(`   DMA user with no location restrictions, showing all forms`);
    return true;
  }

  // Get access_control from form
  const accessControl = form.access_control;

  console.log(`   Access Control:`, accessControl);

  // If no access_control defined OR empty object, BLOCK access (private form)
  if (!accessControl || (typeof accessControl === 'object' && Object.keys(accessControl).length === 0)) {
    console.log(`   :x: No access_control defined or empty, blocking access`);
    return false;
  }

  let accessControlObj = accessControl;
  if (typeof accessControl === 'string') {
    try {
      accessControlObj = JSON.parse(accessControl);
      if (Object.keys(accessControlObj).length === 0) {
        console.log(`   :x: Parsed access_control is empty, blocking access`);
        return false;
      }
    } catch (e) {
      console.error(`   :x: Error parsing access_control:`, e);
      return false;
    }
  }

  // Check access based on user's role and their respective location ID
  let hasAccess = false;
  let matchedRole = null;
  let matchedId = null;

  for (const [roleId, roleConfig] of Object.entries(accessControlObj)) {
    const selectedIds = roleConfig.selectedIds || [];
    console.log(`   Checking Role ${roleId}: selectedIds =`, selectedIds);

    // ROLE ID MAPPINGS:
    // 1 = ULB
    // 7 = ULB_CHIEF_OFFICER
    // 2 = DISTRICT_ADMIN
    // 3 = DIVISIONAL_OFFICER
    // 4 = DMA_DESK_OFFICER
    // 5 = SUPER_ADMIN
    // 6 = DMA_DESK_USER
    // 11 = CADER
    // 12 = DMA_ADMIN

    // ULB Roles (role_id 1 and 7) - check against ulb_id
    if (roleId === '1' || roleId === '7') {
      if (userUlbId && (selectedIds.includes(userUlbId) ||
          selectedIds.includes(Number(userUlbId)) ||
          selectedIds.includes(String(userUlbId)))) {
        hasAccess = true;
        matchedRole = roleId;
        matchedId = userUlbId;
        console.log(`   :white_check_mark: Found ULB ${userUlbId} in Role ${roleId}'s selectedIds`);
        break;
      }
    }

    // DISTRICT_ADMIN Role (role_id 2) - check against district_id
    else if (roleId === '2') {
      if (userDistrictId && (selectedIds.includes(userDistrictId) ||
          selectedIds.includes(Number(userDistrictId)) ||
          selectedIds.includes(String(userDistrictId)))) {
        hasAccess = true;
        matchedRole = roleId;
        matchedId = userDistrictId;
        console.log(`   :white_check_mark: Found District ${userDistrictId} in Role ${roleId}'s selectedIds`);
        break;
      }
    }

    // DIVISIONAL_OFFICER Role (role_id 3) - check against division_id
    else if (roleId === '3') {
      if (userDivisionId && (selectedIds.includes(userDivisionId) ||
          selectedIds.includes(Number(userDivisionId)) ||
          selectedIds.includes(String(userDivisionId)))) {
        hasAccess = true;
        matchedRole = roleId;
        matchedId = userDivisionId;
        console.log(`   :white_check_mark: Found Division ${userDivisionId} in Role ${roleId}'s selectedIds`);
        break;
      }
    }

    // DMA Roles (4, 6, 12) - can access based on state or all if no restrictions
    else if (roleId === '4' || roleId === '6' || roleId === '12') {
      // If selectedIds is empty, allow access (DMA can see all)
      if (selectedIds.length === 0) {
        hasAccess = true;
        matchedRole = roleId;
        console.log(`   :white_check_mark: DMA Role ${roleId} with no restrictions, allowing access`);
        break;
      }
      // If DMA has specific state/district restrictions
      else if (userDistrictId && selectedIds.includes(userDistrictId)) {
        hasAccess = true;
        matchedRole = roleId;
        matchedId = userDistrictId;
        console.log(`   :white_check_mark: DMA user matched District ${userDistrictId} in Role ${roleId}`);
        break;
      }
    }

    // CADER Role (11) - check against district_id or division_id
    else if (roleId === '11') {
      if ((userDistrictId && selectedIds.includes(userDistrictId)) ||
          (userDivisionId && selectedIds.includes(userDivisionId))) {
        hasAccess = true;
        matchedRole = roleId;
        console.log(`   :white_check_mark: CADER user matched location in Role ${roleId}`);
        break;
      }
    }

    // For any other role, fallback to user ID check
    else {
      if (selectedIds.length === 0 || selectedIds.includes(userId) ||
          selectedIds.includes(Number(userId)) || selectedIds.includes(String(userId))) {
        hasAccess = true;
        matchedRole = roleId;
        console.log(`   :white_check_mark: User matched Role ${roleId} by user ID`);
        break;
      }
    }
  }

  if (!hasAccess) {
    console.log(`   :x: User ${userId} (Role: ${userRoleId}) NOT found in any role's selectedIds`);
  } else {
    console.log(`   :white_check_mark: Access granted via Role ${matchedRole} with ID ${matchedId || 'no restriction'}`);
  }

  return hasAccess;
};
// Number to Words converter functions
const numberToWords = (num) => {
  if (num === '' || num === null || num === undefined) return '';
  
  const numStr = String(num).replace(/,/g, '');
  if (isNaN(numStr) || numStr === '') return '';
  
  const number = parseFloat(numStr);
  if (isNaN(number)) return '';
  
  const parts = numStr.split('.');
  const integerPart = parseInt(parts[0], 10);
  // ✅ FIX: Keep decimal part as STRING to preserve leading zeros
  const decimalPartStr = parts[1] || null;
  
  const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  const convertLessThanThousand = (n) => {
    if (n === 0) return '';
    if (n < 20) return ones[n] + ' ';
    if (n < 100) return tens[Math.floor(n / 10)] + ' ' + (n % 10 !== 0 ? ones[n % 10] + ' ' : '');
    return ones[Math.floor(n / 100)] + ' hundred ' + convertLessThanThousand(n % 100);
  };

  const convertToWords = (n) => {
    if (n === 0) return 'zero';
    
    const units = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion'];
    let result = '';
    let unitIndex = 0;
    let tempNum = n;
    
    while (tempNum > 0) {
      const chunk = tempNum % 1000;
      if (chunk !== 0) {
        result = convertLessThanThousand(chunk) + units[unitIndex] + ' ' + result;
      }
      tempNum = Math.floor(tempNum / 1000);
      unitIndex++;
    }
    
    return result.trim();
  };
  
  let words = convertToWords(integerPart);
  
  // ✅ FIX: Handle decimal part with leading zeros preserved
  if (decimalPartStr !== null && decimalPartStr !== '') {
    const decimalValue = parseInt(decimalPartStr, 10);
    
    // Check if decimal part has meaningful value OR has leading zeros
    if (decimalValue !== 0 || decimalPartStr.length > 1) {
      const decimalDigits = decimalPartStr.split('');
      const decimalWordsArray = decimalDigits.map(digit => {
        const digitNum = parseInt(digit, 10);
        if (digitNum === 0) return 'zero';
        if (digitNum < 20) return ones[digitNum];
        return '';
      });
      words += ` point ${decimalWordsArray.join(' ')}`;
    }
  }
  
  return words.charAt(0).toUpperCase() + words.slice(1);
};

// English number to words converter
const convertToEnglishWords = (num, decimal = 0) => {
    if (num === 0 && decimal === 0) return 'Zero';

    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
                  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const convertIndian = (n) => {
        if (n === 0) return '';

        let word = '';
        let crore = Math.floor(n / 10000000);
        let lakh = Math.floor((n % 10000000) / 100000);
        let thousand = Math.floor((n % 100000) / 1000);
        let hundred = Math.floor((n % 1000) / 100);
        let remainder = n % 100;

        if (crore > 0) {
            word += convertIndian(crore) + ' Crore ';
        }
        if (lakh > 0) {
            word += convertIndian(lakh) + ' Lakh ';
        }
        if (thousand > 0) {
            word += convertIndian(thousand) + ' Thousand ';
        }
        if (hundred > 0) {
            word += ones[hundred] + ' Hundred ';
        }
        if (remainder > 0) {
            if (remainder < 20) {
                word += ones[remainder] + ' ';
            } else {
                word += tens[Math.floor(remainder / 10)] + ' ' + ones[remainder % 10] + ' ';
            }
        }

        return word.trim();
    };

    let result = convertIndian(num).trim();

    if (decimal > 0) {
        let decimalWords = '';
        const decimalStr = decimal.toString();
        for (let i = 0; i < decimalStr.length; i++) {
            decimalWords += ones[parseInt(decimalStr[i])] + ' ';
        }
        result += ' Point ' + decimalWords.trim();
    }

    return result || 'Zero';
};

// Marathi number to words converter
const convertToMarathiWords = (num, decimal = 0) => {
    if (num === 0 && decimal === 0) return 'शून्य';

    const marathiOnes = ['', 'एक', 'दोन', 'तीन', 'चार', 'पाच', 'सहा', 'सात', 'आठ', 'नऊ',
                         'दहा', 'अकरा', 'बारा', 'तेरा', 'चौदा', 'पंधरा', 'सोळा', 'सतरा', 'अठरा', 'एकोणीस'];
    const marathiTens = ['', '', 'वीस', 'तीस', 'चाळीस', 'पन्नास', 'साठ', 'सत्तर', 'ऐंशी', 'नव्वद'];
    const marathiHundred = 'शंभर';
    const marathiThousand = 'हजार';
    const marathiLakh = 'लाख';
    const marathiCrore = 'कोटी';

    const convertMarathiIndian = (n) => {
        if (n === 0) return '';

        let word = '';
        let crore = Math.floor(n / 10000000);
        let lakh = Math.floor((n % 10000000) / 100000);
        let thousand = Math.floor((n % 100000) / 1000);
        let hundred = Math.floor((n % 1000) / 100);
        let remainder = n % 100;

        if (crore > 0) {
            word += convertMarathiIndian(crore) + ' ' + marathiCrore + ' ';
        }
        if (lakh > 0) {
            word += convertMarathiIndian(lakh) + ' ' + marathiLakh + ' ';
        }
        if (thousand > 0) {
            word += convertMarathiIndian(thousand) + ' ' + marathiThousand + ' ';
        }
        if (hundred > 0) {
            word += marathiOnes[hundred] + ' ' + marathiHundred + ' ';
        }
        if (remainder > 0) {
            if (remainder < 20) {
                word += marathiOnes[remainder] + ' ';
            } else {
                word += marathiTens[Math.floor(remainder / 10)] + ' ' + marathiOnes[remainder % 10] + ' ';
            }
        }

        return word.trim();
    };

    let result = convertMarathiIndian(num).trim();

    if (decimal > 0) {
        let decimalWords = ' दशांश ';
        const decimalStr = decimal.toString();
        for (let i = 0; i < decimalStr.length; i++) {
            decimalWords += marathiOnes[parseInt(decimalStr[i])] + ' ';
        }
        result += decimalWords;
    }

    return result || 'शून्य';
};

// Date comparison helper functions
const compareDates = (date1, date2, operator) => {
    if (!date1 || !date2) return false;

    const d1 = new Date(date1);
    const d2 = new Date(date2);

    if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return false;

    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    switch (operator) {
        case "equals":
            return d1.getTime() === d2.getTime();
        case "not_equals":
            return d1.getTime() !== d2.getTime();
        case "before":
            return d1.getTime() < d2.getTime();
        case "after":
            return d1.getTime() > d2.getTime();
        case "on_or_before":
            return d1.getTime() <= d2.getTime();
        case "on_or_after":
            return d1.getTime() >= d2.getTime();
        default:
            return false;
    }
};

const isDateInRange = (date, startDate, endDate) => {
    if (!date) return false;
    const d = new Date(date);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    d.setHours(0, 0, 0, 0);
    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(0, 0, 0, 0);

    let valid = true;
    if (start && d < start) valid = false;
    if (end && d > end) valid = false;

    return valid;
};

const FormApp = () => {
    console.log('🚀 FormApp component rendering');
    const navigate = useNavigate();

    const [sbCollapsed, setSbCollapsed] = useState(false);
    const [allForms, setAllForms] = useState([]);
    const [activeForms, setActiveForms] = useState([]);
    const [currentForm, setCurrentForm] = useState(null);
    const [formData, setFormData] = useState({});
    const [viewMode, setViewMode] = useState('list');
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [userLoading, setUserLoading] = useState(true);
    const [selectedLanguage, setSelectedLanguage] = useState('english');
    const [validationErrors, setValidationErrors] = useState({});
    const [formMetadata, setFormMetadata] = useState(null);
    const [progress, setProgress] = useState(0);
    const [confirmSubmit, setConfirmSubmit] = useState(false);

    const [isFormBlocked, setIsFormBlocked] = useState(false);
    const [viewFilledMode, setViewFilledMode] = useState(false);
    const [submittedFormData, setSubmittedFormData] = useState(null);
    const [isMultiEntryLimitReached, setIsMultiEntryLimitReached] = useState(false);

    const [fieldUnits, setFieldUnits] = useState({});
    const [showOnlyNew, setShowOnlyNew] = useState(false);
    const [entries, setEntries] = useState([]);
    const [currentEntryId, setCurrentEntryId] = useState(null);
    const [showEntrySelector, setShowEntrySelector] = useState(false);
    const [entryLimitModal, setEntryLimitModal] = useState(false);
    const [printMode, setPrintMode] = useState(false);
    const formRef = useRef(null);
    const [uploadingFiles, setUploadingFiles] = useState({});
    const [lastLoaded, setLastLoaded] = useState(Date.now());

    // 🆕 Frequency Modal State Variables
    const [showFrequencyModal, setShowFrequencyModal] = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [pendingFormId, setPendingFormId] = useState(null);
    const [customStartDate, setCustomStartDate] = useState('');
    const [customEndDate, setCustomEndDate] = useState('');

    const [expiringForms, setExpiringForms] = useState([]);
    const [expiredForms, setExpiredForms] = useState([]);
    const [showSLAAlert, setShowSLAAlert] = useState(false);
    const [slaViolations, setSlaViolations] = useState([]);
    const [loadingSLA, setLoadingSLA] = useState(false);
    const [formsDeadlines, setFormsDeadlines] = useState({});
    const [checkingSubmissions, setCheckingSubmissions] = useState({});

    const [dscVerified, setDscVerified] = useState(false);

    const API_BASE = `${API_BASE_URL}/api`;

   const blinkStyles = `
        @keyframes gentleBlink {
            0% { opacity: 1; transform: scale(1); background: #ff4d4f; box-shadow: 0 0 0px rgba(255, 77, 79, 0.5); }
            50% { opacity: 0.9; transform: scale(1.05); background: #ff6b6b; box-shadow: 0 0 10px rgba(255, 77, 79, 0.8); }
            100% { opacity: 1; transform: scale(1); background: #ff4d4f; box-shadow: 0 0 0px rgba(255, 77, 79, 0.5); }
        }
        .new-badge {
            animation: gentleBlink 2s ease-in-out infinite;
            display: inline-flex;
            align-items: center;
            background: #ff4d4f;
            color: white;
            font-weight: bold;
            padding: 3px 12px;
            border-radius: 20px;
            font-size: 11px;
            margin-left: 8px;
            letter-spacing: 0.5px;
            border: 1px solid rgba(255, 255, 255, 0.3);
            transition: all 0.3s ease;
        }
        .new-badge:hover {
            animation: none;
            background: #ff3336;
            transform: scale(1.02);
            box-shadow: 0 2px 8px rgba(255, 77, 79, 0.6);
        }
        .new-star {
            animation: gentleBlink 2s ease-in-out infinite;
            display: inline-flex;
            align-items: center;
            margin-left: 6px;
            color: #ff4d4f !important;
            font-size: 14px;
            filter: drop-shadow(0 0 4px rgba(255, 77, 79, 0.5));
        }

        @keyframes gentlePulse {
            0% { background-color: #fff3e0; border-color: #ff9800; box-shadow: 0 0 0px rgba(255, 152, 0, 0.3); }
            50% { background-color: #ffe0b2; border-color: #f57c00; box-shadow: 0 0 8px rgba(255, 152, 0, 0.5); }
            100% { background-color: #fff3e0; border-color: #ff9800; box-shadow: 0 0 0px rgba(255, 152, 0, 0.3); }
        }
        .deadline-urgent {
            animation: gentlePulse 2s ease-in-out infinite;
            border: 2px solid #ff9800;
            background-color: #fff3e0;
        }
        .deadline-today {
            background-color: #ffebee !important;
            border: 2px solid #f44336 !important;
            color: #c62828 !important;
            font-weight: bold;
            box-shadow: 0 2px 8px rgba(244, 67, 54, 0.3);
        }
        .deadline-tomorrow {
            background-color: #fff3e0 !important;
            border: 2px solid #ff9800 !important;
            color: #e65100 !important;
        }
        .deadline-2days {
            background-color: #e8f5e9 !important;
            border: 2px solid #4caf50 !important;
            color: #2e7d32 !important;
        }

        /* Mobile Responsive Styles */
        @media (max-width: 768px) {
            .form-app-main {
                padding: 12px !important;
                margin-left: 0 !important;
                width: 100% !important;
                box-sizing: border-box !important;
            }

            .forms-container {
                width: 100% !important;
                max-width: 100% !important;
                margin: 0 !important;
                padding: 0 8px !important;
                box-sizing: border-box !important;
            }

            .form-card {
                width: 100% !important;
                flex-direction: column !important;
                align-items: flex-start !important;
                padding: 12px !important;
                margin-bottom: 12px !important;
                box-sizing: border-box !important;
                border-radius: 10px !important;
            }

            .form-card-actions {
                width: 100% !important;
                margin-top: 12px !important;
                margin-left: 0 !important;
            }

            .form-card-actions button {
                width: 100% !important;
                min-width: auto !important;
            }

            .form-list-header {
                flex-direction: column !important;
                gap: 12px !important;
                align-items: flex-start !important;
                padding: 12px !important;
                margin-bottom: 16px !important;
            }

            .fill-form-container {
                width: 100% !important;
                max-width: 100% !important;
                margin: 0 !important;
                padding: 16px !important;
                box-sizing: border-box !important;
                border-radius: 12px !important;
            }

            .fill-header {
                flex-direction: column !important;
                width: 100% !important;
                margin-bottom: 20px !important;
            }

            .button-group {
                flex-direction: column !important;
                width: 100% !important;
                gap: 12px !important;
            }

            .button-group button {
                width: 100% !important;
                margin: 0 !important;
            }

            .ant-modal {
                width: 95% !important;
                max-width: 95% !important;
                margin: 0 auto !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
            }

            .ant-modal-body {
                padding: 16px !important;
            }

            .ant-modal-content {
                border-radius: 12px !important;
                overflow: hidden !important;
            }

            .ant-table-wrapper {
                width: 100% !important;
                overflow-x: auto !important;
                -webkit-overflow-scrolling: touch !important;
            }

            .ant-table {
                min-width: 500px !important;
            }

            .progress-container {
                width: 100% !important;
                margin-bottom: 20px !important;
            }

            .confirmation-box {
                width: 100% !important;
                padding: 16px !important;
                flex-direction: column !important;
                align-items: flex-start !important;
                box-sizing: border-box !important;
            }

            .sla-card {
                width: 100% !important;
                margin: 12px 0 !important;
                box-sizing: border-box !important;
            }

            .tag-group {
                flex-wrap: wrap !important;
                gap: 6px !important;
            }

            .radio-option, .checkbox-option {
                width: 100% !important;
                padding: 10px !important;
                margin-bottom: 8px !important;
                box-sizing: border-box !important;
            }

            .empty-state {
                text-align: center !important;
                padding: 40px 20px !important;
            }

            h2 {
                font-size: 20px !important;
            }

            h3 {
                font-size: 18px !important;
            }
        }

        @media (max-width: 480px) {
            .form-app-main {
                padding: 8px !important;
            }

            .fill-form-container {
                padding: 12px !important;
            }

            .form-card {
                padding: 10px !important;
            }

            .form-card .form-name {
                font-size: 15px !important;
            }

            .form-list-header h2 {
                font-size: 18px !important;
            }

            .ant-tag {
                font-size: 10px !important;
                padding: 0 6px !important;
            }

            .field-label {
                font-size: 13px !important;
            }

            input, select, textarea {
                font-size: 16px !important;
            }

            .ant-modal-close {
                top: 12px !important;
                right: 12px !important;
            }

            button,
            .ant-btn,
            .form-card,
            .radio-option,
            .checkbox-option {
                cursor: pointer !important;
                -webkit-tap-highlight-color: transparent !important;
            }
        }

        @media (min-width: 769px) and (max-width: 1024px) {
            .forms-container {
                max-width: 90% !important;
            }

            .form-card {
                padding: 14px !important;
            }
        }

        /* Fix for iOS devices */
        @supports (-webkit-touch-callout: none) {
            @media (max-width: 768px) {
                input, select, textarea {
                    font-size: 16px !important;
                }

                .ant-modal {
                    top: 10% !important;
                    transform: none !important;
                }
            }
        }
    `;

    useEffect(() => {
        console.log('🟢 FormApp mounted/updated');
        console.log('📊 Current State:', {
            viewMode,
            currentFormId: currentForm?.id,
            currentFormName: currentForm?.form_name,
            formDataKeys: Object.keys(formData).length,
            activeFormsCount: activeForms.length,
            allFormsCount: allForms.length,
            currentUserId: currentUser?.id,
            currentUserName: currentUser?.name,
            currentUserRole: currentUser?.role,
            currentUserRoleId: currentUser?.role_id,
            currentUserEmail: currentUser?.email,
            currentUserDivision: currentUser?.division_id,
            currentUserDistrict: currentUser?.district_id,
            currentUserUlb: currentUser?.ulb_id,
            loading,
            userLoading,
            selectedLanguage,
            slaViolationsCount: slaViolations.length,
            validationErrorsCount: Object.keys(validationErrors).length,
            formsDeadlinesCount: Object.keys(formsDeadlines).length,
            showOnlyNew,
            isFormBlocked,
            viewFilledMode,
            isMultiEntryLimitReached
        });
    });

    useEffect(() => {
        console.log('🔄 viewMode changed to:', viewMode);
        if (viewMode === 'fill') {
            console.log('📋 Current form in fill mode:', currentForm?.id, currentForm?.form_name);
            console.log('📋 Form schema exists?', currentForm?.schema ? 'Yes' : 'No');
            if (currentForm?.schema) {
                console.log('📋 Schema fields count:', currentForm.schema.length);
                currentForm.schema.forEach(field => {
                    if (field.validation && Object.keys(field.validation).length > 0) {
                        console.log(`🔍 Field ${field.id} validation:`, field.validation);
                    }
                });
            }
        }
    }, [viewMode, currentForm]);

    const isFormActive = (form) => {
        if (!form) return false;
        const status = form.status;
        if (status === undefined || status === null) return true;
        return status === 1 || status === true || status === '1' || status === 'true';
    };

    const isFormNew = (form) => {
    if (!form || !form.created_at) return false;
    // If form has any submission status, it's not new
    if (form.submission_status === 'submitted' || form.submission_status === 'filled' || form.submission_status === 'approved') {
        return false;
    }
    const createdDate = new Date(form.created_at);
    const now = new Date();
    const diffHours = (now - createdDate) / (1000 * 60 * 60);
    return diffHours < 24;
};

    const getUserSubmissionStatus = async (formId, userId) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${API_BASE}/form-submissions/${formId}/${userId}`, {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        });
        const result = await response.json();
        // 🔥 'approved', 'submitted', 'filled' - all are considered submitted
        if (result?.status === 'submitted' || result?.status === 'filled' || result?.status === 'approved') {
            return { isSubmitted: true, submissionData: result.data };
        }
        return { isSubmitted: false, submissionData: null };
    } catch (error) {
        console.error('Error checking submission status:', error);
        return { isSubmitted: false, submissionData: null };
    }
};
    const getUserEntryCount = async (formId, userId) => {
        try {
            const response = await fetch(`${API_BASE}/form-submissions/${formId}/${userId}`);
            const result = await response.json();
            if (result.entries && Array.isArray(result.entries)) {
                return result.entries.length;
            } else if (Array.isArray(result)) {
                return result.length;
            } else if (result.data && Array.isArray(result.data)) {
                return result.data.length;
            } else if (result.count !== undefined) {
                return result.count;
            }
            return 0;
        } catch (error) {
            console.error('Error checking entry count:', error);
            return 0;
        }
    };

    const normalizeFormStatus = async (form) => {
        if (!form) return form;
        let userSubmissionStatus = null;
        let isBlocked = false;
        let entryCount = 0;
        let maxEntries = form.max_entries_per_user || 0;

        if (currentUser?.id) {
            if (form.entry_type === 'multi') {
                entryCount = await getUserEntryCount(form.id, currentUser.id);
                if (maxEntries > 0 && entryCount >= maxEntries) {
                    userSubmissionStatus = 'limit_reached';
                    isBlocked = true;
                } else {
                    userSubmissionStatus = 'can_fill';
                    isBlocked = false;
                }
            } else {
                const { isSubmitted } = await getUserSubmissionStatus(form.id, currentUser.id);
                userSubmissionStatus = isSubmitted ? 'submitted' : 'not_submitted';
                isBlocked = isSubmitted;
            }
        }

        return {
            ...form,
            status: isFormActive(form) ? 1 : 0,
            entryTypeDisplay: form.entry_type === 'multi' ? 'Multi Entry' : 'Single Entry',
            frequencyDisplay: form.frequency?.enabled ? form.frequency.type : null,
            isNew: isFormNew(form),
            userSubmissionStatus: userSubmissionStatus,
            isBlocked: isBlocked,
            entryCount: entryCount,
            maxEntries: maxEntries
        };
    };

    const fetchFormsDeadlines = useCallback(async () => {
        if (!currentUser?.id) return;

        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(`${API_BASE}/workflow/user/${currentUser.id}/grouped-tasks`, {
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success && result.data) {
                const deadlineMap = {};
                result.data.forEach(group => {
                    if (group.instances && group.instances.length > 0) {
                        const activeInstances = group.instances.filter(inst =>
                            inst.instance_status === 'in_progress' && inst.sla_deadline
                        );
                        if (activeInstances.length > 0) {
                            const deadlines = activeInstances.map(inst => new Date(inst.sla_deadline).getTime());
                            const earliestDeadline = new Date(Math.min(...deadlines));
                            deadlineMap[group.form_id] = earliestDeadline;
                        }
                    }
                });
                setFormsDeadlines(deadlineMap);
            }
        } catch (error) {
            console.error('❌ Error fetching forms deadlines:', error);
        }
    }, [API_BASE, currentUser?.id]);

    const fetchSLAViolations = useCallback(async () => {
        console.log('📡 Fetching SLA violations from database...');
        setLoadingSLA(true);

        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(`${API_BASE}/sla/violations`, {
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success && result.data) {
                setSlaViolations(result.data);

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const expiring = [];
                const expired = [];

                result.data.forEach(violation => {
                    if (violation.expected_deadline) {
                        const deadlineDate = new Date(violation.expected_deadline);
                        deadlineDate.setHours(0, 0, 0, 0);

                        const diffTime = deadlineDate - today;
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                        if (diffDays < 0) {
                            expired.push({
                                ...violation,
                                daysOverdue: Math.abs(diffDays),
                                status: 'expired'
                            });
                        } else if (diffDays <= 3) {
                            expiring.push({
                                ...violation,
                                daysLeft: diffDays,
                                status: diffDays === 0 ? 'today' : diffDays === 1 ? 'tomorrow' : 'day_after'
                            });
                        }
                    }
                });

                setExpiringForms(expiring);
                setExpiredForms(expired);

                if (expiring.length > 0 || expired.length > 0) {
                    setShowSLAAlert(true);
                } else {
                    setShowSLAAlert(false);
                }
            }
        } catch (error) {
            console.error('❌ Error fetching SLA violations:', error);
        } finally {
            setLoadingSLA(false);
        }
    }, [API_BASE]);

    useEffect(() => {
        fetchSLAViolations();
        const interval = setInterval(() => {
            fetchSLAViolations();
        }, 300000);
        return () => clearInterval(interval);
    }, [fetchSLAViolations]);

    useEffect(() => {
        const checkLanguage = () => {
            const savedLanguage = sessionStorage.getItem("dma_portal_language");
            if (savedLanguage === "MR") {
                setSelectedLanguage("marathi");
            } else {
                setSelectedLanguage("english");
            }
        };

        checkLanguage();
        const interval = setInterval(checkLanguage, 500);
        return () => clearInterval(interval);
    }, []);

    const handlePrint = useCallback(() => {
        setPrintMode(true);
        setTimeout(() => {
            window.print();
            setPrintMode(false);
        }, 100);
    }, []);

const printStyles = `
    @media print {
        @page {
            margin-top: 1cm;
            margin-bottom: 2.5cm;
            margin-left: 1.5cm;
            margin-right: 1.5cm;
            size: A4;
            
            /* Custom footer with page numbers */
            @bottom-center {
                content: "Page " counter(page) " of " counter(pages);
                font-size: 9pt;
                color: #666;
            }
            
            /* Remove default headers/footers */
            @top-left {
                content: "";
            }
            @top-right {
                content: "";
            }
            @bottom-left {
                content: "";
            }
            @bottom-right {
                content: "";
            }
        }
        
        body * {
            visibility: hidden;
        }
        .printable-area, .printable-area * {
            visibility: visible;
        }
        .printable-area {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            padding: 20px;
            background: white;
            font-family: Arial, sans-serif;
        }
        .no-print {
            display: none !important;
        }
        
        .print-field {
            page-break-inside: avoid;
            margin-bottom: 15px;
            padding: 10px;
            border-bottom: 1px solid #eee;
        }
        
        .print-header {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            margin-bottom: 30px;
            padding-bottom: 15px;
            border-bottom: 2px solid #333;
        }
        .print-header-left {
            text-align: left;
        }
        .print-header-left h2 {
            margin: 0 0 10px 0;
            font-size: 24px;
            color: #333;
        }
        .print-header-left p {
            margin: 5px 0;
            font-size: 14px;
            color: #555;
        }
        .print-signature {
            text-align: right;
            border-left: 2px solid #999;
            padding-left: 20px;
        }
        .print-signature .signature-line {
            margin-top: 40px;
            border-top: 1px solid #333;
            width: 200px;
            text-align: center;
            padding-top: 5px;
            font-size: 12px;
            color: #666;
        }
        
        .print-label {
            font-weight: bold;
            color: #333;
            min-width: 200px;
            display: inline-block;
        }
        .print-value {
            color: #000;
            margin-left: 10px;
        }
        .print-footer {
            margin-top: 50px;
            text-align: center;
            font-size: 12px;
            color: #666;
            border-top: 1px solid #ccc;
            padding-top: 10px;
        }
        
        html, body {
            margin: 0;
            padding: 0;
        }
    }
`;

    // Add this near the top
// Add these helper functions at the top of FormApp.js (outside any component)

const isLogicalOperator = (operator) => {
  const logicalOps = ['equals', 'not_equals', 'greater_than', 'less_than', 'greater_than_equal', 'less_than_equal'];
  return logicalOps.includes(operator);
};

const refreshToken = async () => {
  try {
    const refreshToken = sessionStorage.getItem('refreshToken');
    if (!refreshToken) return false;

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE = `${API_BASE_URL}/api`;

    const response = await fetch(`${API_BASE}/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken })
    });

    if (response.ok) {
      const data = await response.json();
      if (data.token) {
        sessionStorage.setItem('token', data.token);
        console.log('✅ Token refreshed successfully');
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error('Token refresh failed:', error);
    return false;
  }
};
const startSessionKeepAlive = () => {
  const interval = setInterval(async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      clearInterval(interval);
      return;
    }

    // Check if token is about to expire (within 5 minutes)
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expTime = payload.exp * 1000;
      const timeUntilExpiry = expTime - Date.now();

      if (timeUntilExpiry < 5 * 60 * 1000) {
        console.log('Token expiring soon, refreshing...');
        await refreshToken();
      }
    } catch (e) {
      console.error('Token check error:', e);
    }
  }, 60 * 1000); // Check every minute

  return interval;
};

const checkTokenValidity = async () => {
  const token = sessionStorage.getItem('token');
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expTime = payload.exp * 1000;
    const currentTime = Date.now();

    // If token expires in less than 5 minutes, refresh it
    if (expTime - currentTime < 5 * 60 * 1000) {
      console.log('Token expiring soon, refreshing...');
      const refreshed = await refreshToken();
      return refreshed;
    }
    return true;
  } catch (error) {
    console.error('Token check error:', error);
    return false;
  }
};

// Updated fetchCurrentUser function
const fetchCurrentUser = async () => {
  console.log('👤 fetchCurrentUser called');
  try {
    setUserLoading(true);

    // Check and refresh token if needed
    await checkTokenValidity();

    const storedUser = sessionStorage.getItem('user');

    if (storedUser) {
      const user = JSON.parse(storedUser);
      const userDivision = sessionStorage.getItem('userDivision');
      const userDistrict = sessionStorage.getItem('userDistrict');
      const userUlb = sessionStorage.getItem('userUlb');
      const userRole = sessionStorage.getItem('userRole');
      const userRoleId = sessionStorage.getItem('userRoleId');
      const userEmail = sessionStorage.getItem('userEmail');
      const userUsername = sessionStorage.getItem('userUsername');
      const userRoleName = sessionStorage.getItem('userRoleName');

      user.division_id = userDivision || user.division_id || null;
      user.district_id = userDistrict || user.district_id || null;
      user.ulb_id = userUlb || user.ulb_id || null;
      user.role = userRole || user.role || null;
      user.role_id = userRoleId || user.role_id || null;
      user.email = userEmail || user.email || null;
      user.username = userUsername || user.username || user.name || null;
      user.role_name = userRoleName || user.role_name || user.role || null;

      setCurrentUser(user);
      setUserLoading(false);
      return;
    }

    const storedUserId = sessionStorage.getItem('userId');
    if (storedUserId) {
      const user = {
        id: storedUserId,
        role: sessionStorage.getItem('userRole') || 'user',
        role_id: sessionStorage.getItem('userRoleId') || null,
        role_name: sessionStorage.getItem('userRoleName') || sessionStorage.getItem('userRole') || 'user',
        name: sessionStorage.getItem('userName') || `User ${storedUserId}`,
        username: sessionStorage.getItem('userUsername') || sessionStorage.getItem('userName') || `User ${storedUserId}`,
        email: sessionStorage.getItem('userEmail') || null,
        division_id: sessionStorage.getItem('userDivision') || null,
        district_id: sessionStorage.getItem('userDistrict') || null,
        ulb_id: sessionStorage.getItem('userUlb') || null
      };
      setCurrentUser(user);
      setUserLoading(false);
      return;
    }

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_BASE = `${API_BASE_URL}/api`;
    const token = sessionStorage.getItem('token');

    const response = await fetch(`${API_BASE}/user-info`, {
      credentials: 'include',
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });

    if (response.ok) {
      const result = await response.json();
      const user = result.data || result.user || result;

      if (user.id) sessionStorage.setItem('userId', user.id);
      if (user.name) sessionStorage.setItem('userName', user.name);
      if (user.username) sessionStorage.setItem('userUsername', user.username);
      if (user.role) sessionStorage.setItem('userRole', user.role);
      if (user.role_id) sessionStorage.setItem('userRoleId', user.role_id);
      if (user.role_name) sessionStorage.setItem('userRoleName', user.role_name);
      if (user.email) sessionStorage.setItem('userEmail', user.email);
      if (user.division_id || user.division) {
        sessionStorage.setItem('userDivision', user.division_id || user.division);
      }
      if (user.district_id || user.district) {
        sessionStorage.setItem('userDistrict', user.district_id || user.district);
      }
      if (user.ulb_id || user.ulb) {
        sessionStorage.setItem('userUlb', user.ulb_id || user.ulb);
      }

      const enrichedUser = {
        ...user,
        role_id: user.role_id || null,
        role_name: user.role_name || user.role || null,
        username: user.username || user.name || null,
        email: user.email || null,
        division_id: user.division_id || user.division || null,
        district_id: user.district_id || user.district || null,
        ulb_id: user.ulb_id || user.ulb || null
      };

      setCurrentUser(enrichedUser);
    } else if (response.status === 401) {
      // Token expired, try to refresh
      const refreshed = await refreshToken();
      if (refreshed) {
        // Retry fetching user info
        const retryResponse = await fetch(`${API_BASE}/user-info`, {
          credentials: 'include',
          headers: { 'Authorization': `Bearer ${sessionStorage.getItem('token')}` }
        });

        if (retryResponse.ok) {
          const retryResult = await retryResponse.json();
          const retryUser = retryResult.data || retryResult.user || retryResult;
          // ... process user data similarly ...
          setCurrentUser(retryUser);
        } else {
          throw new Error('Unable to fetch user after token refresh');
        }
      } else {
        console.warn('⚠️ Session expired, redirecting to login');
        sessionStorage.clear();
        window.location.href = '/login';
        return;
      }
    } else {
      console.warn('⚠️ Failed to fetch user from API, using default');
      setCurrentUser({
        id: '1',
        name: 'User',
        username: 'user',
        role: 'user',
        role_id: null,
        role_name: 'user',
        email: null,
        division_id: null,
        district_id: null,
        ulb_id: null
      });
    }
  } catch (error) {
    console.error('❌ Error fetching user:', error);
    // Don't auto-redirect on error - show message instead
    message.error('Failed to load user information. Please refresh the page.');
    setCurrentUser({
      id: '1',
      name: 'User',
      username: 'user',
      role: 'user',
      role_id: null,
      role_name: 'user',
      email: null,
      division_id: null,
      district_id: null,
      ulb_id: null
    });
  } finally {
    setUserLoading(false);
  }
};


const checkFormulaLogicalErrors = () => {
    if (!currentForm || !currentForm.schema) return { hasError: false, errors: [] };
    
    const errors = [];
    
    const getValueForCheck = (fieldData) => {
        if (fieldData.isStepResultReference === true) {
            const sourceStepId = fieldData.sourceStepId;
            if (sourceStepId) {
                if (formData[`step_${sourceStepId}_result`] !== undefined) {
                    return parseFloat(formData[`step_${sourceStepId}_result`]) || 0;
                }
                if (formData[sourceStepId] !== undefined) {
                    return parseFloat(formData[sourceStepId]) || 0;
                }
                const formulaSteps = currentForm.schema
                    .flatMap(f => f.type === 'formula' ? f.formulaSteps || [] : [])
                    .filter(s => s.id === sourceStepId);
                if (formulaSteps.length > 0) {
                    return calculateStepResultForCheck(formulaSteps[0]);
                }
                return 0;
            }
            return 0;
        }
        
        if (fieldData.fieldType === 'constant') {
            return fieldData.constantValue !== undefined ? fieldData.constantValue : 0;
        }
        
        let lookupId = fieldData.id;
        if (fieldData.isExternalReference === true && fieldData.sourceFieldId) {
            lookupId = fieldData.sourceFieldId;
        }
        
        const value = formData[lookupId];
        if (value !== undefined && value !== null && value !== '') {
            const numVal = parseFloat(value);
            return isNaN(numVal) ? null : numVal;
        }
        
        const fallbackValue = formData[fieldData.id];
        if (fallbackValue !== undefined && fallbackValue !== null && fallbackValue !== '') {
            const numVal = parseFloat(fallbackValue);
            return isNaN(numVal) ? null : numVal;
        }
        
        return null;
    };
    
    // 🔥 UPDATED: Calculate step result with proper logical operator handling
    const calculateStepResultForCheck = (step) => {
        const fields = step.arithmeticFields || [];
        if (fields.length === 0) return 0;
        
        let result = 0;
        let isFirst = true;
        const operator = step.combineOperator || 'add';
        const isLogical = isLogicalOperator(operator);
        
        // Check if ANY field is empty
        let hasEmptyValue = false;
        for (const fieldData of fields) {
            const val = getValueForCheck(fieldData);
            if (val === null || val === undefined) {
                hasEmptyValue = true;
                break;
            }
        }
        
        if (hasEmptyValue) {
            return 0;
        }
        
        // All fields have values, calculate result
        for (const fieldData of fields) {
            let value = getValueForCheck(fieldData);
            
            if (value === null || value === undefined) {
                value = 0;
            }
            
            if (isFirst) {
                result = value;
                isFirst = false;
            } else {
                switch (operator) {
                    case 'add': result += value; break;
                    case 'subtract': result -= value; break;
                    case 'multiply': result *= value; break;
                    case 'divide': result = value !== 0 ? result / value : 0; break;
                    case 'equals': result = (result === value) ? 1 : 0; break;
                    case 'not_equals': result = (result !== value) ? 1 : 0; break;
                    case 'greater_than': result = (result > value) ? 1 : 0; break;
                    case 'less_than': result = (result < value) ? 1 : 0; break;
                    case 'greater_than_equal': result = (result >= value) ? 1 : 0; break;
                    case 'less_than_equal': result = (result <= value) ? 1 : 0; break;
                    default: result += value;
                }
            }
        }
        
        return result;
    };
    
    const findFormulaFields = (fields) => {
        let formulaFields = [];
        if (!fields) return formulaFields;
        
        fields.forEach(field => {
            if (field.type === 'formula') {
                formulaFields.push(field);
            }
            if (field.children) {
                if (Array.isArray(field.children)) {
                    formulaFields = [...formulaFields, ...findFormulaFields(field.children)];
                } else {
                    if (field.children.left) formulaFields = [...formulaFields, ...findFormulaFields([field.children.left])];
                    if (field.children.right) formulaFields = [...formulaFields, ...findFormulaFields([field.children.right])];
                }
            }
            if (field.subFields) {
                formulaFields = [...formulaFields, ...findFormulaFields(field.subFields)];
            }
            if (field.arithmeticFields) {
                formulaFields = [...formulaFields, ...findFormulaFields(field.arithmeticFields)];
            }
        });
        return formulaFields;
    };
    
    const rootFields = currentForm.schema.filter(f => !f.parentId);
    const formulaFields = findFormulaFields(rootFields);
    
    console.log('🔍 Found formula fields:', formulaFields.length);
    
    for (const formulaField of formulaFields) {
        const formulaSteps = formulaField.formulaSteps || [];
        const stepCombineOp = formulaField.stepCombineOperator || 'add';
        const finalFalseMessage = formulaField.finalFalseMessage || '';
        
        console.log(`📝 Checking formula: ${formulaField.enLabel || formulaField.id} (${formulaSteps.length} steps)`);
        
        for (const step of formulaSteps) {
            const stepIsLogical = isLogicalOperator(step.combineOperator);
            const stepFalseMessage = step.falseMessage || '';
            
            console.log(`  📝 Step: ${step.name || 'unnamed'}, isLogical: ${stepIsLogical}, falseMessage: "${stepFalseMessage}"`);
            
            if (stepIsLogical && stepFalseMessage) {
                // Check if any field is empty
                let hasEmptyField = false;
                if (step.arithmeticFields) {
                    for (const f of step.arithmeticFields) {
                        const val = getValueForCheck(f);
                        if (val === null || val === undefined) {
                            hasEmptyField = true;
                            console.log(`    ⚠️ Field ${f.id} is empty`);
                            break;
                        }
                    }
                }
                
                if (!hasEmptyField) {
                    const stepResult = calculateStepResultForCheck(step);
                    console.log(`    Step result: ${stepResult}`);
                    
                    // 🔥 CRITICAL FIX: For logical operators, result 0 means FALSE
                    if (stepResult === 0) {
                        console.log(`    ❌ Step failed, showing error: "${stepFalseMessage}"`);
                        errors.push({
                            fieldId: formulaField.id,
                            fieldLabel: getFieldLabel(formulaField),
                            stepName: step.name || 'Step',
                            message: stepFalseMessage,
                            type: 'step'
                        });
                    } else {
                        console.log(`    ✅ Step passed (result: ${stepResult})`);
                    }
                } else {
                    console.log(`    ⏭️ Skipping step error because fields are empty`);
                }
            }
        }
        
        // Check final result for logical combine
        const isLogicalCombine = ['equals', 'not_equals', 'greater_than', 'less_than', 
                                   'greater_than_equal', 'less_than_equal'].includes(stepCombineOp);
        
        if (isLogicalCombine && finalFalseMessage && formulaSteps.length > 0) {
            let hasEmptyField = false;
            for (const step of formulaSteps) {
                if (step.arithmeticFields) {
                    for (const f of step.arithmeticFields) {
                        const val = getValueForCheck(f);
                        if (val === null || val === undefined) {
                            hasEmptyField = true;
                            break;
                        }
                    }
                }
                if (hasEmptyField) break;
            }
            
            if (!hasEmptyField) {
                const stepResults = [];
                for (const step of formulaSteps) {
                    stepResults.push(calculateStepResultForCheck(step));
                }
                
                let finalResult = stepResults[0];
                for (let i = 1; i < stepResults.length; i++) {
                    switch (stepCombineOp) {
                        case 'add': finalResult += stepResults[i]; break;
                        case 'subtract': finalResult -= stepResults[i]; break;
                        case 'multiply': finalResult *= stepResults[i]; break;
                        case 'divide': finalResult = stepResults[i] !== 0 ? finalResult / stepResults[i] : 0; break;
                        case 'equals': finalResult = (finalResult === stepResults[i]) ? 1 : 0; break;
                        case 'not_equals': finalResult = (finalResult !== stepResults[i]) ? 1 : 0; break;
                        case 'greater_than': finalResult = (finalResult > stepResults[i]) ? 1 : 0; break;
                        case 'less_than': finalResult = (finalResult < stepResults[i]) ? 1 : 0; break;
                        case 'greater_than_equal': finalResult = (finalResult >= stepResults[i]) ? 1 : 0; break;
                        case 'less_than_equal': finalResult = (finalResult <= stepResults[i]) ? 1 : 0; break;
                        default: finalResult += stepResults[i];
                    }
                }
                
                if (finalResult === 0) {
                    errors.push({
                        fieldId: formulaField.id,
                        fieldLabel: getFieldLabel(formulaField),
                        stepName: 'Final Result',
                        message: finalFalseMessage,
                        type: 'final'
                    });
                }
            }
        }
    }
    
    console.log(`📊 Formula errors found: ${errors.length}`);
    if (errors.length > 0) {
        console.log('❌ Errors:', errors);
    }
    
    return { hasError: errors.length > 0, errors };
};
// Debug helper to log formula field values

// Add this useEffect in your component (after all other useEffects)
useEffect(() => {
  // Start session keep-alive
  const keepAliveInterval = setInterval(async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      clearInterval(keepAliveInterval);
      return;
    }

    await checkTokenValidity();
  }, 60 * 1000); // Check every minute

  // Add activity detection to keep session alive
  let activityTimeout;
  const resetActivityTimer = () => {
    if (activityTimeout) clearTimeout(activityTimeout);
    activityTimeout = setTimeout(async () => {
      console.log('User inactive for 25 minutes, refreshing token...');
      await refreshToken();
    }, 25 * 60 * 1000); // 25 minutes
  };

  const events = ['mousedown', 'keydown', 'touchstart', 'scroll', 'click', 'mousemove'];
  events.forEach(event => {
    window.addEventListener(event, resetActivityTimer);
  });
  resetActivityTimer();

  return () => {
    if (keepAliveInterval) clearInterval(keepAliveInterval);
    if (activityTimeout) clearTimeout(activityTimeout);
    events.forEach(event => {
      window.removeEventListener(event, resetActivityTimer);
    });
  };
}, []);

// Add fetchWithAuth helper function
const fetchWithAuth = async (url, options = {}) => {
  const token = sessionStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };

  try {
    let response = await fetch(url, { ...options, headers });

    // If unauthorized, try to refresh token once
    if (response.status === 401) {
      console.log('🔄 401 Unauthorized, attempting token refresh...');
      const refreshed = await refreshToken();
      if (refreshed) {
        const newToken = sessionStorage.getItem('token');
        headers.Authorization = `Bearer ${newToken}`;
        response = await fetch(url, { ...options, headers });
        console.log('✅ Retry successful after token refresh');
      } else {
        console.log('❌ Token refresh failed, redirecting to login');
        sessionStorage.clear();
        window.location.href = '/login';
        throw new Error('Session expired');
      }
    }

    return response;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};
    const fetchAllForms = async () => {
  console.log('📡 fetchAllForms called');
  setLoading(true);
  try {
    const response = await fetchWithAuth(`${API_BASE}/forms/active`);

    // Check if response is ok
    if (!response.ok) {
      // If response is not ok, handle based on status
      if (response.status === 401) {
        // Token refresh already handled by fetchWithAuth, just return
        console.log('⚠️ Session expired, redirecting to login');
        setLoading(false);
        return;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    let forms = result.data || [];

    console.log(`📋 Found ${forms.length} total forms from API`);
    console.log(`👤 Current User:`, {
      id: currentUser?.id,
      role_id: currentUser?.role_id,
      role_name: currentUser?.role_name,
      ulb_id: currentUser?.ulb_id
    });

    // Filter forms based on access control
    const accessibleForms = forms.filter(form => {
      const hasAccess = hasFormAccess(form, currentUser);
      if (!hasAccess) {
        console.log(`🚫 Filtering out form ${form.id} (${form.form_name}) - User ULB ${currentUser?.ulb_id} not in access_control`);
      } else {
        console.log(`✅ Allowing form ${form.id} (${form.form_name})`);
      }
      return hasAccess;
    });

    console.log(`📋 After access control filter: ${accessibleForms.length} forms accessible out of ${forms.length}`);

    const initialCheckingStatus = {};
    accessibleForms.forEach(form => {
      initialCheckingStatus[form.id] = true;
    });
    setCheckingSubmissions(initialCheckingStatus);

    // Process each form to get submission status
    const processedForms = await Promise.all(accessibleForms.map(async form => {
      let userSubmissionStatus = null;
      let isBlocked = false;
      let entryCount = 0;
      let maxEntries = form.max_entries_per_user || 0;

      console.log(`🔍 Processing form ${form.id}: ${form.form_name}, entry_type: ${form.entry_type}`);

      if (currentUser?.id) {
        if (form.entry_type === 'multi') {
          try {
            entryCount = await getUserEntryCount(form.id, currentUser.id);
            if (maxEntries > 0 && entryCount >= maxEntries) {
              userSubmissionStatus = 'limit_reached';
              isBlocked = true;
            } else {
              userSubmissionStatus = 'can_fill';
              isBlocked = false;
            }
          } catch (entryError) {
            console.error(`Error getting entry count for form ${form.id}:`, entryError);
            entryCount = 0;
            userSubmissionStatus = 'can_fill';
            isBlocked = false;
          }
        } else {
          try {
            const { isSubmitted } = await getUserSubmissionStatus(form.id, currentUser.id);

            const lastSubmissionVersion = sessionStorage.getItem(`form_${form.id}_submitted_at`);
            const formUpdatedAt = form.updated_at;
            const isFormUpdatedAfterSubmission = lastSubmissionVersion && new Date(formUpdatedAt) > new Date(lastSubmissionVersion);

            console.log(`📊 Form ${form.id} version check:`, {
              formUpdatedAt,
              lastSubmissionVersion,
              isFormUpdatedAfterSubmission
            });

            if (isSubmitted && isFormUpdatedAfterSubmission) {
              userSubmissionStatus = 'not_submitted';
              isBlocked = false;
              console.log(`🔄 Form ${form.id} was updated after submission, allowing re-fill`);
            } else if (isSubmitted) {
              userSubmissionStatus = 'not_submitted';
              isBlocked = false;
              console.log(`✅ Form ${form.id} is submitted but allowing fill (restriction removed)`);
            } else {
              userSubmissionStatus = 'not_submitted';
              isBlocked = false;
            }
          } catch (submissionError) {
            console.error(`Error checking submission status for form ${form.id}:`, submissionError);
            userSubmissionStatus = 'not_submitted';
            isBlocked = false;
          }
        }
      }

      const isActive = isFormActive(form);

      return {
        ...form,
        status: isActive ? 1 : 0,
        entryTypeDisplay: form.entry_type === 'multi' ? 'Multi Entry' : 'Single Entry',
        frequencyDisplay: form.frequency?.enabled ? form.frequency.type : null,
        isNew: isFormNew(form),
        userSubmissionStatus: userSubmissionStatus,
        isBlocked: isBlocked,
        entryCount: entryCount,
        maxEntries: maxEntries
      };
    }));

    // Set the states with processed forms
    setAllForms(processedForms);
    const active = processedForms.filter(form => form.status === 1);
    setActiveForms(active);

    console.log(`✅ Set ${processedForms.length} total forms, ${active.length} active forms`);

    setTimeout(() => {
      setCheckingSubmissions({});
    }, 100);

    setLastLoaded(Date.now());
    setLoading(false);

    if (currentUser?.id) {
      try {
        // await fetchFormsDeadlines();
      } catch (deadlineError) {
        console.error('Error fetching deadlines:', deadlineError);
      }
    }
    return;

  } catch (error) {
    console.error('❌ Error fetching forms:', error);

    // Don't show error message for session expiration (already handled)
    if (!error.message?.includes('Session expired')) {
      message.error(selectedLanguage === 'english'
        ? 'Failed to load forms. Please refresh the page.'
        : 'फॉर्म लोड करण्यात अयशस्वी. कृपया पृष्ठ रिफ्रेश करा.');
    }

    setCheckingSubmissions({});
    setLoading(false);
  }
};

    useEffect(() => {
        if (currentUser?.id) {
            fetchFormsDeadlines();
        }
    }, [currentUser, fetchFormsDeadlines]);

    useEffect(() => {
        const interval = setInterval(() => {
            fetchAllForms();
        }, 300000);

        return () => clearInterval(interval);
    }, []);

    const getDeadlineStatus = (deadline) => {
        if (!deadline) return null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const deadlineDate = new Date(deadline);
        deadlineDate.setHours(0, 0, 0, 0);

        const diffTime = deadlineDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 0) {
            return { status: 'expired', days: Math.abs(diffDays), class: 'deadline-today' };
        } else if (diffDays === 0) {
            return { status: 'today', days: 0, class: 'deadline-today' };
        } else if (diffDays === 1) {
            return { status: 'tomorrow', days: 1, class: 'deadline-tomorrow' };
        } else if (diffDays === 2) {
            return { status: '2days', days: 2, class: 'deadline-2days' };
        } else if (diffDays <= 5) {
            return { status: 'soon', days: diffDays, class: 'deadline-urgent' };
        }

        return null;
    };

    const renderSLACard = () => {
        if (!showSLAAlert && expiringForms.length === 0 && expiredForms.length === 0) return null;

        const totalIssues = expiringForms.length + expiredForms.length;
        const language = selectedLanguage;

        return (
            <div style={{
                margin: '16px 8px',
                padding: '12px',
                background: '#fff3e0',
                borderRadius: '12px',
                border: '2px solid #ff9800',
                boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '12px',
                    paddingBottom: '8px',
                    borderBottom: '1px solid #ffe0b2'
                }}>
                    <WarningOutlined style={{ fontSize: '24px', color: '#ff9800' }} />
                    <span style={{
                        fontWeight: 'bold',
                        fontSize: '16px',
                        color: '#e65100'
                    }}>
                        {language === 'english' ? '⚠️ SLA Alerts' : '⚠️ SLA सूचना'}
                    </span>
                    <Badge
                        count={totalIssues}
                        style={{
                            backgroundColor: '#ff9800',
                            marginLeft: 'auto'
                        }}
                    />
                </div>

                {loadingSLA && (
                    <div style={{ textAlign: 'center', padding: '10px' }}>
                        <Spin size="small" />
                        <span style={{ marginLeft: '8px', fontSize: '12px', color: '#666' }}>Loading...</span>
                    </div>
                )}

                {expiredForms.length > 0 && (
                    <div style={{ marginBottom: '12px' }}>
                        <div style={{
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#d32f2f',
                            marginBottom: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                        }}>
                            <ExclamationCircleOutlined />
                            {language === 'english' ? 'Expired Deadlines' : 'मुदत संपलेले'}
                        </div>
                        {expiredForms.map(form => {
                            return (
                                <div
                                    key={form.id}
                                    onClick={() => {
                                        if (form.form_id) {
                                            loadFormToFill(form.form_id);
                                        }
                                    }}
                                    style={{
                                        padding: '10px',
                                        marginBottom: '6px',
                                        background: '#ffebee',
                                        borderRadius: '8px',
                                        border: '1px solid #ffcdd2',
                                        cursor: form.form_id ? 'pointer' : 'default',
                                        transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => form.form_id && (e.currentTarget.style.background = '#ffcdd2')}
                                    onMouseLeave={(e) => form.form_id && (e.currentTarget.style.background = '#ffebee')}
                                >
                                    <div style={{
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        marginBottom: '4px'
                                    }}>
                                        {form.form_name || `Form #${form.form_id}`}
                                        {form.stage_name && (
                                            <Tag size="small" style={{ marginLeft: '4px', fontSize: '10px' }}>
                                                {form.stage_name}
                                            </Tag>
                                        )}
                                    </div>
                                    <div style={{
                                        fontSize: '11px',
                                        color: '#d32f2f',
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                        <span>
                                            <CalendarOutlined style={{ marginRight: '4px' }} />
                                            {language === 'english'
                                                ? `Deadline: ${new Date(form.expected_deadline).toLocaleDateString()}`
                                                : `अंतिम तारीख: ${new Date(form.expected_deadline).toLocaleDateString()}`}
                                        </span>
                                        <Tag color="red" style={{ fontSize: '10px' }}>
                                            {form.daysOverdue} {language === 'english' ? 'days overdue' : 'दिवस उशीर'}
                                        </Tag>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {expiringForms.length > 0 && (
                    <div>
                        <div style={{
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#f57c00',
                            marginBottom: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px'
                        }}>
                            <ClockCircleOutlined />
                            {language === 'english' ? 'Expiring Soon' : 'मुदत जवळ येत आहे'}
                        </div>
                        {expiringForms.map(form => {
                            const deadlineStatus = getDeadlineStatus(form.expected_deadline);

                            return (
                                <div
                                    key={form.id}
                                    onClick={() => {
                                        if (form.form_id) {
                                            loadFormToFill(form.form_id);
                                        }
                                    }}
                                    className={deadlineStatus?.class || ''}
                                    style={{
                                        padding: '10px',
                                        marginBottom: '6px',
                                        background: '#fff3e0',
                                        borderRadius: '8px',
                                        border: '1px solid #ffe0b2',
                                        cursor: form.form_id ? 'pointer' : 'default',
                                        transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => form.form_id && (e.currentTarget.style.background = '#ffe0b2')}
                                    onMouseLeave={(e) => form.form_id && (e.currentTarget.style.background = deadlineStatus?.class ? undefined : '#fff3e0')}
                                >
                                    <div style={{
                                        fontSize: '13px',
                                        fontWeight: '500',
                                        marginBottom: '4px'
                                    }}>
                                        {form.form_name || `Form #${form.form_id}`}
                                        {form.stage_name && (
                                            <Tag size="small" style={{ marginLeft: '4px', fontSize: '10px' }}>
                                                {form.stage_name}
                                            </Tag>
                                        )}
                                    </div>
                                    <div style={{
                                        fontSize: '11px',
                                        color: '#f57c00',
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                        <span>
                                            <CalendarOutlined style={{ marginRight: '4px' }} />
                                            {language === 'english'
                                                ? `Deadline: ${new Date(form.expected_deadline).toLocaleDateString()}`
                                                : `अंतिम तारीख: ${new Date(form.expected_deadline).toLocaleDateString()}`}
                                        </span>
                                        <Tag
                                            color={form.daysLeft === 0 ? 'red' : form.daysLeft === 1 ? 'orange' : 'green'}
                                            style={{ fontSize: '10px' }}
                                        >
                                            {form.daysLeft === 0
                                                ? (language === 'english' ? 'Today' : 'आज')
                                                : form.daysLeft === 1
                                                    ? (language === 'english' ? 'Tomorrow' : 'उद्या')
                                                    : `${form.daysLeft} ${language === 'english' ? 'days' : 'दिवस'}`}
                                        </Tag>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {(expiringForms.length > 0 || expiredForms.length > 0) && (
                    <div style={{
                        marginTop: '12px',
                        paddingTop: '8px',
                        borderTop: '1px solid #ffe0b2',
                        textAlign: 'center'
                    }}>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                Modal.info({
                                    title: language === 'english' ? 'All SLA Violations' : 'सर्व SLA उल्लंघने',
                                    width: 600,
                                    content: (
                                        <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '10px' }}>
                                            {slaViolations.map(violation => {
                                                const deadlineStatus = getDeadlineStatus(violation.expected_deadline);
                                                return (
                                                    <div key={violation.id} style={{
                                                        padding: '12px',
                                                        marginBottom: '8px',
                                                        background: '#f9f9f9',
                                                        borderRadius: '6px',
                                                        border: '1px solid #e8e8e8'
                                                    }}>
                                                        <div style={{ fontWeight: 'bold' }}>
                                                            {violation.form_name || `Form #${violation.form_id}`}
                                                        </div>
                                                        <div style={{ fontSize: '12px', marginTop: '4px' }}>
                                                            <div><strong>Stage:</strong> {violation.stage_name || `Stage ${violation.stage_index}`}</div>
                                                            <div><strong>Deadline:</strong> {new Date(violation.expected_deadline).toLocaleString()}</div>
                                                            {violation.actual_completion && (
                                                                <div><strong>Completed:</strong> {new Date(violation.actual_completion).toLocaleString()}</div>
                                                            )}
                                                            {violation.violated_at && (
                                                                <div><strong>Violated:</strong> {new Date(violation.violated_at).toLocaleString()}</div>
                                                            )}
                                                            {violation.escalation_triggered && (
                                                                <div><strong>Escalated to:</strong> {violation.escalation_to}</div>
                                                            )}
                                                            <div><strong>Status:</strong> {violation.status || 'pending'}</div>
                                                        </div>
                                                        {deadlineStatus && (
                                                            <Tag color={deadlineStatus.status === 'expired' ? 'red' : 'orange'} style={{ marginTop: '4px' }}>
                                                                {deadlineStatus.status === 'expired'
                                                                    ? `${deadlineStatus.days} days overdue`
                                                                    : `${deadlineStatus.days} days left`}
                                                            </Tag>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ),
                                    onOk() {},
                                });
                            }}
                            style={{ color: '#f57c00' }}
                        >
                            {language === 'english' ? 'View All Details' : 'सर्व तपशील पहा'}
                        </Button>
                    </div>
                )}
            </div>
        );
    };

const calculateProgress = useCallback(() => {
    if (!currentForm || !currentForm.schema) return 0;

    const userInputFields = [];

    const collectUserInputFields = (fields, parentValue = null) => {
        fields.forEach(field => {
            // Skip formula field itself - we need to check its children instead
// Inside calculateProgress, when checking formula fields
if (field.type === 'formula') {
    if (field.formulaSteps && Array.isArray(field.formulaSteps)) {
        field.formulaSteps.forEach(step => {
            if (step.arithmeticFields && Array.isArray(step.arithmeticFields)) {
                step.arithmeticFields.forEach(af => {
                    // 🔥 FIX: Don't skip required constant fields
                    let isConstant = af.fieldType === 'constant';
                    let isShared = af.isSharedReference === true;
                    
                    // Check if this field is required
                    const isRequired = af.enRequired === true || af.enRequired === 1 || 
                                      af.required === true || af.required === 1;
                    
                    // Only skip if it's constant AND NOT required
                    if ((isConstant && !isRequired) || isShared) {
                        return;
                    }
                    
                    userInputFields.push({
                        id: af.id,
                        type: af.type || 'number',
                        isAutoCalculated: false,
                        fieldData: af
                    });
                });
            }
        });
    }
    return;
}

            // Skip heading fields
            if (field.type === 'heading') {
                if (field.children && Array.isArray(field.children)) {
                    collectUserInputFields(field.children, parentValue);
                }
                return;
            }

            // Handle row fields
            if (field.type === 'row') {
                if (field.children) {
                    if (Array.isArray(field.children)) {
                        collectUserInputFields(field.children, parentValue);
                    } else {
                        if (field.children.left) collectUserInputFields(field.children.left, parentValue);
                        if (field.children.right) collectUserInputFields(field.children.right, parentValue);
                    }
                }
                return;
            }

            // Check if this field should be visible based on parent radio/checkbox
            if (field.parentId) {
                const parentField = currentForm.schema.find(f => f.id === field.parentId);
                if (parentField) {
                    if (parentField.type === 'radio') {
                        const selectedRadioValue = formData[parentField.id];
                        if (String(field.colName) !== String(selectedRadioValue)) {
                            return;
                        }
                    }
                    else if (parentField.type === 'checkbox') {
                        const selectedCheckboxValues = Array.isArray(formData[parentField.id]) ? formData[parentField.id] : [];
                        if (!selectedCheckboxValues.includes(field.colName)) {
                            return;
                        }
                    }
                }
            }

            // For comparison fields
            if (field.type === 'comparison') {
                if (field.mainField) {
                    userInputFields.push({
                        id: field.mainField.id,
                        type: field.mainField.type || 'number',
                        isAutoCalculated: false
                    });
                }
                if (field.subFields && Array.isArray(field.subFields)) {
                    field.subFields.forEach(sf => {
                        userInputFields.push({
                            id: sf.id,
                            type: sf.type || 'number',
                            isAutoCalculated: false
                        });
                    });
                }
                return;
            }

            // For arithmetic fields
            if (field.type === 'arithmetic') {
                if (field.arithmeticFields && Array.isArray(field.arithmeticFields)) {
                    field.arithmeticFields.forEach(af => {
                        let isConstant = af.fieldType === 'constant';
                        if (!isConstant && af.constantValue !== undefined && af.constantValue !== null) {
                            isConstant = true;
                        }

                        userInputFields.push({
                            id: af.id,
                            type: af.type || 'number',
                            isAutoCalculated: isConstant
                        });
                    });
                }
                return;
            }

            // Regular user input fields
            if (['text', 'number', 'date', 'checkbox', 'paragraph', 'file', 'image', 'dropdown', 'radio'].includes(field.type)) {
                let isConstantField = false;

                // Check if this field is used as a constant in any formula
                if (currentForm.schema) {
                    for (const schemaField of currentForm.schema) {
                        if (schemaField.type === 'formula' && schemaField.formulaSteps) {
                            for (const step of schemaField.formulaSteps) {
                                if (step.arithmeticFields) {
                                    for (const af of step.arithmeticFields) {
                                        if (af.id === field.id && (af.fieldType === 'constant' || af.constantValue !== undefined)) {
                                            isConstantField = true;
                                            break;
                                        }
                                    }
                                }
                                if (isConstantField) break;
                            }
                        }
                        if (isConstantField) break;
                    }
                }

                if (!isConstantField && (field.constantValue !== undefined || field.fieldType === 'constant')) {
                    isConstantField = true;
                }

                userInputFields.push({
                    id: field.id,
                    type: field.type,
                    isAutoCalculated: isConstantField
                });
            }

            // Recursively process children
            if (field.children && Array.isArray(field.children)) {
                collectUserInputFields(field.children, parentValue);
            }
        });
    };

    // Start collecting from root fields
    const rootFields = currentForm.schema.filter(f => !f.parentId);
    collectUserInputFields(rootFields);

    // Remove duplicates
    const uniqueFields = [];
    const seenIds = new Set();
    for (const field of userInputFields) {
        if (!seenIds.has(field.id)) {
            seenIds.add(field.id);
            uniqueFields.push(field);
        }
    }

    // Filter out auto-calculated fields
    const fillableFields = uniqueFields.filter(field => !field.isAutoCalculated);

    if (fillableFields.length === 0) return 0;

    let filledCount = 0;

    fillableFields.forEach(field => {
        const value = formData[field.id];

        let isFilled = false;

        if (field.type === 'checkbox') {
            if (value && Array.isArray(value) && value.length > 0) {
                isFilled = true;
            }
        }
        else if (field.type === 'file' || field.type === 'image') {
            if (value && Array.isArray(value) && value.length > 0) {
                isFilled = true;
            }
        }
        else if (field.type === 'dropdown') {
            if (value && value !== '' && value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    isFilled = value.length > 0;
                } else {
                    isFilled = true;
                }
            }
        }
        else if (field.type === 'number') {
            // 🔥 CRITICAL FIX: Check for number values (including 0)
            if (value !== undefined && value !== null && value !== '') {
                const numValue = parseFloat(value);
                if (!isNaN(numValue)) {
                    isFilled = true;
                }
            }
        }
        else if (field.type === 'radio') {
            if (value && value !== '' && value !== undefined && value !== null) {
                isFilled = true;
            }
        }
        else if (field.type === 'date') {
            if (value && value !== '' && value !== undefined && value !== null) {
                isFilled = true;
            }
        }
        else if (field.type === 'text' || field.type === 'paragraph') {
            if (value && value !== '' && value !== undefined && value !== null) {
                // Trim to check if it's not just whitespace
                if (typeof value === 'string' && value.trim() !== '') {
                    isFilled = true;
                } else if (typeof value !== 'string') {
                    isFilled = true;
                }
            }
        }
        else {
            if (value !== undefined && value !== null && value !== '') {
                isFilled = true;
            }
        }

        if (isFilled) {
            filledCount++;
        }
    });

    const percentage = Math.round((filledCount / fillableFields.length) * 100);

    console.log(`📊 PROGRESS: ${filledCount}/${fillableFields.length} = ${percentage}%`);
    console.log('📊 Fillable fields count:', fillableFields.length);
    console.log('📊 Filled count:', filledCount);
    
    // Log which fields are empty (for debugging)
    const emptyFields = fillableFields.filter(field => {
        const value = formData[field.id];
        if (field.type === 'checkbox') return !(value && Array.isArray(value) && value.length > 0);
        if (field.type === 'number') return !(value !== undefined && value !== null && value !== '' && !isNaN(parseFloat(value)));
        if (field.type === 'text') return !(value && typeof value === 'string' && value.trim() !== '');
        return !(value !== undefined && value !== null && value !== '');
    });

    if (emptyFields.length > 0) {
        console.log('📊 Empty fields:', emptyFields.map(f => `${f.id} (${f.type})`));
    }

    return percentage;
}, [currentForm, formData]);

    useEffect(() => {
        const newProgress = calculateProgress();
        setProgress(newProgress);
    }, [formData, calculateProgress]);

    const loadAllEntries = async (formId, userId) => {
        console.log('📋 loadAllEntries called for form:', formId, 'user:', userId);
        try {
            const response = await fetch(`${API_BASE}/form-submissions/${formId}/${userId}`);
            const result = await response.json();

            if (result.entries) {
                setEntries(result.entries);
            } else if (Array.isArray(result)) {
                setEntries(result);
            } else {
                setEntries([]);
            }
        } catch (error) {
            console.error('❌ Error loading entries:', error);
            setEntries([]);
        }
    };

const loadFormFieldsAfterFrequency = async (formId, frequencySelection) => {
  console.log('📅 Loading form fields after frequency selection:', frequencySelection);

  try {
    setLoading(true);
    const token = sessionStorage.getItem('token');

    let searchId = currentUser?.ulb_id || currentUser?.id;

    console.log('📡 Current User:', {
      id: currentUser?.id,
      ulb_id: currentUser?.ulb_id,
      name: currentUser?.name
    });
    console.log('📡 Using searchId:', searchId);

    const periodLabel = frequencySelection?.periodLabel;

    if (!periodLabel) {
      console.error('❌ No period_label provided!');
      message.error(selectedLanguage === 'english'
        ? 'Invalid period selected'
        : 'अवैध कालावधी निवडला');
      setLoading(false);
      return;
    }

    let url = `${API_BASE}/form-submissions/${formId}/${searchId}?period_label=${encodeURIComponent(periodLabel)}&ulb_id=${searchId}`;

    console.log('📡 Checking existing submission from:', url);

    let existingData = { data: {}, status: null, progress: 0 };

    try {
      const existingRes = await fetchWithAuth(url);
      const responseData = await existingRes.json();
      console.log('📡 API Response:', JSON.stringify(responseData, null, 2));

      if (responseData.data && Object.keys(responseData.data).length > 0) {
        existingData.data = responseData.data;
        existingData.status = responseData.status;
        existingData.progress = responseData.progress || 0;
        console.log('✅ Found existing data with keys:', Object.keys(responseData.data));
      } else {
        console.log('ℹ️ No existing data found');
        if (responseData.error) {
          console.error('❌ Backend error:', responseData.error);
        }
      }
    } catch (err) {
      console.error('Error fetching existing submission:', err);
    }

    const response = await fetchWithAuth(`${API_BASE}/forms/${formId}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.data) {
      setCurrentForm(result.data);

      let loadedData = {};
      const hasExistingData = existingData.data && Object.keys(existingData.data).length > 0;

      // ✅ FUNCTION TO LOAD CONSTANT VALUES FROM FORMULA FIELDS (for BOTH existing and new)
      const loadConstantValuesFromFormula = (fields, targetData) => {
        if (!fields || !Array.isArray(fields)) return;

        fields.forEach(field => {
          if (field.type === 'formula' && field.formulaSteps && Array.isArray(field.formulaSteps)) {
            field.formulaSteps.forEach(step => {
              if (step.arithmeticFields && Array.isArray(step.arithmeticFields)) {
                step.arithmeticFields.forEach(arithmeticField => {
                  // 🔥 CRITICAL: Always load constant value regardless of existing data
                  if (arithmeticField.fieldType === 'constant' && arithmeticField.constantValue !== undefined && arithmeticField.constantValue !== null) {
                    targetData[arithmeticField.id] = arithmeticField.constantValue;
                    console.log(`✅ Loaded constant value for ${arithmeticField.id}: ${arithmeticField.constantValue}`);
                  }
                  // Also check for defaultValue as fallback
                  else if (arithmeticField.defaultValue !== undefined && arithmeticField.defaultValue !== null && arithmeticField.defaultValue !== '') {
                    targetData[arithmeticField.id] = arithmeticField.defaultValue;
                    console.log(`✅ Loaded defaultValue for ${arithmeticField.id}: ${arithmeticField.defaultValue}`);
                  }
                });
              }
            });
          }

          // Handle nested children
          if (field.children) {
            if (Array.isArray(field.children)) {
              loadConstantValuesFromFormula(field.children, targetData);
            } else {
              if (field.children.left) loadConstantValuesFromFormula(field.children.left, targetData);
              if (field.children.right) loadConstantValuesFromFormula(field.children.right, targetData);
            }
          }
          if (field.subFields && Array.isArray(field.subFields)) {
            loadConstantValuesFromFormula(field.subFields, targetData);
          }
          if (field.arithmeticFields && Array.isArray(field.arithmeticFields)) {
            loadConstantValuesFromFormula(field.arithmeticFields, targetData);
          }
        });
      };

      if (hasExistingData) {
        console.log('✅ Existing submission found, loading data...');
        loadedData = { ...existingData.data };

        // Parse JSON strings for file fields
        Object.keys(loadedData).forEach(key => {
          if (typeof loadedData[key] === 'string') {
            if (loadedData[key].startsWith('[') || loadedData[key].startsWith('{')) {
              try {
                loadedData[key] = JSON.parse(loadedData[key]);
              } catch (e) {
                console.warn(`Failed to parse field ${key}:`, e);
              }
            }
          }
        });

        // 🔥🔥🔥 CRITICAL: ALWAYS load constant values from schema (even for existing data)
        // This ensures constant values are always present
        const schemaFields = result.data.schema || [];
        loadConstantValuesFromFormula(schemaFields, loadedData);

        console.log('📦 After loading constants into existing data:', Object.keys(loadedData).filter(k =>
          schemaFields.some(f => f.type === 'formula' &&
            f.formulaSteps?.some(s => s.arithmeticFields?.some(af => af.id === k))
          )
        ));

        // message.success(selectedLanguage === 'english'
        //   ? `Loading existing data for ${periodLabel}`
        //   : `${periodLabel} साठी विद्यमान डेटा लोड करत आहे`);
      } else {
        console.log('🆕 No existing submission found - Starting blank');
        loadedData = {};

        const schemaFields = result.data.schema || [];

        // Apply default values from schema (regular fields)
        schemaFields.forEach(field => {
          if (field.defaultValue !== undefined && field.defaultValue !== null && field.defaultValue !== '') {
            loadedData[field.id] = field.defaultValue;
          }

          if (field.type === 'radio' && field.defaultValue) {
            loadedData[field.id] = field.defaultValue;
          }

          if (field.type === 'checkbox' && field.defaultValue && Array.isArray(field.defaultValue)) {
            loadedData[field.id] = field.defaultValue;
          }

          if (field.type === 'arithmetic' && field.arithmeticFields) {
            field.arithmeticFields.forEach(af => {
              if (af.defaultValue !== undefined && af.defaultValue !== null && af.defaultValue !== '') {
                loadedData[af.id] = af.defaultValue;
              }
            });
          }

          if (field.type === 'comparison' && field.mainField) {
            if (field.mainField.defaultValue !== undefined && field.mainField.defaultValue !== null) {
              loadedData[field.mainField.id] = field.mainField.defaultValue;
            }
            if (field.subFields) {
              field.subFields.forEach(sf => {
                if (sf.defaultValue !== undefined && sf.defaultValue !== null) {
                  loadedData[sf.id] = sf.defaultValue;
                }
              });
            }
          }
        });

        // 🔥 Load constant values from formula fields
        loadConstantValuesFromFormula(schemaFields, loadedData);

        console.log('📦 Loaded constant values from formula:', Object.keys(loadedData).filter(key =>
          schemaFields.some(f => f.type === 'formula' &&
            f.formulaSteps?.some(s => s.arithmeticFields?.some(af => af.id === key))
          )
        ));

        // Auto-fill user data
        schemaFields.forEach(field => {
          if (loadedData[field.id]) return;

          const identifiers = [field.id, field.column_name, field.enLabel, field.label].join(' ').toLowerCase();
          let matchedValue = null;

          if (identifiers.includes('division')) matchedValue = currentUser.division_id;
          else if (identifiers.includes('district')) matchedValue = currentUser.district_id;
          else if (identifiers.includes('ulb')) matchedValue = currentUser.ulb_id;
          else if (identifiers.includes('user_id')) matchedValue = currentUser.id;
          else if (identifiers.includes('name')) matchedValue = currentUser.name;
          else if (identifiers.includes('email')) matchedValue = currentUser.email;

          if (matchedValue && matchedValue !== 'null' && matchedValue !== 'undefined') {
            loadedData[field.id] = matchedValue;
          }
        });
      }

      // Store frequency metadata in formData
      loadedData.selected_frequency_label = periodLabel;
      loadedData.selected_frequency_period = periodLabel;
      loadedData.selected_frequency_type = frequencySelection?.type || null;
      loadedData.frequency_selection_date = new Date().toISOString();

      console.log('📦 Setting formData with keys:', Object.keys(loadedData));

      setFormData(loadedData);

      // Initialize field units for number fields
      const initialFieldUnits = {};
      if (result.data.schema) {
        result.data.schema.forEach(field => {
          if (field.type === 'number') {
            if (field.units?.enabled && field.units?.selectedUnit) {
              initialFieldUnits[field.id] = field.units.selectedUnit;
            } else if (field.hasUnit && field.selectedUnit) {
              initialFieldUnits[field.id] = field.selectedUnit;
            } else if (field.units_category && field.units_category !== 'none') {
              initialFieldUnits[field.id] = field.units_category;
            }
          }
        });
      }
      setFieldUnits(initialFieldUnits);

      // 🔥🔥🔥 CRITICAL FIX: Check for 'approved' status - View mode
      const isApprovedSubmission = existingData.status === 'approved';
      const isSubmitted = existingData.status === 'submitted' || existingData.status === 'filled';
      const isDraft = existingData.status === 'draft';

      console.log(`📊 Status flags - isApproved: ${isApprovedSubmission}, isSubmitted: ${isSubmitted}, isDraft: ${isDraft}`);

      setIsFormBlocked(isApprovedSubmission || isSubmitted);
      setViewFilledMode(isApprovedSubmission || isSubmitted);
      setValidationErrors({});

      if (isApprovedSubmission) {
        // message.info(selectedLanguage === 'english'
        //   ? 'Viewing approved form (read-only mode)'
        //   : 'अप्रूव्ह केलेला फॉर्म पाहत आहे (फक्त-वाचन मोड)');
      } else if (isSubmitted) {
        // message.info(selectedLanguage === 'english'
        //   ? 'Viewing submitted form (read-only mode)'
        //   : 'सबमिट केलेला फॉर्म पाहत आहे (फक्त-वाचन मोड)');
      } else if (isDraft) {
        message.info(selectedLanguage === 'english'
          ? 'Editing saved draft'
          : 'जतन केलेला मसुदा संपादित करत आहे');
      }

      setViewMode("fill");
    } else {
      console.error('❌ No data in response:', result);
      message.error(selectedLanguage === 'english'
        ? 'Failed to load form data'
        : 'फॉर्म डेटा लोड करण्यात अयशस्वी');
    }
  } catch (error) {
    console.error("❌ Error loading form fields:", error);

    if (error.message === 'Session expired') {
      message.error(selectedLanguage === 'english'
        ? 'Session expired. Please login again.'
        : 'सत्र समाप्त झाले. कृपया पुन्हा लॉगिन करा.');
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    } else {
      message.error(selectedLanguage === 'english'
        ? `Failed to load form: ${error.message}`
        : `फॉर्म लोड करण्यात अयशस्वी: ${error.message}`);
    }
  } finally {
    setLoading(false);
  }
};
// Helper function to get schedule display text
const getScheduleDisplayText = (type, schedule, language) => {
  const time = schedule?.time || '09:00';
  const lang = language === 'english' ? 'en' : 'mr';

  if (type === 'custom') {
    return lang === 'en' ? `Custom - Scheduled at ${time}` : `सानुकूल - ${time} वाजता नियोजित`;
  }
  if (type === 'daily') {
    return lang === 'en' ? `Daily - at ${time}` : `दैनिक - ${time} वाजता`;
  }
  if (type === 'weekly') {
    return lang === 'en' ? `Weekly - at ${time}` : `साप्ताहिक - ${time} वाजता`;
  }
  if (type === 'monthly') {
    return lang === 'en' ? `Monthly - at ${time}` : `मासिक - ${time} वाजता`;
  }
  return lang === 'en' ? `Scheduled at ${time}` : `${time} वाजता नियोजित`;
};

const loadFormToFill = async (formId) => {
  console.log('🎯 loadFormToFill CALLED with formId:', formId);

  if (formId === 100 || formId === "100") {
    setViewMode("form100");
    return;
  }

  if (!currentUser || !currentUser.id) {
    message.error(selectedLanguage === 'english'
      ? 'Please login first to fill forms'
      : 'कृपया फॉर्म भरण्यासाठी प्रथम लॉगिन करा');
    return;
  }

  try {
    setLoading(true);

    console.log('📡 Fetching form schema from:', `${API_BASE}/forms/${formId}`);
    const response = await fetchWithAuth(`${API_BASE}/forms/${formId}`);

    if (!response.ok) {
      if (response.status === 401) {
        console.log('⚠️ Session expired, redirecting to login');
        setLoading(false);
        return;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result.data) {
      const formStatus = result.data.status;
      const isActive = formStatus === 1 || formStatus === true || formStatus === '1' || formStatus === 'true';

      if (!isActive) {
        message.error(selectedLanguage === 'english'
          ? 'This form is currently inactive and cannot be filled'
          : 'हा फॉर्म सध्या निष्क्रिय आहे आणि भरता येत नाही');
        setLoading(false);
        return;
      }

      // Extract frequency from database fields properly
      const frequencyEnabled = result.data.frequency_enabled === 1 ||
                               result.data.frequency_enabled === true ||
                               result.data.frequency_enabled === '1';

      let frequencyConfigObj = null;
      try {
        if (result.data.frequency_config && typeof result.data.frequency_config === 'string') {
          frequencyConfigObj = JSON.parse(result.data.frequency_config);
        } else if (result.data.frequency_config && typeof result.data.frequency_config === 'object') {
          frequencyConfigObj = result.data.frequency_config;
        } else if (result.data.frequency && typeof result.data.frequency === 'object') {
          frequencyConfigObj = result.data.frequency;
        }
      } catch (e) {
        console.error('Error parsing frequency_config:', e);
        frequencyConfigObj = null;
      }

      // Build frequency object for metadata
      const frequencyObj = {
        enabled: frequencyEnabled,
        type: frequencyConfigObj?.type || null,
        schedule: frequencyConfigObj?.schedule || null,
        custom: frequencyConfigObj?.custom || null
      };

      console.log('📅 Frequency check:', {
        frequencyEnabled,
        frequencyConfigObj,
        hasFrequency: frequencyEnabled && frequencyConfigObj?.schedule
      });

      setFormMetadata({
        is_existing_table: result.data.is_existing_table || false,
        linked_form_id: result.data.linked_form_id,
        columns_schema: result.data.columns_schema,
        status: result.data.status,
        entry_type: result.data.entry_type || 'single',
        frequency: frequencyObj,
        frequency_configs: result.data.frequency_configs || [],
        max_entries_per_user: result.data.max_entries_per_user || 0,
        formName: result.data.form_name
      });

      setCurrentForm(result.data);

      // Check if frequency is enabled AND has schedule
      const hasFrequency = frequencyEnabled === true &&
                          frequencyConfigObj !== null &&
                          frequencyConfigObj?.schedule !== null &&
                          Object.keys(frequencyConfigObj?.schedule || {}).length > 0;

      // If frequency is enabled, show the period selection modal
      if (hasFrequency) {
        console.log('📅 Frequency enabled with schedule, showing period selection modal');
        setPendingFormId(formId);
        setShowFrequencyModal(true);
        setLoading(false);
        return;
      }

      let searchId = currentUser.id;
      let queryParam = '';

      if (currentUser?.ulb_id && currentUser?.ulb_id !== 'null' && currentUser?.ulb_id !== 'undefined') {
        searchId = currentUser.ulb_id;
        queryParam = `?ulb_id=${encodeURIComponent(currentUser.ulb_id)}`;
      }

      const submissionsUrl = `${API_BASE}/form-submissions/${formId}/${searchId}${queryParam}`;

      console.log('📡 Checking existing submission from (non-frequency):', submissionsUrl);

      const draftRes = await fetchWithAuth(submissionsUrl);

      if (!draftRes.ok) {
        if (draftRes.status === 401) {
          console.log('⚠️ Session expired while checking submissions');
          setLoading(false);
          return;
        }
        throw new Error(`HTTP error! status: ${draftRes.status}`);
      }

      const draftResult = await draftRes.json();
      console.log('📡 Submission response received:', draftResult);
      console.log('📊 Submission status from backend:', draftResult?.status);

      let loadedData = {};
      let isExisting = false;

      // 🔥🔥🔥 CRITICAL FIX: Check for 'approved' status (not 'approve')
      const isApprovedSubmission = draftResult?.status === 'approved';
      const isSubmitted = draftResult?.status === 'submitted' || draftResult?.status === 'filled';
      const isDraft = draftResult?.status === 'draft';

      console.log(`📊 Status flags - isApproved: ${isApprovedSubmission}, isSubmitted: ${isSubmitted}, isDraft: ${isDraft}`);

      if (draftResult?.data && Object.keys(draftResult.data).length > 0) {
        console.log('✅ Existing submission found with keys:', Object.keys(draftResult.data));
        loadedData = { ...draftResult.data };
        isExisting = true;

        // Parse file fields
        Object.keys(loadedData).forEach(key => {
          if (typeof loadedData[key] === 'string' && loadedData[key].startsWith('[') && loadedData[key].includes('fileId')) {
            try {
              loadedData[key] = JSON.parse(loadedData[key]);
            } catch (e) {
              console.warn(`Failed to parse file data for key ${key}:`, e);
            }
          }
        });
      } else {
        console.log('ℹ️ No existing submission found, starting fresh');
      }

      // Auto-fill only for new forms (not existing submissions)
      if (!isExisting) {
        const schemaFields = result.data.schema || [];

        // Default values from schema
        schemaFields.forEach(field => {
          if (loadedData[field.id] !== undefined && loadedData[field.id] !== null && loadedData[field.id] !== '') {
            return;
          }

          let defaultValue = field.defaultValue || field.importedExistingValue;
          if (defaultValue && defaultValue !== null && defaultValue !== '') {
            if (typeof defaultValue === 'string' && (defaultValue.startsWith('[') || defaultValue.startsWith('{'))) {
              try {
                defaultValue = JSON.parse(defaultValue);
              } catch(e) {
                console.warn(`Failed to parse default value for field ${field.id}:`, e);
              }
            }
            loadedData[field.id] = defaultValue;
          }
        });

        // User data auto-fill (only for new forms)
        schemaFields.forEach(field => {
          if (loadedData[field.id]) return;

          const identifiers = [field.id, field.column_name, field.enLabel, field.label].join(' ').toLowerCase();
          let matchedValue = null;

          if (identifiers.includes('division')) matchedValue = currentUser.division_id;
          else if (identifiers.includes('district')) matchedValue = currentUser.district_id;
          else if (identifiers.includes('ulb')) matchedValue = currentUser.ulb_id;
          else if (identifiers.includes('user_id')) matchedValue = currentUser.id;
          else if (identifiers.includes('name')) matchedValue = currentUser.name;
          else if (identifiers.includes('email')) matchedValue = currentUser.email;

          if (matchedValue && matchedValue !== 'null' && matchedValue !== 'undefined') {
            loadedData[field.id] = matchedValue;
          }
        });
      }

      // Initialize field units
      const initialFieldUnits = {};
      if (result.data.schema) {
        result.data.schema.forEach(field => {
          if (field.type === 'number') {
            if (field.units?.enabled && field.units?.selectedUnit) {
              initialFieldUnits[field.id] = field.units.selectedUnit;
            } else if (field.hasUnit && field.selectedUnit) {
              initialFieldUnits[field.id] = field.selectedUnit;
            } else if (field.units_category && field.units_category !== 'none') {
              initialFieldUnits[field.id] = field.units_category;
            }
          }
        });
      }
      setFieldUnits(initialFieldUnits);

      setFormData(loadedData);

      // 🔥🔥🔥 CRITICAL: Set mode based on submission status
      // If status is 'approved' - view only mode (no editing, no submitting)
      if (isApprovedSubmission) {
        setIsFormBlocked(true);      // Block all editing
        setViewFilledMode(true);     // Enable view-only mode
        setConfirmSubmit(false);     // Disable submit button
        message.info(selectedLanguage === 'english'
          ? 'Viewing approved form (read-only mode)'
          : 'अप्रूव्ह केलेला फॉर्म पाहत आहे (फक्त-वाचन मोड)');
      }
      else if (isSubmitted) {
        setIsFormBlocked(true);
        setViewFilledMode(true);
        setConfirmSubmit(false);
        message.info(selectedLanguage === 'english'
          ? 'Viewing submitted form (read-only mode)'
          : 'सबमिट केलेला फॉर्म पाहत आहे (फक्त-वाचन मोड)');
      }
      else if (isDraft) {
        setIsFormBlocked(false);
        setViewFilledMode(false);
        setConfirmSubmit(false);
        message.info(selectedLanguage === 'english'
          ? 'Editing saved draft'
          : 'जतन केलेला मसुदा संपादित करत आहे');
      }
      else {
        // Brand new form - can edit and submit
        setIsFormBlocked(false);
        setViewFilledMode(false);
        setConfirmSubmit(false);
      }

      console.log(`📊 Final mode settings - isFormBlocked: ${isFormBlocked}, viewFilledMode: ${viewFilledMode}`);

      setViewMode("fill");
    } else {
      console.error('❌ No data in response:', result);
      message.error(selectedLanguage === 'english'
        ? 'Failed to load form data'
        : 'फॉर्म डेटा लोड करण्यात अयशस्वी');
    }
  } catch (error) {
    console.error("❌ Error loading form:", error);

    if (!error.message?.includes('Session expired') && error.message !== 'Session expired') {
      message.error(selectedLanguage === 'english'
        ? "Failed to load form: " + error.message
        : "फॉर्म लोड करण्यात अयशस्वी: " + error.message);
    }
  } finally {
    setLoading(false);
  }
};
    const loadEntry = async (entryId) => {
        console.log('📋 loadEntry called for entry:', entryId);
        if (!currentForm || !currentUser) return;

        try {
            setLoading(true);
            setIsFormBlocked(false);
            setViewFilledMode(false);
            const token = sessionStorage.getItem('token');
            const response = await fetch(`${API_BASE}/form-submissions/${currentForm.id}/${currentUser.id}?entryId=${entryId}`, {
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });
            const result = await response.json();

            if (result.data) {
                const parsedData = { ...result.data };
                Object.keys(parsedData).forEach(key => {
                    if (typeof parsedData[key] === 'string' && parsedData[key].startsWith('[') && parsedData[key].includes('fileId')) {
                        try {
                            parsedData[key] = JSON.parse(parsedData[key]);
                        } catch (e) {}
                    }
                });

                setFormData(parsedData);
                setCurrentEntryId(entryId);
                setShowEntrySelector(false);
                setViewMode("fill");
            } else {
                message.error('Failed to load entry');
            }
        } catch (error) {
            console.error('❌ Error loading entry:', error);
            message.error('Failed to load entry');
        } finally {
            setLoading(false);
        }
    };

    const createNewEntry = () => {
        console.log('📋 Creating new entry');
        setFormData({});
        setCurrentEntryId(null);
        setIsFormBlocked(false);
        setViewFilledMode(false);
        setShowEntrySelector(false);
        setViewMode("fill");
    };

    const getFieldLabel = (field) => {
        if (!field) return '';

        if (selectedLanguage === 'english') {
            return field.enLabel || field.englishLabel || field.label || '';
        } else {
            return field.mrLabel || field.marathiLabel || field.enLabel || field.englishLabel || field.label || '';
        }
    };

    const getPlaceholder = (field) => {
        if (!field) return '';

        if (selectedLanguage === 'english') {
            return field.enPlaceholder || field.englishPlaceholder || field.placeholder || '';
        } else {
            return field.mrPlaceholder || field.marathiPlaceholder || field.enPlaceholder || field.englishPlaceholder || field.placeholder || '';
        }
    };

    const getOptions = (field) => {
        if (!field) return [];

        if (selectedLanguage === 'english') {
            return field.enOptions || field.englishOptions || field.options || [];
        } else {
            return field.mrOptions || field.marathiOptions || field.enOptions || field.englishOptions || field.options || [];
        }
    };

    const isRequired = (field) => {
        if (!field) return false;

        if (selectedLanguage === 'english') {
            return field.enRequired || field.englishRequired || field.required || false;
        } else {
            return field.mrRequired || field.marathiRequired || field.enRequired || field.englishRequired || field.required || false;
        }
    };

const handleFieldChange = (fieldId, value) => {
    if (isFormBlocked || viewFilledMode) {
        return;
    }

    const field = currentForm?.schema?.find(f => f.id === fieldId);

    let processedValue = value;
    if (field?.validation?.trimInput) {
        if (typeof value === 'string') {
            processedValue = value.trim();
        }
    }

    setFormData(prev => {
        const newData = { ...prev, [fieldId]: processedValue };
        // Progress will automatically recalculate due to the useEffect
        return newData;
    });

    setValidationErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldId];
        return newErrors;
    });
};

    const handleUnitChange = (fieldId, unit) => {
        if (isFormBlocked || viewFilledMode) return;
        setFieldUnits(prev => ({
            ...prev,
            [fieldId]: unit
        }));
    };

const calculateComparisonResult = (subFields, data) => {
    if (!subFields || subFields.length === 0) return 0;

    // 🔥 FIX: Parse as float but handle decimal properly
    let result = parseFloat(data[subFields[0]?.id]) || 0;

    for (let i = 1; i < subFields.length; i++) {
        const subField = subFields[i];
        const value = parseFloat(data[subField?.id]) || 0;
        const operator = subField.arithmeticOperator || "add";

        switch (operator) {
            case "add": result += value; break;
            case "subtract": result -= value; break;
            case "multiply": result *= value; break;
            case "divide": if (value !== 0) result /= value; break;
            default: result += value;
        }
    }

    // Return with 2 decimal places for display
    return parseFloat(result.toFixed(2));
};

    const calculateArithmeticResult = (fields, data, operator) => {
        if (!fields || fields.length === 0) return 0;

        const numbers = fields.map(f => parseFloat(data[f.id]) || 0);

        switch (operator) {
            case "add":
                return numbers.reduce((a, b) => a + b, 0);
            case "subtract":
                return numbers.reduce((a, b) => a - b);
            case "multiply":
                return numbers.reduce((a, b) => a * b, 1);
            case "divide":
                return numbers.reduce((a, b) => a / b);
            case "average":
                return numbers.reduce((a, b) => a + b, 0) / numbers.length;
            default:
                return numbers.reduce((a, b) => a + b, 0);
        }
    };

    const checkComparison = (mainValue, calculatedValue, operator) => {
        const main = parseFloat(mainValue) || 0;
        const calculated = parseFloat(calculatedValue) || 0;

        switch (operator) {
            case "equals": return main === calculated;
            case "not_equals": return main !== calculated;
            case "greater_than": return main > calculated;
            case "less_than": return main < calculated;
            case "greater_than_equal": return main >= calculated;
            case "less_than_equal": return main <= calculated;
            default: return main === calculated;
        }
    };

    const validateDateComparison = (field, value) => {
        if (!field.enableDateComparison || !value) return { valid: true };

        const selectedDate = value;

        if (field.comparisonOperator === 'current_date') {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const todayStr = today.toISOString().split('T')[0];
            const isValid = selectedDate === todayStr;

            if (!isValid) {
                return {
                    valid: false,
                    message: field.customValidationMessage || (selectedLanguage === 'english'
                        ? `Date must be today's date (${todayStr})`
                        : `तारीख आजची (${todayStr}) असणे आवश्यक आहे`)
                };
            }
            return { valid: true };
        }

        if (field.comparisonType === 'single' && field.compareWithDate) {
            const isValid = compareDates(selectedDate, field.compareWithDate, field.comparisonOperator);
            if (!isValid) {
                const operatorLabel = DATE_COMPARISON_OPERATORS.find(op => op.value === field.comparisonOperator)?.label || field.comparisonOperator;
                return {
                    valid: false,
                    message: field.customValidationMessage || (selectedLanguage === 'english'
                        ? `Date must be ${operatorLabel} ${field.compareWithDate}`
                        : `तारीख ${operatorLabel} ${field.compareWithDate} असणे आवश्यक आहे`)
                };
            }
        }

        else if (field.comparisonType === 'range' && field.startDate && field.endDate) {
            const isValid = isDateInRange(selectedDate, field.startDate, field.endDate);
            if (!isValid) {
                return {
                    valid: false,
                    message: field.customValidationMessage || (selectedLanguage === 'english'
                        ? `Date must be between ${field.startDate} and ${field.endDate}`
                        : `तारीख ${field.startDate} आणि ${field.endDate} दरम्यान असणे आवश्यक आहे`)
                };
            }
        }

        else if (field.comparisonType === 'field' && field.compareWithFieldId) {
            const compareDate = formData[field.compareWithFieldId];
            if (compareDate) {
                const isValid = compareDates(selectedDate, compareDate, field.comparisonOperator);
                if (!isValid) {
                    const operatorLabel = DATE_COMPARISON_OPERATORS.find(op => op.value === field.comparisonOperator)?.label || field.comparisonOperator;
                    return {
                        valid: false,
                        message: field.customValidationMessage || (selectedLanguage === 'english'
                            ? `Date must be ${operatorLabel} the compared date`
                            : `तारीख तुलना केलेल्या तारखेपेक्षा ${operatorLabel} असणे आवश्यक आहे`)
                    };
                }
            }
        }

        return { valid: true };
    };

    const validateFieldValue = (field, value) => {
        if (!field) return { valid: true };
        if (viewFilledMode) return { valid: true };

        const validation = field.validation || {};
        const isRequiredField = field.enRequired || field.required || false;

        if (!isRequiredField && (value === undefined || value === null || value === '')) {
            return { valid: true };
        }

        if (isRequiredField && (value === undefined || value === null || value === '')) {
            return {
                valid: false,
                message: selectedLanguage === 'english'
                    ? 'This field is required'
                    : 'हे फील्ड आवश्यक आहे'
            };
        }

        const stringValue = String(value || '');

        if (validation.exactLength) {
            let lengthToCheck;
            if (field.type === 'number') {
                lengthToCheck = stringValue.replace('-', '').replace('.', '').length;
            } else {
                lengthToCheck = stringValue.length;
            }

            if (lengthToCheck > validation.exactLength) {
                return {
                    valid: false,
                    message: selectedLanguage === 'english'
                        ? `Maximum ${validation.exactLength} ${field.type === 'number' ? 'digits' : 'characters'} allowed`
                        : `कमाल ${validation.exactLength} ${field.type === 'number' ? 'अंक' : 'अक्षरे'} परवानगी आहेत`
                };
            }
        }

        if (validation.patternType && validation.patternType !== 'none') {
            let pattern;
            let errorMsg;

            switch (validation.patternType) {
                case 'letters_only':
                    pattern = /^[A-Za-z]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Only letters are allowed' : 'फक्त अक्षरे परवानगी आहेत';
                    if (!pattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'letters_spaces':
                    pattern = /^[A-Za-z\s]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Only letters and spaces are allowed' : 'फक्त अक्षरे आणि स्पेस परवानगी आहेत';
                    if (!pattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'alphanumeric':
                    pattern = /^[A-Za-z0-9]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Only letters and numbers are allowed' : 'फक्त अक्षरे आणि संख्या परवानगी आहेत';
                    if (!pattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'alphanumeric_spaces':
                    pattern = /^[A-Za-z0-9\s]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Only letters, numbers and spaces are allowed' : 'फक्त अक्षरे, संख्या आणि स्पेस परवानगी आहेत';
                    if (!pattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'numbers_only':
                    pattern = /^[0-9]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Only numbers are allowed' : 'फक्त संख्या परवानगी आहेत';
                    if (!pattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'email':
                    pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Invalid email format' : 'अवैध ईमेल स्वरूप';
                    if (!pattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'phone':
                    pattern = /^[0-9+\-\s()]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Invalid phone number format' : 'अवैध फोन नंबर स्वरूप';
                    if (!pattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'url':
                    try {
                        new URL(stringValue);
                    } catch (e) {
                        return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? 'Invalid URL format' : 'अवैध URL स्वरूप') };
                    }
                    break;
                case 'ip_address':
                    const ipPattern = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                    if (!ipPattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? 'Invalid IP address' : 'अवैध IP पत्ता') };
                    }
                    break;
                case 'credit_card':
                    const ccPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
                    if (!ccPattern.test(stringValue.replace(/\s/g, ''))) {
                        return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? 'Invalid credit card number' : 'अवैध क्रेडिट कार्ड क्रमांक') };
                    }
                    break;
                case 'custom':
                    if (validation.customPattern) {
                        try {
                            const flags = validation.regexFlags || 'g';
                            const regex = new RegExp(validation.customPattern, flags);
                            if (!regex.test(stringValue)) {
                                return { valid: false, message: validation.patternErrorMessage || (selectedLanguage === 'english' ? 'Invalid format' : 'अवैध स्वरूप') };
                            }
                        } catch (e) {}
                    }
                    break;
            }
        }

        if (validation.allowSpaces === false && stringValue.includes(' ')) {
            return { valid: false, message: selectedLanguage === 'english' ? 'Spaces are not allowed' : 'स्पेस परवानगी नाहीत' };
        }
        if (validation.allowLeadingSpaces === false && stringValue.startsWith(' ')) {
            return { valid: false, message: selectedLanguage === 'english' ? 'Leading spaces are not allowed' : 'सुरुवातीला स्पेस परवानगी नाहीत' };
        }
        if (validation.allowTrailingSpaces === false && stringValue.endsWith(' ')) {
            return { valid: false, message: selectedLanguage === 'english' ? 'Trailing spaces are not allowed' : 'शेवटी स्पेस परवानगी नाहीत' };
        }
        if (validation.allowMultipleSpaces === false && /\s{2,}/.test(stringValue)) {
            return { valid: false, message: selectedLanguage === 'english' ? 'Multiple consecutive spaces are not allowed' : 'एकापेक्षा जास्त स्पेस परवानगी नाहीत' };
        }

        if (validation.allowedCharacters && validation.allowedCharacters !== 'any') {
            let allowedPattern;
            let errorMsg;

            switch (validation.allowedCharacters) {
                case 'letters_only':
                    allowedPattern = /^[A-Za-z]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Only letters are allowed' : 'फक्त अक्षरे परवानगी आहेत';
                    if (!allowedPattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'numbers_only':
                    allowedPattern = /^[0-9]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Only numbers are allowed' : 'फक्त संख्या परवानगी आहेत';
                    if (!allowedPattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'alphanumeric':
                    allowedPattern = /^[A-Za-z0-9]+$/;
                    errorMsg = selectedLanguage === 'english' ? 'Only letters and numbers are allowed' : 'फक्त अक्षरे आणि संख्या परवानगी आहेत';
                    if (!allowedPattern.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || errorMsg };
                    }
                    break;
                case 'custom':
                    if (validation.customAllowedChars) {
                        const allowedSet = new Set(validation.customAllowedChars.split(''));
                        for (let char of stringValue) {
                            if (!allowedSet.has(char)) {
                                return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? `Character '${char}' is not allowed` : `'${char}' अक्षर परवानगी नाही`) };
                            }
                        }
                    }
                    break;
            }
        }

        if (validation.disallowedCharacters) {
            const disallowedSet = new Set(validation.disallowedCharacters.split(''));
            for (let char of stringValue) {
                if (disallowedSet.has(char)) {
                    return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? `Character '${char}' is not allowed` : `'${char}' अक्षर परवानगी नाही`) };
                }
            }
        }

        if (validation.uppercase && stringValue !== stringValue.toUpperCase()) {
            return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? 'Only uppercase letters are allowed' : 'फक्त मोठी अक्षरे परवानगी आहेत') };
        }
        if (validation.lowercase && stringValue !== stringValue.toLowerCase()) {
            return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? 'Only lowercase letters are allowed' : 'फक्त लहान अक्षरे परवानगी आहेत') };
        }

        if (validation.languageScript && validation.languageScript !== 'any') {
            const devanagariRegex = /[\u0900-\u097F]/;
            const latinRegex = /[A-Za-z]/;

            switch (validation.languageScript) {
                case 'english_only':
                    if (devanagariRegex.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? 'Only English characters are allowed' : 'फक्त इंग्रजी अक्षरे परवानगी आहेत') };
                    }
                    break;
                case 'marathi_only':
                    if (!devanagariRegex.test(stringValue) || latinRegex.test(stringValue)) {
                        return { valid: false, message: validation.customErrorMessage || (selectedLanguage === 'english' ? 'Only Marathi characters are allowed' : 'फक्त मराठी अक्षरे परवानगी आहेत') };
                    }
                    break;
                case 'english_marathi':
                    break;
            }
        }

        if (field.type === 'date' && value) {
            const dateValue = new Date(value);
            if (isNaN(dateValue.getTime())) {
                return { valid: false, message: selectedLanguage === 'english' ? 'Invalid date' : 'अवैध तारीख' };
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (validation.futureDates && dateValue < today) {
                return { valid: false, message: selectedLanguage === 'english' ? 'Future dates only' : 'फक्त भविष्यातील तारखा' };
            }
            if (validation.pastDates && dateValue > today) {
                return { valid: false, message: selectedLanguage === 'english' ? 'Past dates only' : 'फक्त भूतकाळातील तारखा' };
            }
            if (validation.todayOnly && dateValue.toDateString() !== today.toDateString()) {
                return { valid: false, message: selectedLanguage === 'english' ? 'Today\'s date only' : 'फक्त आजची तारीख' };
            }

            const comparisonResult = validateDateComparison(field, value);
            if (!comparisonResult.valid) {
                return comparisonResult;
            }
        }

if (field.type === 'number' && value !== undefined && value !== null && value !== '') {
    // 🔥 Convert to number for validation, but keep original string for storage
    const numValue = parseFloat(value);
    
    if (isNaN(numValue) && value !== '') {
        return { valid: false, message: selectedLanguage === 'english' ? 'Invalid number' : 'अवैध संख्या' };
    }
    
    // Skip validation for empty string
    if (value === '') return { valid: true };
    
    if (validation.decimalPlaces !== null && validation.decimalPlaces !== undefined) {
        const decimalStr = value.toString().split('.')[1];
        if (decimalStr && decimalStr.length > validation.decimalPlaces) {
            return { valid: false, message: selectedLanguage === 'english' ? `Maximum ${validation.decimalPlaces} decimal places allowed` : `कमाल ${validation.decimalPlaces} दशांश स्थळे परवानगी आहेत` };
        }
    }
    
    if (validation.allowNegative === false && numValue < 0) {
        return { valid: false, message: selectedLanguage === 'english' ? 'Negative numbers are not allowed' : 'ऋण संख्या परवानगी नाहीत' };
    }
    
    if (validation.allowZero === false && numValue === 0) {
        return { valid: false, message: selectedLanguage === 'english' ? 'Zero is not allowed' : 'शून्य परवानगी नाही' };
    }
    
    if (validation.integerOnly && !Number.isInteger(numValue)) {
        return { valid: false, message: selectedLanguage === 'english' ? 'Integer only (no decimals)' : 'फक्त पूर्णांक (दशांश नको)' };
    }
}

        if (validation.validationFunction) {
            try {
                const customValidation = new Function('value', validation.validationFunction);
                const result = customValidation(value);
                if (result !== true) {
                    return { valid: false, message: result || validation.customErrorMessage || (selectedLanguage === 'english' ? 'Custom validation failed' : 'सानुकूल वैधता अयशस्वी') };
                }
            } catch (e) {}
        }

        return { valid: true };
    };

const validateForm = () => {
    const errors = {};

    if (viewFilledMode) return true;
    if (!currentForm || !currentForm.schema) return true;

    // 🔥 FIRST: Check formula logical errors
    const formulaCheck = checkFormulaLogicalErrors();
    if (formulaCheck.hasError) {
        formulaCheck.errors.forEach(err => {
            errors[`formula_${err.fieldId}`] = err.message;
        });
        // Show first error message to user
        message.error(formulaCheck.errors[0].message);
        setValidationErrors(errors);
        return false;
    }

    // Rest of your existing validation code continues here...
    // (Helper function to get operator symbol and the rest of validateForm)
    
    const getOperatorSymbolForError = (operator) => {
        const symbols = {
            "equals": "=",
            "not_equals": "≠",
            "greater_than": ">",
            "less_than": "<",
            "greater_than_equal": "≥",
            "less_than_equal": "≤"
        };
        return symbols[operator] || "=";
    };

    const validateField = (field) => {
        if (!field) return;
        if (field.parentId) return;

        const value = formData[field.id];
        const result = validateFieldValue(field, value);

        if (!result.valid) {
            errors[field.id] = result.message;
        }

        // 🔥🔥🔥 ADD THIS: Validate comparison logic (Main Value vs Calculated Value)
        if (field.type === 'comparison') {
            const mainField = field.mainField;
            const subFields = field.subFields || [];
            const operator = field.comparisonOperator || 'equals';
            
            if (mainField && mainField.id) {
                const mainValue = formData[mainField.id];
                const mainValueExists = mainValue !== undefined && mainValue !== null && mainValue !== '';
                
                // Calculate result from subfields
                let calculatedValue = 0;
                if (subFields.length > 0) {
                    let result = parseFloat(formData[subFields[0]?.id]) || 0;
                    for (let i = 1; i < subFields.length; i++) {
                        const subField = subFields[i];
                        const subValue = parseFloat(formData[subField?.id]) || 0;
                        const subOperator = subField.arithmeticOperator || "add";
                        
                        switch (subOperator) {
                            case "add": result += subValue; break;
                            case "subtract": result -= subValue; break;
                            case "multiply": result *= subValue; break;
                            case "divide": if (subValue !== 0) result /= subValue; break;
                            default: result += subValue;
                        }
                    }
                    calculatedValue = result;
                }
                
                // Check comparison only if main value exists
                if (mainValueExists) {
                    const mainNum = parseFloat(mainValue) || 0;
                    let isComparisonValid = false;
                    
                    switch (operator) {
                        case "equals": isComparisonValid = mainNum === calculatedValue; break;
                        case "not_equals": isComparisonValid = mainNum !== calculatedValue; break;
                        case "greater_than": isComparisonValid = mainNum > calculatedValue; break;
                        case "less_than": isComparisonValid = mainNum < calculatedValue; break;
                        case "greater_than_equal": isComparisonValid = mainNum >= calculatedValue; break;
                        case "less_than_equal": isComparisonValid = mainNum <= calculatedValue; break;
                        default: isComparisonValid = mainNum === calculatedValue;
                    }
                    
                    if (!isComparisonValid) {
                        const operatorSymbol = getOperatorSymbolForError(operator);
                        const customMsg = field.customValidationMessage;
                        
                        if (customMsg) {
                            errors[field.id] = customMsg;
                        } else {
                            errors[field.id] = selectedLanguage === 'english'
                                ? `❌ Comparison failed: ${mainValue} ${operatorSymbol} ${calculatedValue.toFixed(2)} is false`
                                : `❌ तुलना अयशस्वी: ${mainValue} ${operatorSymbol} ${calculatedValue.toFixed(2)} चुकीचे आहे`;
                        }
                    }
                }
            }
            
            // Validate main field (required, etc.)
            if (field.mainField && field.mainField.id) {
                const mainValue = formData[field.mainField.id];
                const mainValidation = validateFieldValue(field.mainField, mainValue);
                
                const isRequired = field.mainField.enRequired || field.mainField.required || false;
                const isEmpty = mainValue === undefined || mainValue === null || mainValue === '';
                
                if (isRequired && isEmpty) {
                    errors[field.mainField.id] = selectedLanguage === 'english'
                        ? `${getFieldLabel(field.mainField)} is required`
                        : `${getFieldLabel(field.mainField)} आवश्यक आहे`;
                } else if (!mainValidation.valid && !isEmpty) {
                    errors[field.mainField.id] = mainValidation.message;
                }
            }

            // Validate sub fields
            if (field.subFields && Array.isArray(field.subFields)) {
                field.subFields.forEach(subField => {
                    const subValue = formData[subField.id];
                    const subValidation = validateFieldValue(subField, subValue);
                    
                    const isRequired = subField.enRequired || subField.required || false;
                    const isEmpty = subValue === undefined || subValue === null || subValue === '';
                    
                    if (isRequired && isEmpty) {
                        errors[subField.id] = selectedLanguage === 'english'
                            ? `${getFieldLabel(subField)} is required`
                            : `${getFieldLabel(subField)} आवश्यक आहे`;
                    } else if (!subValidation.valid && !isEmpty) {
                        errors[subField.id] = subValidation.message;
                    }
                });
            }
        }

        // Validate arithmetic field's arithmetic fields
        if (field.type === 'arithmetic' && field.arithmeticFields && Array.isArray(field.arithmeticFields)) {
            field.arithmeticFields.forEach(afield => {
                // Skip constant fields (they don't need validation since they're auto-filled)
                if (afield.fieldType === 'constant' || afield.constantValue !== undefined) {
                    return;
                }
                
                const afieldValue = formData[afield.id];
                const afieldValidation = validateFieldValue(afield, afieldValue);
                
                const isRequired = afield.enRequired || afield.required || false;
                const isEmpty = afieldValue === undefined || afieldValue === null || afieldValue === '';
                
                if (isRequired && isEmpty) {
                    errors[afield.id] = selectedLanguage === 'english'
                        ? `${getFieldLabel(afield)} is required`
                        : `${getFieldLabel(afield)} आवश्यक आहे`;
                } else if (!afieldValidation.valid && !isEmpty) {
                    errors[afield.id] = afieldValidation.message;
                }
            });
        }

        // Formula field validation
   // Formula field validation - Step Result Reference skip करा
if (field.type === 'formula' && field.formulaSteps && Array.isArray(field.formulaSteps)) {
    console.log('🔍 Validating formula field:', field.id, 'with steps:', field.formulaSteps.length);
    
    field.formulaSteps.forEach((step, stepIndex) => {
        if (step.arithmeticFields && Array.isArray(step.arithmeticFields)) {
            step.arithmeticFields.forEach((afield, fieldIndex) => {
                // ===== FIX: Skip Step Result Reference fields =====
                if (afield.isStepResultReference === true) {
                    console.log(`⏭️ Skipping step result reference field: ${afield.id}`);
                    return;
                }
                
                const isConstant = afield.fieldType === 'constant' || afield.constantValue !== undefined;
                
                const isRequired = afield.enRequired === true || afield.enRequired === 1 || afield.enRequired === '1' ||
                                  afield.required === true || afield.required === 1 || afield.required === '1' ||
                                  afield.mrRequired === true || afield.mrRequired === 1 || afield.mrRequired === '1';
                
                if (isConstant && !isRequired) {
                    console.log(`⏭️ Skipping optional constant field: ${afield.id}`);
                    return;
                }
                
                if (afield.isSharedReference === true) {
                    console.log(`⏭️ Skipping shared reference field: ${afield.id}`);
                    return;
                }
                
                const afieldValue = formData[afield.id];
                
                let actualValue = afieldValue;
                if (isConstant && afield.constantValue !== undefined && afield.constantValue !== null) {
                    actualValue = afield.constantValue;
                }
                
                const isEmpty = actualValue === undefined || 
                               actualValue === null || 
                               actualValue === '' ||
                               (typeof actualValue === 'string' && actualValue.trim() === '');
                
                if (isRequired && isEmpty) {
                    const errorMsg = selectedLanguage === 'english'
                        ? `${getFieldLabel(afield)} is required`
                        : `${getFieldLabel(afield)} आवश्यक आहे`;
                    errors[afield.id] = errorMsg;
                    console.log(`❌ Required error for ${afield.id}:`, errorMsg);
                } 
                else if (!isEmpty && !isConstant) {
                    const afieldValidation = validateFieldValue(afield, actualValue);
                    if (!afieldValidation.valid) {
                        errors[afield.id] = afieldValidation.message;
                        console.log(`❌ Validation error for ${afield.id}:`, afieldValidation.message);
                    }
                }
            });
        }
    });
}

        // Radio field with children
        if (field.type === 'radio' && formData[field.id]) {
            const selectedOption = formData[field.id];
            const subFieldsForOption = currentForm.schema.filter(f =>
                String(f.parentId) === String(field.id) &&
                String(f.colName) === String(selectedOption)
            );

            subFieldsForOption.forEach(subField => {
                const subValue = formData[subField.id];
                const subResult = validateFieldValue(subField, subValue);
                if (!subResult.valid) {
                    errors[subField.id] = subResult.message;
                } else if ((subField.enRequired || subField.required) && 
                          (subValue === undefined || subValue === null || subValue === '')) {
                    errors[subField.id] = selectedLanguage === 'english'
                        ? `${getFieldLabel(subField)} is required`
                        : `${getFieldLabel(subField)} आवश्यक आहे`;
                }
            });
        }

        // Checkbox field with children
        if (field.type === 'checkbox') {
            const parentValues = Array.isArray(formData[field.id]) ? formData[field.id] : [];
            if (parentValues.length > 0) {
                parentValues.forEach(selectedOption => {
                    const subFieldsForOption = currentForm.schema.filter(f =>
                        String(f.parentId) === String(field.id) &&
                        String(f.colName) === String(selectedOption)
                    );
                    subFieldsForOption.forEach(subField => {
                        const subValue = formData[subField.id];
                        const subResult = validateFieldValue(subField, subValue);
                        if (!subResult.valid) {
                            errors[subField.id] = subResult.message;
                        } else if ((subField.enRequired || subField.required) && 
                                  (subValue === undefined || subValue === null || subValue === '')) {
                            errors[subField.id] = selectedLanguage === 'english'
                                ? `${getFieldLabel(subField)} is required`
                                : `${getFieldLabel(subField)} आवश्यक आहे`;
                        }
                    });
                });
            }
        }
    };

    const rootFields = currentForm.schema.filter(f => !f.parentId);
    rootFields.forEach(validateField);

    // Log validation results for debugging
    if (Object.keys(errors).length > 0) {
        console.log('❌ Validation errors found:', errors);
    } else {
        console.log('✅ All validations passed');
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
};
// Add this new function
const validateFormulaInputsDirectly = () => {
    if (!currentForm?.schema) return true;
    
    let hasError = false;
    let errorMessage = '';
    
    // Find all formula fields
    const formulaFields = currentForm.schema.filter(f => f.type === 'formula');
    
    for (const formulaField of formulaFields) {
        if (formulaField.formulaSteps) {
            for (const step of formulaField.formulaSteps) {
                // Skip logical steps (handled by checkFormulaLogicalErrors)
                const stepIsLogical = isLogicalOperator(step.combineOperator);
                if (stepIsLogical) continue;
                
                if (step.arithmeticFields) {
                    for (const afield of step.arithmeticFields) {
                        // Skip auto-calculated fields
                        if (afield.isStepResultReference === true) continue;
                        if (afield.isSharedReference === true) continue;
                        if (afield.isExternalReference === true) continue;
                        if (afield.fieldType === 'constant') continue;
                        
                        // Check if field is required
                        const isRequired = afield.enRequired === true || afield.enRequired === 1 || 
                                          afield.required === true || afield.required === 1;
                        if (!isRequired) continue;
                        
                        // Get value
                        const value = formData[afield.id];
                        const isEmpty = value === undefined || value === null || value === '' || value === 0;
                        
                        if (isEmpty && isRequired) {
                            const label = getFieldLabel(afield);
                            errorMessage = selectedLanguage === 'english'
                                ? `Please fill "${label}" in the formula step "${step.name}"`
                                : `कृपया फॉर्म्युला स्टेप "${step.name}" मध्ये "${label}" भरा`;
                            hasError = true;
                            break; // Break inner loop
                        }
                    }
                }
                if (hasError) break;
            }
        }
        if (hasError) break;
    }
    
    if (hasError) {
        console.log('❌ Formula inputs validation error:', errorMessage);
        message.error(errorMessage);
        return false;
    }
    
    return true;
};
    const handleFileUpload = async (fieldId, file, onSuccess, onError, onProgress) => {
        if (isFormBlocked || viewFilledMode) {
            onError(new Error('Form already submitted or limit reached'));
            return;
        }

        const formDataObj = new FormData();
        formDataObj.append('file', file);
        formDataObj.append('fieldId', fieldId);
        formDataObj.append('formId', currentForm?.id);
        formDataObj.append('userId', currentUser?.id);
        formDataObj.append('entryId', currentEntryId || '');

        setUploadingFiles(prev => ({ ...prev, [file.uid]: true }));

        try {
            const response = await fetch(`${API_BASE}/upload`, {
                method: 'POST',
                headers: { 'x-user-id': currentUser?.id },
                body: formDataObj
            });

            const result = await response.json();

            if (result.success) {
                onSuccess(result.data, file);
                const currentFiles = formData[fieldId] || [];
                const updatedFiles = [...currentFiles, {
                    uid: file.uid,
                    fileId: result.data.fileId,
                    name: file.name,
                    filename: result.data.filename,
                    originalName: result.data.originalName,
                    url: result.data.url,
                    serverPath: result.data.path || result.data.serverPath,
                    size: result.data.size,
                    type: result.data.type,
                    status: 'done'
                }];
                handleFieldChange(fieldId, updatedFiles);
                message.success(`${file.name} uploaded successfully`);
            } else {
                onError(new Error(result.message));
                message.error(result.message);
            }
        } catch (error) {
            console.error('❌ Upload error:', error);
            onError(error);
            message.error(`${file.name} upload failed`);
        } finally {
            setUploadingFiles(prev => ({ ...prev, [file.uid]: false }));
        }
    };

    const handleFileDelete = async (fieldId, file) => {
        if (isFormBlocked || viewFilledMode) return;

        if (file.fileId) {
            try {
                await fetch(`${API_BASE}/files/${file.fileId}`, { method: 'DELETE' });
            } catch (error) {}
        }

        const currentFiles = formData[fieldId] || [];
        const updatedFiles = currentFiles.filter(f => f.uid !== file.uid);
        handleFieldChange(fieldId, updatedFiles);
    };

    const calculateAllResults = () => {
    if (!currentForm || !currentForm.schema) return formData;

    const updatedFormData = { ...formData };

    const processFields = (fields) => {
        fields.forEach(field => {
            if (field.type === 'arithmetic' && field.arithmeticFields && field.arithmeticFields.length > 0) {
                const result = calculateArithmeticResult(field.arithmeticFields, formData, field.arithmeticOperator || 'add');
                updatedFormData[field.id] = result;
            }

            if (field.type === 'comparison' && field.subFields && field.subFields.length > 0) {

                if (field.mainField && field.mainField.id) {
                    const mainValue = formData[field.mainField.id];
                    if (mainValue !== undefined) {
                        updatedFormData[field.mainField.id] = mainValue;
                        console.log(`✅ calculateAllResults - Main field ${field.mainField.id}:`, mainValue);
                    }
                }

                const result = calculateComparisonResult(field.subFields, formData);
                updatedFormData[`${field.id}_calculated`] = result;
            }

            if (field.children) {
                if (Array.isArray(field.children)) {
                    processFields(field.children);
                } else {
                    if (field.children.left) processFields(field.children.left);
                    if (field.children.right) processFields(field.children.right);
                }
            }
        });
    };

    if (currentForm.schema) {
        processFields(currentForm.schema);
    }

    // 🔥 Also process all subfields that might be main fields
    if (currentForm.schema) {
        const allSubFields = currentForm.schema.filter(f => f.parentId);
        allSubFields.forEach(field => {
            if (field.type === 'number' && formData[field.id] !== undefined) {
                updatedFormData[field.id] = formData[field.id];
            }
        });
    }

    return updatedFormData;
};

// // 🔹 DSC Verification function - Calls backend API
// const verifyDSC = async () => {
//     try {
//         const token = sessionStorage.getItem('token');

//         const response = await fetch(`${API_BASE}/verify-dsc`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 ...(token ? { 'Authorization': `Bearer ${token}` } : {})
//             },
//             body: JSON.stringify({
//                 userId: currentUser?.id,
//                 formId: currentForm?.id
//             })
//         });

//         const result = await response.json();

//         if (result.success && result.hasDSC) {
//             setDscVerified(true);
//             return true;
//         } else {
//             setDscVerified(false);
//             message.error(selectedLanguage === 'english'
//                 ? 'DSC (Digital Signature Certificate) not found. Please insert your DSC token.'
//                 : 'DSC (डिजिटल स्वाक्षरी प्रमाणपत्र) सापडले नाही. कृपया तुमचे DSC टोकन लावा.');
//             return false;
//         }
//     } catch (error) {
//         console.error('DSC verification error:', error);
//         message.error(selectedLanguage === 'english'
//             ? 'Unable to verify DSC. Please check your DSC connection.'
//             : 'DSC सत्यापन करू शकत नाही. कृपया तुमचे DSC कनेक्शन तपासा.');
//         return false;
//     }
// };

const checkComparisonValidation = () => {
    if (!currentForm || !currentForm.schema) return true;

    let hasFailedComparison = false;
    let failedComparisonMessage = '';

    const checkComparison = (field) => {
        if (field.type !== 'comparison') return;

        const mainField = field.mainField;
        const subFields = field.subFields || [];
        const operator = field.comparisonOperator || 'equals';
        
        if (!mainField) return;

        // Get main field value - keep as string to preserve zeros
        const rawMainValue = formData[mainField.id];
        const mainValue = (rawMainValue === 0 || rawMainValue === '0') ? 0 : rawMainValue;
        
        // Calculate the result from subfields
        let calculatedValue = 0;
        if (subFields.length > 0) {
            let result = parseFloat(formData[subFields[0]?.id]) || 0;
            for (let i = 1; i < subFields.length; i++) {
                const subField = subFields[i];
                const value = parseFloat(formData[subField?.id]) || 0;
                const subOperator = subField.arithmeticOperator || "add";
                
                switch (subOperator) {
                    case "add": result += value; break;
                    case "subtract": result -= value; break;
                    case "multiply": result *= value; break;
                    case "divide": if (value !== 0) result /= value; break;
                    default: result += value;
                }
            }
            calculatedValue = parseFloat(result.toFixed(2));
        }
        
        // Check if main value is filled
        const mainValueExists = mainValue !== undefined && mainValue !== null && mainValue !== '';
        
        let isValid = null;
        if (mainValueExists) {
            const mainNum = parseFloat(mainValue) || 0;
            const calcNum = calculatedValue;
            
            switch (operator) {
                case "equals": isValid = mainNum === calcNum; break;
                case "not_equals": isValid = mainNum !== calcNum; break;
                case "greater_than": isValid = mainNum > calcNum; break;
                case "less_than": isValid = mainNum < calcNum; break;
                case "greater_than_equal": isValid = mainNum >= calcNum; break;
                case "less_than_equal": isValid = mainNum <= calcNum; break;
                default: isValid = mainNum === calcNum;
            }
        }
        
        // Get operator symbol for display
        const getOperatorSymbol = (op) => {
            const symbols = {
                "equals": "=",
                "not_equals": "≠",
                "greater_than": ">",
                "less_than": "<",
                "greater_than_equal": "≥",
                "less_than_equal": "≤"
            };
            return symbols[op] || "=";
        };
        
        console.log(`🔍 Comparison Check: ${mainValue} ${getOperatorSymbol(operator)} ${calculatedValue} = ${isValid}`);
        
        if (mainValueExists && isValid === false) {
            hasFailedComparison = true;
            failedComparisonMessage = field.customValidationMessage || 
                (selectedLanguage === 'english' 
                    ? `❌ Comparison failed: ${mainValue} ${getOperatorSymbol(operator)} ${calculatedValue} is false`
                    : `❌ तुलना अयशस्वी: ${mainValue} ${getOperatorSymbol(operator)} ${calculatedValue} चुकीचे आहे`);
        }
    };

    const checkAllFields = (fields) => {
        if (!fields) return;
        fields.forEach(field => {
            checkComparison(field);
            
            if (field.children) {
                if (Array.isArray(field.children)) {
                    checkAllFields(field.children);
                } else {
                    if (field.children.left) checkAllFields(field.children.left);
                    if (field.children.right) checkAllFields(field.children.right);
                }
            }
            if (field.subFields && Array.isArray(field.subFields)) {
                checkAllFields(field.subFields);
            }
            if (field.arithmeticFields && Array.isArray(field.arithmeticFields)) {
                checkAllFields(field.arithmeticFields);
            }
        });
    };

    const rootFields = currentForm.schema.filter(f => !f.parentId);
    checkAllFields(rootFields);

    if (hasFailedComparison) {
        message.error(failedComparisonMessage);
        return false;
    }
    return true;
};

// Helper function to get operator symbol for display
const getOperatorSymbol = (operator) => {
    const op = COMPARISON_OPERATORS.find(op => op.value === operator);
    return op ? op.symbol : '=';
};

// Helper to calculate final result for a formula field
const calculateFinalResult = (field) => {
    if (!field || !field.formulaSteps || field.formulaSteps.length === 0) return 0;
    
    const stepResults = [];
    
    for (const step of field.formulaSteps) {
        let stepResult = 0;
        let isFirst = true;
        const operator = step.combineOperator || 'add';
        
        if (step.arithmeticFields && Array.isArray(step.arithmeticFields)) {
            for (const arithField of step.arithmeticFields) {
                let value = 0;
                
                if (arithField.fieldType === 'constant') {
                    value = parseFloat(arithField.constantValue) || 0;
                } else {
                    const formValue = formData[arithField.id];
                    value = parseFloat(formValue) || 0;
                }
                
                if (isFirst) {
                    stepResult = value;
                    isFirst = false;
                } else {
                    switch (operator) {
                        case 'add': stepResult += value; break;
                        case 'subtract': stepResult -= value; break;
                        case 'multiply': stepResult *= value; break;
                        case 'divide': stepResult = value !== 0 ? stepResult / value : 0; break;
                        default: stepResult += value;
                    }
                }
            }
        }
        
        stepResults.push(stepResult);
    }
    
    // Combine step results
    const combineOperator = field.stepCombineOperator || 'add';
    let finalResult = stepResults.length > 0 ? stepResults[0] : 0;
    
    for (let i = 1; i < stepResults.length; i++) {
        switch (combineOperator) {
            case 'add': finalResult += stepResults[i]; break;
            case 'subtract': finalResult -= stepResults[i]; break;
            case 'multiply': finalResult *= stepResults[i]; break;
            case 'divide': finalResult = stepResults[i] !== 0 ? finalResult / stepResults[i] : 0; break;
            default: finalResult += stepResults[i];
        }
    }
    
    return finalResult;
};

// =====================================================
// 🛡️ COMPREHENSIVE VALIDATION FUNCTION (FIXED)
// =====================================================
const validateFormComprehensive = () => {
    if (!currentForm || !currentForm.schema) return { valid: true, errors: [], errorMessages: [] };
    if (viewFilledMode) return { valid: true, errors: [], errorMessages: [] };

    const errors = {};

    // Helper to get label
    const getLabel = (field) => {
        if (!field) return 'Field';
        return selectedLanguage === 'english' ? (field.enLabel || field.label || field.id) : (field.mrLabel || field.label || field.id);
    };

    // Check if field should be validated (skip auto-calculated/constant fields)
    const shouldValidateField = (field) => {
        // Skip if field is auto-calculated
        if (field.isAutoCalculated === true) return false;
        
        // Skip constant fields
        if (field.fieldType === 'constant' || field.constantValue !== undefined) return false;
        
        // Skip shared references
        if (field.isSharedReference === true) return false;
        
        // Skip external references
        if (field.isExternalReference === true) return false;
        
        // Skip step result references
        if (field.isStepResultReference === true) return false;
        
        return true;
    };

    // Check if a value is considered empty
    const isEmpty = (value, fieldType) => {
        if (value === undefined || value === null) return true;
        
        if (fieldType === 'checkbox') {
            if (!Array.isArray(value) || value.length === 0) return true;
            return false;
        }
        
        if (fieldType === 'file' || fieldType === 'image') {
            if (!Array.isArray(value) || value.length === 0) return true;
            return false;
        }
        
        if (fieldType === 'number') {
            if (value === '' || value === 0) return true;
            return false;
        }
        
        if (fieldType === 'text' || fieldType === 'paragraph') {
            if (typeof value === 'string' && value.trim() === '') return true;
            return false;
        }
        
        if (fieldType === 'date') {
            if (value === '' || value === null) return true;
            return false;
        }
        
        if (fieldType === 'dropdown') {
            if (value === '' || value === null) return true;
            if (Array.isArray(value) && value.length === 0) return true;
            return false;
        }
        
        if (fieldType === 'radio') {
            if (value === '' || value === null) return true;
            return false;
        }
        
        return value === '' || value === null || value === undefined;
    };

    // Recursive function to validate all fields
    const validateAllFields = (fields, parentContext = null) => {
        if (!fields || !Array.isArray(fields)) return;

        for (const field of fields) {
            // Skip heading fields
            if (field.type === 'heading') {
                if (field.children && Array.isArray(field.children)) {
                    validateAllFields(field.children, parentContext);
                }
                continue;
            }

            // Skip row fields
            if (field.type === 'row') {
                if (field.children) {
                    if (Array.isArray(field.children)) {
                        validateAllFields(field.children, parentContext);
                    } else {
                        if (field.children.left) validateAllFields(field.children.left, parentContext);
                        if (field.children.right) validateAllFields(field.children.right, parentContext);
                    }
                }
                continue;
            }

            // Skip formula fields for validation (they are handled separately)
            if (field.type === 'formula') {
                // Still validate required arithmetic fields inside formula
                if (field.formulaSteps && Array.isArray(field.formulaSteps)) {
                    for (const step of field.formulaSteps) {
                        if (step.arithmeticFields && Array.isArray(step.arithmeticFields)) {
                            for (const arithField of step.arithmeticFields) {
                                // Skip if field shouldn't be validated
                                if (!shouldValidateField(arithField)) continue;
                                
                                const isRequired = arithField.enRequired === true || arithField.enRequired === 1 || 
                                                   arithField.required === true || arithField.required === 1;
                                
                                if (isRequired) {
                                    const value = formData[arithField.id];
                                    if (isEmpty(value, arithField.type)) {
                                        errors[arithField.id] = selectedLanguage === 'english'
                                            ? `${getLabel(arithField)} is required in formula step "${step.name || 'Step'}"`
                                            : `${getLabel(arithField)} फॉर्म्युला स्टेप "${step.name || 'Step'}" मध्ये आवश्यक आहे`;
                                    }
                                }
                            }
                        }
                    }
                }
                continue;
            }

            // ========== VALIDATE COMPARISON FIELDS ==========
            if (field.type === 'comparison') {
                const mainField = field.mainField;
                const subFields = field.subFields || [];
                const operator = field.comparisonOperator || 'equals';
                
                if (!mainField) continue;

                // Validate main field (only if not auto-calculated)
                if (shouldValidateField(mainField)) {
                    const isMainRequired = mainField.enRequired === true || mainField.required === true;
                    const mainValue = formData[mainField.id];
                    
                    if (isMainRequired && isEmpty(mainValue, mainField.type)) {
                        errors[mainField.id] = selectedLanguage === 'english'
                            ? `${getLabel(mainField)} is required`
                            : `${getLabel(mainField)} आवश्यक आहे`;
                    }
                }

                // Validate sub fields
                for (const subField of subFields) {
                    if (!shouldValidateField(subField)) continue;
                    
                    const isSubRequired = subField.enRequired === true || subField.required === true;
                    const subValue = formData[subField.id];
                    
                    if (isSubRequired && isEmpty(subValue, subField.type)) {
                        errors[subField.id] = selectedLanguage === 'english'
                            ? `${getLabel(subField)} is required`
                            : `${getLabel(subField)} आवश्यक आहे`;
                    }
                }

                // Check comparison logic only if main value exists and is not empty
                const mainValue = formData[mainField.id];
                if (mainValue !== undefined && mainValue !== null && mainValue !== '' && mainValue !== 0) {
                    let calculatedValue = 0;
                    if (subFields.length > 0) {
                        let result = parseFloat(formData[subFields[0]?.id]) || 0;
                        for (let i = 1; i < subFields.length; i++) {
                            const subField = subFields[i];
                            const value = parseFloat(formData[subField?.id]) || 0;
                            const subOperator = subField.arithmeticOperator || "add";
                            
                            switch (subOperator) {
                                case "add": result += value; break;
                                case "subtract": result -= value; break;
                                case "multiply": result *= value; break;
                                case "divide": if (value !== 0) result /= value; break;
                                default: result += value;
                            }
                        }
                        calculatedValue = result;
                    }
                    
                    const mainNum = parseFloat(mainValue) || 0;
                    let isValid = false;
                    
                    switch (operator) {
                        case "equals": isValid = mainNum === calculatedValue; break;
                        case "not_equals": isValid = mainNum !== calculatedValue; break;
                        case "greater_than": isValid = mainNum > calculatedValue; break;
                        case "less_than": isValid = mainNum < calculatedValue; break;
                        case "greater_than_equal": isValid = mainNum >= calculatedValue; break;
                        case "less_than_equal": isValid = mainNum <= calculatedValue; break;
                        default: isValid = mainNum === calculatedValue;
                    }
                    
                    if (!isValid) {
                        const operatorSymbol = getOperatorSymbol(operator);
                        const customMsg = field.customValidationMessage;
                        errors[field.id] = customMsg || selectedLanguage === 'english'
                            ? `❌ Comparison failed: ${mainValue} ${operatorSymbol} ${calculatedValue.toFixed(2)} is false`
                            : `❌ तुलना अयशस्वी: ${mainValue} ${operatorSymbol} ${calculatedValue.toFixed(2)} चुकीचे आहे`;
                    }
                }
                continue;
            }

            // ========== VALIDATE ARITHMETIC FIELDS ==========
            if (field.type === 'arithmetic' && field.arithmeticFields && Array.isArray(field.arithmeticFields)) {
                for (const arithField of field.arithmeticFields) {
                    // Skip if field shouldn't be validated
                    if (!shouldValidateField(arithField)) continue;
                    
                    const isRequired = arithField.enRequired === true || arithField.required === true;
                    const value = formData[arithField.id];
                    
                    if (isRequired && isEmpty(value, arithField.type)) {
                        errors[arithField.id] = selectedLanguage === 'english'
                            ? `${getLabel(arithField)} is required`
                            : `${getLabel(arithField)} आवश्यक आहे`;
                    } else if (value !== undefined && value !== null && value !== '') {
                        const numVal = parseFloat(value);
                        if (isNaN(numVal)) {
                            errors[arithField.id] = selectedLanguage === 'english'
                                ? `${getLabel(arithField)} must be a valid number`
                                : `${getLabel(arithField)} वैध संख्या असणे आवश्यक आहे`;
                        }
                    }
                }
                continue;
            }

            // ========== VALIDATE REGULAR FIELDS ==========
            // Check if field should be validated
            if (!shouldValidateField(field)) continue;

            // Check if field is visible based on parent
            if (field.parentId) {
                const parentField = currentForm.schema.find(f => f.id === field.parentId);
                if (parentField) {
                    if (parentField.type === 'radio') {
                        const selectedRadioValue = formData[parentField.id];
                        if (String(field.colName) !== String(selectedRadioValue)) {
                            continue;
                        }
                    } else if (parentField.type === 'checkbox') {
                        const selectedCheckboxValues = Array.isArray(formData[parentField.id]) ? formData[parentField.id] : [];
                        if (!selectedCheckboxValues.includes(field.colName)) {
                            continue;
                        }
                    }
                }
            }

            const fieldTypes = ['text', 'number', 'date', 'dropdown', 'radio', 'paragraph', 'file', 'image', 'checkbox'];
            if (!fieldTypes.includes(field.type)) continue;

            const isRequired = field.enRequired === true || field.required === true;
            const value = formData[field.id];

            // Check if empty
            if (isRequired && isEmpty(value, field.type)) {
                errors[field.id] = selectedLanguage === 'english'
                    ? `${getLabel(field)} is required`
                    : `${getLabel(field)} आवश्यक आहे`;
            }

            // Additional validation for filled fields
            if (!isEmpty(value, field.type) && value !== undefined && value !== null && value !== '') {
                if (field.type === 'number') {
                    const numVal = parseFloat(value);
                    if (isNaN(numVal)) {
                        errors[field.id] = selectedLanguage === 'english'
                            ? `${getLabel(field)} must be a valid number`
                            : `${getLabel(field)} वैध संख्या असणे आवश्यक आहे`;
                    }
                }
            }

            if (field.children && Array.isArray(field.children)) {
                validateAllFields(field.children, parentContext);
            }
        }
    };

    const rootFields = currentForm.schema.filter(f => !f.parentId);
    validateAllFields(rootFields);

    const errorMessages = Object.values(errors);
    const valid = errorMessages.length === 0;

    console.log(`📋 Comprehensive validation: ${valid ? '✅ PASSED' : '❌ FAILED'} (${errorMessages.length} errors)`);
    if (!valid) {
        console.log('📋 Errors:', errors);
    }

    return { valid, errors, errorMessages };
};

const saveFormData = async (status = "draft") => {
    // Early return if no form
    if (!currentForm) {
        console.warn('No current form to save');
        return;
    }
    
    if (!currentUser || !currentUser.id) {
        message.error(selectedLanguage === 'english' ? 'Please login first' : 'कृपया प्रथम लॉगिन करा');
        return;
    }

    const isMultiEntry = formMetadata?.entry_type === 'multi';

    if (isMultiEntry && isMultiEntryLimitReached) {
        message.error(selectedLanguage === 'english'
            ? 'You have reached the maximum entry limit for this form'
            : 'तुम्ही या फॉर्मसाठी कमाल एंट्री मर्यादा पूर्ण केली आहे');
        return;
    }

    // =====================================================
    // 🛡️ STEP 1: FORMULA LOGICAL ERRORS CHECK
    // =====================================================
    console.log('🔍 Checking formula logical errors...');
    const formulaCheck = checkFormulaLogicalErrors();
    if (formulaCheck.hasError) {
        // Show the first error message
        const errorMsg = formulaCheck.errors[0].message;
        console.log('❌ Formula error found:', errorMsg);
        message.error(errorMsg);
        
        // Set validation errors to show in UI
        const errorObj = {};
        formulaCheck.errors.forEach(err => {
            errorObj[err.fieldId] = err.message;
        });
        setValidationErrors(errorObj);
        
        // 🔥 CRITICAL: Set submitting to false and RETURN
        setIsSubmitting(false);
        return; // ✅ This stops execution
    }

    // =====================================================
    // 🛡️ STEP 2: FORMULA INPUTS VALIDATION (Only for submission)
    // =====================================================
    if (status === 'filled') {
        console.log('🔍 Validating formula inputs...');
        const formulaInputsValid = validateFormulaInputsDirectly();
        if (!formulaInputsValid) {
            console.log('❌ Formula inputs validation failed');
            setIsSubmitting(false);
            return; // ✅ Stops execution
        }

        // =====================================================
        // 🛡️ STEP 3: COMPREHENSIVE VALIDATION
        // =====================================================
        console.log('🔍 Running comprehensive validation...');
        const validationResult = validateFormComprehensive();
        if (!validationResult.valid) {
            console.log('❌ Comprehensive validation failed:', validationResult.errorMessages);
            if (validationResult.errorMessages.length > 0) {
                message.error(validationResult.errorMessages[0]);
            } else {
                message.error(selectedLanguage === 'english'
                    ? 'Please fix all validation errors before submitting'
                    : 'कृपया सबमिट करण्यापूर्वी सर्व त्रुटी सुधारा');
            }
            setValidationErrors(validationResult.errors);
            setIsSubmitting(false);
            return; // ✅ Stops execution
        }

        // =====================================================
        // 🛡️ STEP 4: COMPARISON FIELD VALIDATION
        // =====================================================
        console.log('🔍 Checking comparison validation...');
        const comparisonValid = checkComparisonValidation();
        if (!comparisonValid) {
            console.log('❌ Comparison validation failed');
            setIsSubmitting(false);
            return; // ✅ Stops execution
        }

        // =====================================================
        // 🛡️ STEP 5: CONFIRMATION CHECK
        // =====================================================
        if (!confirmSubmit) {
            console.log('❌ Confirmation not checked');
            message.error(selectedLanguage === 'english'
                ? 'Please confirm that you have filled the form correctly'
                : 'कृपया पुष्टी करा की तुम्ही फॉर्म योग्यरित्या भरला आहे');
            setIsSubmitting(false);
            return; // ✅ Stops execution
        }
    }

    // =====================================================
    // 🚀 PROCEED WITH SAVING - Only reaches here if all validations pass
    // =====================================================
    console.log('✅ All validations passed! Proceeding with save...');
    setIsSubmitting(true);

    try {
        const formDataWithResults = calculateAllResults();
        const cleanData = {};

        const collectAllFieldIds = (fields) => {
            fields.forEach(field => {
                if (field.type === 'heading') {
                    if (field.children) {
                        if (Array.isArray(field.children)) {
                            collectAllFieldIds(field.children);
                        } else {
                            if (field.children.left) collectAllFieldIds(field.children.left);
                            if (field.children.right) collectAllFieldIds(field.children.right);
                        }
                    }
                    return;
                }

                if (field.type === 'row') return;

                let fieldValue = formDataWithResults[field.id] !== undefined ? formDataWithResults[field.id] : '';

                if (field.type === 'comparison') {
                    if (field.mainField && field.mainField.id) {
                        const mainFieldValue = formDataWithResults[field.mainField.id] !== undefined
                            ? formDataWithResults[field.mainField.id]
                            : '';
                        cleanData[field.mainField.id] = mainFieldValue;
                    }

                    if (field.subFields && Array.isArray(field.subFields)) {
                        field.subFields.forEach(subField => {
                            cleanData[subField.id] = formDataWithResults[subField.id] !== undefined
                                ? formDataWithResults[subField.id]
                                : '';
                        });
                    }
                    return;
                }

                if (field.type === 'arithmetic' && field.arithmeticFields) {
                    field.arithmeticFields.forEach(afield => {
                        cleanData[afield.id] = formDataWithResults[afield.id] !== undefined ? formDataWithResults[afield.id] : '';
                    });
                    if (formDataWithResults[field.id] !== undefined) {
                        cleanData[field.id] = formDataWithResults[field.id];
                    }
                }

                if (field.type === 'radio' && field.children) {
                    field.children.forEach(child => {
                        cleanData[child.id] = formDataWithResults[child.id] !== undefined ? formDataWithResults[child.id] : '';
                    });
                }

                if (field.type === 'checkbox' && field.children) {
                    field.children.forEach(child => {
                        cleanData[child.id] = formDataWithResults[child.id] !== undefined ? formDataWithResults[child.id] : '';
                    });
                }

                if (field.type !== 'comparison') {
                    cleanData[field.id] = fieldValue;
                }

                if (field.children) {
                    if (Array.isArray(field.children)) {
                        collectAllFieldIds(field.children);
                    } else {
                        if (field.children.left) collectAllFieldIds(field.children.left);
                        if (field.children.right) collectAllFieldIds(field.children.right);
                    }
                }
            });
        };

        if (currentForm.schema) {
            collectAllFieldIds(currentForm.schema);
        }

        Object.keys(formDataWithResults).forEach(key => {
            if (cleanData[key] === undefined) {
                if (!key.includes('_calculated') && !key.includes('_main') && !key.includes('_sub_')) {
                    cleanData[key] = formDataWithResults[key];
                }
            }
        });

        cleanData['form_progress'] = progress;
        cleanData['submitted_by_division'] = currentUser.division_id || null;
        cleanData['submitted_by_district'] = currentUser.district_id || null;
        cleanData['submitted_by_ulb'] = currentUser.ulb_id || null;

        const unitSelections = {};
        Object.keys(fieldUnits).forEach(fieldId => {
            if (fieldUnits[fieldId] !== 'none') {
                unitSelections[fieldId] = fieldUnits[fieldId];
            }
        });

        const arithmeticResults = {};
        const comparisonResults = {};

        const collectResults = (fields) => {
            fields.forEach(field => {
                if (field.type === 'arithmetic' && field.arithmeticFields && field.arithmeticFields.length > 0) {
                    arithmeticResults[field.id] = formDataWithResults[field.id] || 0;
                }
                if (field.type === 'comparison' && field.subFields && field.subFields.length > 0) {
                    const result = formDataWithResults[`${field.id}_calculated`] || 0;
                    comparisonResults[field.id] = result;
                }

                if (field.type === 'formula' && field.formulaSteps && field.formulaSteps.length > 0) {
                    if (formDataWithResults[field.id] !== undefined) {
                        arithmeticResults[`formula_${field.id}`] = formDataWithResults[field.id];
                    }
                }

                if (field.children) {
                    if (Array.isArray(field.children)) {
                        collectResults(field.children);
                    } else {
                        if (field.children.left) collectResults(field.children.left);
                        if (field.children.right) collectResults(field.children.right);
                    }
                }
            });
        };

        if (currentForm.schema) {
            collectResults(currentForm.schema);
        }

        if (Object.keys(arithmeticResults).length > 0) {
            cleanData['arithmetic_results'] = JSON.stringify(arithmeticResults);
        }
        if (Object.keys(comparisonResults).length > 0) {
            cleanData['comparison_results'] = JSON.stringify(comparisonResults);
        }

        let dateFormat = formMetadata?.frequency?.schedule?.dateFormat ||
                         formData.schedule_date_format ||
                         'YYYY-MM-DD';

        const today = new Date();
        let formattedDate = null;

        if (dateFormat && dateFormat !== 'YYYY-MM-DD') {
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');

            formattedDate = dateFormat
                .replace(/YYYY/g, year)
                .replace(/MM/g, month)
                .replace(/DD/g, day);
        } else {
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            formattedDate = `${year}-${month}-${day}`;
        }

        const finalData = {
            ...cleanData,
            schedule_date_format: formattedDate
        };

        const submissionData = {
            formId: currentForm.id,
            userId: currentUser.id,
            data: finalData,
            unitSelections: unitSelections,
            status: status,
            progress: progress,
            created_by_name: currentUser.name || currentUser.username || `User ${currentUser.id}`,
            division_id: currentUser.division_id,
            district_id: currentUser.district_id,
            ulb_id: currentUser.ulb_id,
            role_id: currentUser.role_id || currentUser.roleId || null,

            ...(formData.selected_frequency_type && { selected_frequency_type: formData.selected_frequency_type }),
            ...(formData.selected_frequency_period && { selected_frequency_period: formData.selected_frequency_period }),
            ...(formData.selected_frequency_label && { selected_frequency_label: formData.selected_frequency_label }),
            ...(formData.frequency_selection_date && { frequency_selection_date: formData.frequency_selection_date }),

            ...(formData.schedule_time && { schedule_time: formData.schedule_time }),
            ...(formData.schedule_period && { schedule_period: formData.schedule_period }),
            ...(formData.schedule_weekday && { schedule_weekday: formData.schedule_weekday }),
            ...(formData.schedule_monthly_selection_type && { schedule_monthly_selection_type: formData.schedule_monthly_selection_type }),
            ...(formData.schedule_date && { schedule_date: formData.schedule_date }),
            ...(formData.schedule_day_of_week && { schedule_day_of_week: formData.schedule_day_of_week }),
            ...(formData.schedule_week_number && { schedule_week_number: formData.schedule_week_number }),
            ...(formData.schedule_monthly_date_format && { schedule_monthly_date_format: formData.schedule_monthly_date_format }),
            ...(formData.schedule_every_n_months && { schedule_every_n_months: formData.schedule_every_n_months }),
            ...(formData.schedule_selection_type && { schedule_selection_type: formData.schedule_selection_type }),
            ...(formData.schedule_month && { schedule_month: formData.schedule_month }),
            ...(formData.schedule_yearly_format && { schedule_yearly_format: formData.schedule_yearly_format }),

            created_by_username: currentUser.username || currentUser.name || null,
            created_by_role: currentUser.role || null,
            role: currentUser.role_name || currentUser.role || null,
            created_by_email: currentUser.email || null,
            created_by_ulb_id: currentUser.ulb_id || null,
            entryId: currentEntryId
        };

        if (currentEntryId && !isNaN(parseInt(currentEntryId))) {
            submissionData.entryId = currentEntryId;
        }

        const response = await fetchWithAuth(`${API_BASE}/form-submissions`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-user-id": currentUser.id
            },
            body: JSON.stringify(submissionData),
        });

        if (!response.ok) {
            if (response.status === 401) {
                console.log('⚠️ Session expired while saving');
                throw new Error('Session expired');
            }
            const errorText = await response.text();
            throw new Error(`HTTP error ${response.status}: ${errorText}`);
        }

        const result = await response.json();

        if (!result.success) {
            throw new Error(result.message || "Failed to save");
        }

        const submissionId = result.data?.submissionId;

        message.success(status === "draft"
            ? (selectedLanguage === 'english' ? "Draft saved!" : "मसुदा जतन केला!")
            : (selectedLanguage === 'english' ? "Form submitted!" : "फॉर्म सबमिट केला!"));

        if (status === 'filled') {
            sessionStorage.setItem(`form_${currentForm.id}_submitted_at`, new Date().toISOString());
            sessionStorage.setItem(`form_${currentForm.id}_submitted`, 'true');

            setConfirmSubmit(false);
            if (!isMultiEntry) {
                setFormData({});
                setCurrentForm(null);
                setViewMode("list");
                await fetchAllForms();
            } else {
                const newEntryCount = entries.length + 1;
                const maxEntries = formMetadata?.max_entries_per_user || 0;
                if (maxEntries > 0 && newEntryCount >= maxEntries) {
                    setIsMultiEntryLimitReached(true);
                    setIsFormBlocked(true);
                }
            }
        }

        if (isMultiEntry) {
            await loadAllEntries(currentForm.id, currentUser.id);

            if (status === 'filled') {
                setShowEntrySelector(true);
                setFormData({});
                setCurrentEntryId(null);
                setIsFormBlocked(false);
                setViewFilledMode(false);
            } else {
                if (!currentEntryId && submissionId) {
                    setCurrentEntryId(submissionId);
                }
            }
        } else {
            setViewMode("list");
            setCurrentForm(null);
            setFormData({});
            setFormMetadata(null);
            await fetchAllForms();
        }

        await fetchSLAViolations();

    } catch (error) {
        console.error("❌ Save error:", error);

        if (error.message === 'Session expired') {
            message.error(selectedLanguage === 'english'
                ? 'Session expired. Please login again.'
                : 'सत्र समाप्त झाले. कृपया पुन्हा लॉगिन करा.');
            setTimeout(() => {
                window.location.href = '/login';
            }, 2000);
        } else {
            message.error(selectedLanguage === 'english'
                ? `Error saving form: ${error.message}`
                : `फॉर्म जतन करताना त्रुटी: ${error.message}`);
        }
    } finally {
        setIsSubmitting(false);
    }
};

    // DROPDOWN FIELD RENDERER
    const renderDropdownField = (field) => {
        const label = getFieldLabel(field);
        const placeholder = getPlaceholder(field);
        const required = isRequired(field);
        const error = validationErrors[field.id];
        const defaultValue = field.defaultValue || field.importedExistingValue || '';
        const value = formData[field.id] !== undefined ? formData[field.id] : defaultValue;
        const options = getOptions(field);

        const allowSearch = field.allowSearch === true;
        const allowMultiSelect = field.allowMultiSelect === true;

        if (printMode) {
            const selectedOption = value;
            return (
                <div key={field.id} className="print-field">
                    <span className="print-label">{label}:</span>
                    <span className="print-value">{selectedOption || 'Not selected'}</span>
                </div>
            );
        }

        return (
            <div key={field.id} style={{ marginBottom: '24px' }}>
                <div style={{
                    marginBottom: '6px',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    color: error ? '#ff4444' : '#333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <span>
                        {label}
                        {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                    </span>
                    {allowSearch && (
                        <Tag color="blue" style={{ fontSize: '11px' }}>
                            <SearchOutlined /> Searchable
                        </Tag>
                    )}
                    {allowMultiSelect && (
                        <Tag color="green" style={{ fontSize: '11px' }}>
                            <CheckSquareOutlined /> Multi-select
                        </Tag>
                    )}
                </div>

                <Select
                    placeholder={placeholder || (selectedLanguage === 'english' ? 'Select an option...' : 'पर्याय निवडा...')}
                    style={{ width: '100%' }}
                    value={value}
                    onChange={(val) => handleFieldChange(field.id, val)}
                    disabled={isFormBlocked || viewFilledMode}
                    allowClear={!required}
                    showSearch={allowSearch}
                    mode={allowMultiSelect ? 'multiple' : undefined}
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                        return (option?.children?.toString()?.toLowerCase() || '').includes(input.toLowerCase());
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                >
                    {options.map((option, idx) => (
                        <Option key={idx} value={option}>
                            {option}
                        </Option>
                    ))}
                </Select>

                {error && (
                    <div style={{
                        color: '#ff4444',
                        fontSize: '12px',
                        marginTop: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        backgroundColor: '#ffebee',
                        padding: '6px 10px',
                        borderRadius: '4px'
                    }}>
                        <ExclamationCircleOutlined />
                        {error}
                    </div>
                )}
            </div>
        );
    };

    const renderFileUploadField = (field) => {
        const label = getFieldLabel(field);
        const required = isRequired(field);
        const error = validationErrors[field.id];
        const fileList = formData[field.id] || [];

        const handleFileChange = (info) => {
            const { file, fileList: newFileList } = info;

            if (file.status === 'removed') {
                handleFileDelete(field.id, file);
            }

            const processedList = newFileList.map(f => ({
                ...f,
                status: f.status || 'done'
            }));

            handleFieldChange(field.id, processedList);
        };

        const customRequest = ({ file, onSuccess, onError, onProgress }) => {
            handleFileUpload(field.id, file, onSuccess, onError, onProgress);
        };

        const beforeUpload = (file) => {
            if (field.acceptedFileTypes) {
                const acceptedTypes = field.acceptedFileTypes.split(',').map(type => type.trim().toLowerCase());
                const fileExt = '.' + file.name.split('.').pop().toLowerCase();

                if (!acceptedTypes.includes(fileExt) && !acceptedTypes.includes('*/*')) {
                    message.error(`${file.name} is not an accepted file type. Accepted: ${field.acceptedFileTypes}`);
                    return Upload.LIST_IGNORE;
                }
            }

            if (field.maxFileSize && file.size > field.maxFileSize * 1024 * 1024) {
                message.error(`${file.name} is larger than ${field.maxFileSize}MB`);
                return Upload.LIST_IGNORE;
            }

            return true;
        };

        if (printMode) {
            return (
                <div key={field.id} className="print-field">
                    <span className="print-label">{label}:</span>
                    <span className="print-value">{fileList.length > 0 ? `${fileList.length} file(s)` : 'No files'}</span>
                </div>
            );
        }

        return (
            <div key={field.id} style={{
                marginBottom: '24px',
                padding: '16px',
                border: error ? '2px solid #ff4444' : '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: '#ffffff'
            }}>
                <div style={{
                    fontWeight: '600',
                    marginBottom: '12px',
                    fontSize: '13px', 
                    color: error ? '#ff4444' : '#333'
                }}>
                    {label}
                    {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                </div>

                <div>
                    <Upload
                        fileList={fileList}
                        onChange={handleFileChange}
                        customRequest={customRequest}
                        beforeUpload={beforeUpload}
                        multiple={field.maxFileCount > 1}
                        accept={field.acceptedFileTypes}
                        listType="text"
                        showUploadList={{
                            showRemoveIcon: true,
                            showPreviewIcon: true
                        }}
                        onPreview={(file) => {
                            if (file.url) {
                                window.open(file.url, '_blank');
                            } else if (file.response?.url) {
                                window.open(file.response.url, '_blank');
                            }
                        }}
                        onRemove={(file) => {
                            handleFileDelete(field.id, file);
                        }}
                        disabled={isFormBlocked || viewFilledMode}
                    >
                        <Button
                            icon={<UploadOutlined />}
                            disabled={fileList.length >= (field.maxFileCount || 5) || isFormBlocked || viewFilledMode}
                        >
                            {selectedLanguage === 'english' ? 'Upload File' : 'फाइल अपलोड करा'}
                        </Button>
                    </Upload>

                    <div style={{ marginTop: '12px' }}>
                        <Space wrap size={[4, 4]}>
                            {(field.acceptedFileTypes || ".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.txt").split(',').map((type, idx) => (
                                <Tag key={idx} color="blue" style={{ fontSize: '11px' }}>
                                    {type.trim()}
                                </Tag>
                            ))}
                            <Tag color="green">{field.maxFileSize || 5} MB Max</Tag>
                            {field.maxFileCount > 1 && (
                                <Tag color="orange">Max {field.maxFileCount} files</Tag>
                            )}
                        </Space>
                    </div>
                </div>

                {error && (
                    <div style={{ color: '#ff4444', fontSize: '12px', marginTop: '4px' }}>
                        {error}
                    </div>
                )}
            </div>
        );
    };

    const renderImageUploadField = (field) => {
        return renderFileUploadField(field);
    };

    const renderRadioField = (field) => {
        const fieldValue = formData[field.id] || '';
        const options = getOptions(field);
        const label = getFieldLabel(field);
        const required = isRequired(field);
        const error = validationErrors[field.id];

        let allRadioSubFields = [];
        if (currentForm?.schema) {
            allRadioSubFields = currentForm.schema.filter(f =>
                f.parentId === field.id || f.parent_id === field.id
            );
        }

        let subFieldsForOption = [];
        if (fieldValue) {
            subFieldsForOption = allRadioSubFields.filter(f =>
                String(f.colName || '').toLowerCase() === String(fieldValue).toLowerCase()
            );
        }

        if (printMode) {
            return (
                <div key={field.id} className="print-field">
                    <span className="print-label">{label}:</span>
                    <span className="print-value">{fieldValue || 'Not selected'}</span>
                    {fieldValue && subFieldsForOption.length > 0 && (
                        <div style={{ marginLeft: '30px', marginTop: '10px' }}>
                            {subFieldsForOption.map(subField => (
                                <div key={subField.id} style={{ marginBottom: '8px' }}>
                                    <span className="print-label">{getFieldLabel(subField)}:</span>
                                    <span className="print-value">
                                        {subField.type === 'file' || subField.type === 'image'
                                            ? (formData[subField.id]?.length > 0 ? `${formData[subField.id].length} file(s)` : 'Not filled')
                                            : formData[subField.id] || 'Not filled'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div key={field.id} style={{
                marginBottom: '24px',
                padding: '16px',
                border: error ? '2px solid #ff4444' : '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: '#ffffff'
            }}>
                <div style={{
                    fontWeight: '600',
                    marginBottom: '12px',fontSize: '13px', 
                    color: error ? '#ff4444' : '#333'
                }}>
                    {label}
                    {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                </div>

                <div style={{ marginBottom: '16px' }}>
                    {options.map((option, idx) => {
                        const isSelected = fieldValue === option;

                        return (
                            <label
                                key={idx}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '10px',
                                    padding: '10px 12px',
                                    backgroundColor: isSelected ? '#e6f7ff' : '#f9f9f9',
                                    borderRadius: '6px',
                                    border: isSelected ? '2px solid #1890ff' : '1px solid #ddd',
                                    cursor: 'pointer'
                                }}
                            >
                                <input
                                    type="radio"
                                    name={field.id}
                                    value={option}
                                    checked={isSelected}
                                    onChange={(e) => handleFieldChange(field.id, option)}
                                    style={{ marginRight: '12px', cursor: 'pointer' }}
                                    disabled={isFormBlocked || viewFilledMode}
                                />
                                <span>{option}</span>
                            </label>
                        );
                    })}
                </div>

                {error && (
                    <div style={{ color: '#ff4444', fontSize: '12px', marginTop: '4px' }}>
                        {error}
                    </div>
                )}

                {fieldValue && subFieldsForOption.length > 0 && (
                    <div style={{
                        marginTop: '20px',
                        padding: '16px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '6px',
                        borderLeft: '3px solid #1890ff'
                    }}>
                        {subFieldsForOption.map(subField => (
                            <div key={subField.id} style={{ marginBottom: '16px' }}>
                                <div style={{ marginBottom: '6px', fontWeight: '500' }}>
                                    {getFieldLabel(subField)}
                                    {isRequired(subField) && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                                </div>
                                {renderSubField(subField)}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

   const renderCheckboxField = (field) => {
    const label = getFieldLabel(field);
    const options = getOptions(field);
    const required = isRequired(field);
    const error = validationErrors[field.id];

    const rawSelectedValues = formData[field.id];
    const selectedValues = Array.isArray(rawSelectedValues) ? rawSelectedValues : [];

    let allCheckboxSubFields = [];
    if (currentForm?.schema) {
        allCheckboxSubFields = currentForm.schema.filter(f =>
            f.parentId === field.id || f.parent_id === field.id
        );
    }

    const subFieldsByOption = {};
    allCheckboxSubFields.forEach(subField => {
        const option = subField.colName;
        if (option) {
            if (!subFieldsByOption[option]) {
                subFieldsByOption[option] = [];
            }
            subFieldsByOption[option].push(subField);
        }
    });

    const handleCheckboxChange = (option) => {
        const currentSelected = Array.isArray(formData[field.id]) ? formData[field.id] : [];
        let newSelectedValues = [...currentSelected];

        if (newSelectedValues.includes(option)) {
            newSelectedValues = newSelectedValues.filter(v => v !== option);
            const subFieldsToRemove = subFieldsByOption[option] || [];
            setFormData(prev => {
                const newData = { ...prev };
                subFieldsToRemove.forEach(subField => {
                    delete newData[subField.id];
                });
                return newData;
            });
        } else {
            newSelectedValues.push(option);
        }

        handleFieldChange(field.id, newSelectedValues);
    };

    if (printMode) {
        return (
            <div key={field.id} className="print-field">
                <span className="print-label">{label}:</span>
                <span className="print-value">
                    {selectedValues.length > 0 ? selectedValues.join(', ') : 'Not selected'}
                </span>
                {selectedValues.length > 0 && (
                    <div style={{ marginLeft: '30px', marginTop: '10px' }}>
                        {selectedValues.map(selectedOption => {
                            const optionSubFields = subFieldsByOption[selectedOption] || [];
                            return optionSubFields.map(subField => (
                                <div key={subField.id} style={{ marginBottom: '8px' }}>
                                    <span className="print-label">{getFieldLabel(subField)}:</span>
                                    <span className="print-value">
                                        {subField.type === 'file' || subField.type === 'image'
                                            ? (formData[subField.id]?.length > 0 ? `${formData[subField.id].length} file(s)` : 'Not filled')
                                            : formData[subField.id] || 'Not filled'}
                                    </span>
                                </div>
                            ));
                        })}
                    </div>
                )}
            </div>
        );
    }

    return (
        <div key={field.id} style={{
            marginBottom: '24px',
            padding: '16px',
            border: error ? '2px solid #ff4444' : '1px solid #e0e0e0',
            borderRadius: '8px',
            backgroundColor: '#ffffff'
        }}>
            <div style={{
                fontWeight: '600',
                marginBottom: '12px',fontSize: '13px', 
                color: error ? '#ff4444' : '#333'
            }}>
                {label}
                {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
            </div>

            <div style={{ marginBottom: '16px' }}>
                {options.map((option, idx) => (
                    <label
                        key={idx}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            padding: '10px 12px',
                            backgroundColor: selectedValues.includes(option) ? '#e6f7ff' : '#f9f9f9',
                            borderRadius: '6px',
                            border: selectedValues.includes(option) ? '2px solid #52c41a' : '1px solid #ddd',
                            cursor: 'pointer'
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={selectedValues.includes(option)}
                            onChange={() => handleCheckboxChange(option)}
                            style={{ marginRight: '12px', cursor: 'pointer', width: '16px', height: '16px' }}
                            disabled={isFormBlocked || viewFilledMode}
                        />
                        <span style={{ fontSize: '14px' }}>{option}</span>
                    </label>
                ))}
            </div>

            {error && (
                <div style={{ color: '#ff4444', fontSize: '12px', marginTop: '4px' }}>
                    {error}
                </div>
            )}

            {/* ✅ Subfields - फक्त selected options साठी */}
            {selectedValues.length > 0 && !viewFilledMode && (
                <div style={{ marginTop: '20px' }}>
                    {selectedValues.map(selectedOption => {
                        const optionSubFields = subFieldsByOption[selectedOption] || [];
                        if (optionSubFields.length === 0) return null;

                        return (
                            <div key={selectedOption} style={{
                                marginBottom: '20px',
                                padding: '16px',
                                backgroundColor: '#f9f9f9',
                                borderRadius: '8px',
                                borderLeft: '3px solid #52c41a'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginBottom: '12px',
                                    paddingBottom: '8px',
                                    borderBottom: '1px dashed #b7eb8f'
                                }}>
                                    <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                    <span style={{ fontWeight: '600', color: '#2e7d32' }}>
                                        {selectedLanguage === 'english'
                                            ? `Fields for "${selectedOption}"`
                                            : `"${selectedOption}" साठी फील्ड`}
                                    </span>
                                </div>

                                {optionSubFields.map(subField => (
                                    <div key={subField.id} style={{ marginBottom: '16px' }}>
                                        <div style={{ marginBottom: '6px', fontWeight: '500' }}>
                                            {getFieldLabel(subField)}
                                            {isRequired(subField) && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                                        </div>
                                        {renderSubField(subField)}
                                    </div>
                                ))}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};
    // Helper to render a number input with unit and words - WITH EXACT LENGTH LIMIT
    const renderNumberInputWithUnit = (numField, fieldId, value, onChange) => {
        const unitInfo = getFieldUnitInfo(numField);
        const inputError = validationErrors[fieldId];
        const fieldValue = value;

        // ✅ GET VALIDATION RULES
        const validation = numField?.validation || {};
        const exactLength = validation.exactLength;
        const decimalPlaces = validation.decimalPlaces;
        const allowNegative = validation.allowNegative !== false;
        const allowZero = validation.allowZero !== false;
        const integerOnly = validation.integerOnly === true;

        // ✅ VALIDATION RESULT
        const validationResult = validateFieldValue(numField, fieldValue);
        const showError = inputError || (!validationResult.valid && fieldValue !== '');

        let words = '';
        if (fieldValue !== '' && fieldValue !== null && fieldValue !== undefined) {
            const numValue = parseFloat(fieldValue);
            if (!isNaN(numValue)) {
                const unitForConversion = unitInfo.hasUnit ? (unitInfo.unitCategory || 'none') : 'none';
                words = numberToWords(fieldValue, selectedLanguage, unitForConversion);
                if (unitInfo.hasUnit && unitInfo.displayLabel && !words.includes(unitInfo.displayLabel)) {
                    words = `${words} ${unitInfo.displayLabel}`;
                }
            }
        }

        // ✅ DIGIT COUNT DISPLAY
        const getDigitCount = (val) => {
            if (!val && val !== 0) return 0;
            const strVal = String(val);
            return strVal.replace('-', '').replace('.', '').length;
        };

        // ✅ HANDLE INPUT WITH EXACT LENGTH LIMIT
        const handleNumberChange = (e) => {
    let newValue = e.target.value;
    
    console.log('🔍 Raw input:', newValue);

    // ✅ EXACT LENGTH VALIDATION - Limit digits
    if (exactLength && newValue !== '') {
        // Remove non-digit characters for counting
        let digitsOnly = newValue.replace(/[^0-9]/g, '');
        
        // Check if we have a decimal point
        const decimalIndex = newValue.indexOf('.');
        
        if (decimalIndex !== -1) {
            // Keep the integer part limited
            const integerPart = newValue.substring(0, decimalIndex);
            const decimalPart = newValue.substring(decimalIndex + 1);
            
            // Count digits in integer part only
            const integerDigits = integerPart.replace(/[^0-9]/g, '').length;
            
            if (integerDigits > exactLength) {
                // Limit integer part
                const limitedInteger = integerPart.slice(0, exactLength);
                newValue = limitedInteger + '.' + decimalPart;
            }
        } else {
            // No decimal, limit all digits
            const allDigits = newValue.replace(/[^0-9]/g, '');
            if (allDigits.length > exactLength) {
                newValue = allDigits.slice(0, exactLength);
            }
        }
    }

    if (newValue === '') {
        onChange('');
        setValidationErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[fieldId];
            return newErrors;
        });
        return;
    }

    // 🔥 CRITICAL FIX: Store the EXACT string value for display
    // Don't convert to number for display purposes
    // Keep it as string to preserve leading zeros and decimal format
    
    // For validation and storage, we need numeric value
    // But we must preserve the EXACT string for display
    
    // First, validate the value
    const currentValidationResult = validateFieldValue(numField, newValue);
    if (!currentValidationResult.valid && newValue !== '') {
        setValidationErrors(prev => ({
            ...prev,
            [fieldId]: currentValidationResult.message
        }));
    } else {
        setValidationErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors[fieldId];
            return newErrors;
        });
    }
    
    // 🔥 CRITICAL: Store as string to preserve exact format including leading zeros
    // But convert to number for arithmetic calculations elsewhere
    // For now, store the string as is
    onChange(newValue);  // Store as string, not number
};

        return (
            <div style={{ marginBottom: '12px' }}>
                <div style={{ marginBottom: '4px', fontSize: '13px', fontWeight: '500' }}>
                    {selectedLanguage === 'english' ? numField?.enLabel : numField?.mrLabel}
                    {(selectedLanguage === 'english' ? numField?.enRequired : numField?.mrRequired) &&
                        <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                    {unitInfo.hasUnit && unitInfo.displayLabel && (
                        <span style={{
                            fontWeight: 'normal',
                            fontSize: '13px',
                            color: '#666',
                            marginLeft: '6px'
                        }}>
                            ({selectedLanguage === 'english' ? 'in' : 'मध्ये'} {unitInfo.displayLabel})
                        </span>
                    )}
                </div>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    background: '#fff',
                    border: showError ? '2px solid #ff4444' : '1px solid #ddd',
                    borderRadius: '4px',
                    padding: '4px 8px'
                }}>
                    <input
                        type="text"
                        inputMode="numeric"
                        value={fieldValue}
                        onChange={handleNumberChange}
                        placeholder={selectedLanguage === 'english' ? numField?.enPlaceholder : numField?.mrPlaceholder}
                        style={{
                            flex: 1,
                            padding: '8px',
                            border: 'none',
                            fontSize: '14px',
                            outline: 'none',
                            background: 'transparent'
                        }}
                        disabled={isFormBlocked || viewFilledMode}
                    />
                    {unitInfo.hasUnit && unitInfo.displaySymbol && (
                        <span style={{
                            fontSize: '14px',
                            color: '#999',
                            padding: '0 4px',
                            borderLeft: '1px solid #eee',
                            marginLeft: '4px'
                        }}>
                            {unitInfo.displaySymbol}
                        </span>
                    )}
                </div>

                {/* ✅ EXACT LENGTH INDICATOR */}
                {exactLength && fieldValue !== '' && fieldValue !== null && fieldValue !== undefined && !viewFilledMode && (
                    <div style={{
                        fontSize: '11px',
                        color: '#999',
                        marginTop: '4px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <span>
                            {selectedLanguage === 'english' ? 'Digits:' : 'अंक:'} {getDigitCount(fieldValue)}
                        </span>
                        <span style={{
                            color: getDigitCount(fieldValue) > exactLength ? '#ff4444' : '#52c41a',
                            fontWeight: getDigitCount(fieldValue) > exactLength ? 'bold' : 'normal'
                        }}>
                            {getDigitCount(fieldValue)}/{exactLength}
                        </span>
                    </div>
                )}

                {/* ✅ VALIDATION RULES TAGS */}
                {/* {(exactLength || decimalPlaces || integerOnly || !allowNegative || !allowZero) &&
                 fieldValue !== '' && !showError && !viewFilledMode && (
                    <div style={{ marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {exactLength && <Tag color="orange" style={{ fontSize: '10px' }}>📏 Exact: {exactLength} digits</Tag>}
                        {decimalPlaces && decimalPlaces > 0 && <Tag color="cyan" style={{ fontSize: '10px' }}>🔢 {decimalPlaces} decimal(s)</Tag>}
                        {integerOnly && <Tag color="purple" style={{ fontSize: '10px' }}>🔢 Integer only</Tag>}
                        {!allowNegative && <Tag color="orange" style={{ fontSize: '10px' }}>➕ Positive only</Tag>}
                        {!allowZero && <Tag color="red" style={{ fontSize: '10px' }}>🚫 No zero</Tag>}
                    </div>
                )} */}

                {/* Words display */}
                {fieldValue !== '' && fieldValue !== null && fieldValue !== undefined && !showError && !viewFilledMode && words && (
                    <div style={{
                        marginTop: '6px',
                        padding: '6px 10px',
                        background: '#f6ffed',
                        border: '1px solid #b7eb8f',
                        borderRadius: '6px',
                        fontSize: '11px',
                        color: '#389e0d'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <FileTextOutlined style={{ color: '#52c41a', fontSize: '11px' }} />
                            <span style={{ fontWeight: '500' }}>
                                {selectedLanguage === 'english' ? 'In Words:' : 'शब्दांमध्ये:'}
                            </span>
                        </div>
                        <div style={{ paddingLeft: '16px', fontStyle: 'italic' }}>
                            {words}
                        </div>
                    </div>
                )}

                {showError && (
                    <div style={{ color: '#ff4444', fontSize: '11px', marginTop: '4px' }}>
                        {inputError || validationResult.message}
                    </div>
                )}
            </div>
        );
    };
    
const renderComparisonField = (field) => {
    const label = getFieldLabel(field);
    const required = isRequired(field);
    const error = validationErrors[field.id];

    const mainField = field.mainField;
    const subFields = field.subFields || [];
    const operator = field.comparisonOperator || 'equals';

    const rawMainValue = formData[mainField?.id] || '';
    const mainValue = (rawMainValue === 0 || rawMainValue === '0') ? 0 : rawMainValue;
    
    const calculatedValue = calculateComparisonResult(subFields, formData);
    const isValid = mainValue !== '' && mainValue !== null && mainValue !== undefined ? checkComparison(mainValue, calculatedValue, operator) : null;
    const customValidationMessage = field.customValidationMessage || (selectedLanguage === 'english' ? 'Invalid' : 'चुकीचे');
    
    const getOperatorLabel = () => {
        const op = COMPARISON_OPERATORS.find(op => op.value === operator);
        return op ? op.label : 'Equals';
    };

    const getFieldUnitInfo = (numField) => {
        let unitCategory = null;
        let unitSymbol = null;
        let unitLabel = null;
        let hasUnit = false;

        if (numField) {
            if (numField.units_enabled === '1' || numField.units_enabled === 1 || numField.units_enabled === true) {
                hasUnit = true;
                unitCategory = numField.units_category;
                unitSymbol = numField.units_symbol;
                unitLabel = numField.units_selected_unit || numField.units_label;
            }
            else if (numField.units && typeof numField.units === 'object') {
                if (numField.units.enabled === '1' || numField.units.enabled === true || numField.units.selectedUnit) {
                    hasUnit = true;
                    unitCategory = numField.units.category || numField.units.unit_category;
                    unitSymbol = numField.units.symbol;
                    unitLabel = numField.units.selectedUnit || numField.units.label;
                }
            }
            else if (numField.selectedUnit) {
                hasUnit = true;
                unitLabel = numField.selectedUnit;
                unitSymbol = numField.unit_symbol;
                unitCategory = numField.unit_category;
            }
        }

        const displaySymbol = hasUnit ? (unitSymbol || unitLabel || unitCategory) : null;
        const displayLabel = hasUnit ? (unitLabel || unitCategory || 'unit') : '';

        return { hasUnit, displaySymbol, displayLabel, unitCategory };
    };

    // 🔥 PRINT MODE - Simple text format (NO BOXES)
    if (printMode) {
        return (
            <div key={field.id} style={{ marginBottom: '20px' }}>
                <div style={{ marginBottom: '8px', fontWeight: 'bold', fontSize: '15px', borderBottom: '1px solid #ccc', paddingBottom: '4px' }}>
                    {label}
                    {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                </div>

                <div style={{ marginLeft: '20px' }}>
                    {/* Main Value */}
                    <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <span style={{ minWidth: '120px', fontWeight: '500' }}>
                            {mainField ? (selectedLanguage === 'english' ? mainField.enLabel : mainField.mrLabel) : 'Main Value'}:
                        </span>
                        <span style={{ padding: '4px 8px', border: '1px solid #ccc', borderRadius: '3px', minWidth: '100px', background: '#fafafa' }}>
                            {mainValue !== '' && mainValue !== null && mainValue !== undefined ? mainValue : 'Not filled'}
                        </span>
                        {(() => {
                            const unitInfo = mainField ? getFieldUnitInfo(mainField) : null;
                            return unitInfo?.hasUnit && unitInfo.displaySymbol ? (
                                <span style={{ fontSize: '13px', color: '#666' }}>{unitInfo.displaySymbol}</span>
                            ) : null;
                        })()}
                    </div>

                    {/* Condition */}
                    <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        <span style={{ minWidth: '120px', fontWeight: '500' }}>Condition:</span>
                        <span>{getOperatorLabel()}</span>
                    </div>

                    {/* Sub Fields */}
                    {subFields.length > 0 && (
                        <div style={{ marginBottom: '8px' }}>
                            <div style={{ marginBottom: '4px', fontWeight: '500' }}>Values:</div>
                            <div style={{ marginLeft: '20px' }}>
                                {subFields.map((subField, idx) => (
                                    <div key={subField.id} style={{ marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                        <span style={{ minWidth: '100px' }}>
                                            {selectedLanguage === 'english' ? subField.enLabel : subField.mrLabel}:
                                        </span>
                                        <span style={{ padding: '4px 8px', border: '1px solid #ccc', borderRadius: '3px', minWidth: '80px', background: '#fafafa' }}>
                                            {formData[subField.id] !== undefined && formData[subField.id] !== '' ? formData[subField.id] : '0'}
                                        </span>
                                        {(() => {
                                            const unitInfo = getFieldUnitInfo(subField);
                                            return unitInfo.hasUnit && unitInfo.displaySymbol ? (
                                                <span style={{ fontSize: '13px', color: '#666' }}>{unitInfo.displaySymbol}</span>
                                            ) : null;
                                        })()}
                                        {idx < subFields.length - 1 && (
                                            <span style={{ color: '#999' }}>
                                                {operator === 'add' ? '+' : operator === 'subtract' ? '-' : operator === 'multiply' ? '×' : operator === 'divide' ? '÷' : '+'}
                                            </span>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Status Message - Only show error when condition fails */}
                    {mainValue && isValid === false && (
                        <div style={{ marginTop: '8px', padding: '6px 10px', background: '#fff0f0', borderLeft: '3px solid #f44336', fontSize: '12px', color: '#d32f2f' }}>
                            ✗ {customValidationMessage}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    // 🔥 EDIT MODE - Only show error message when condition is wrong, no calculated value display
    return (
        <div key={field.id} style={{ marginBottom: '24px' }}>
            <div style={{
                marginBottom: '6px',
                fontWeight: 'bold',
                fontSize: '14px',
                color: error ? '#ff4444' : '#333'
            }}>
                {label}
                {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
            </div>

            {/* Main Field Input */}
            {mainField && renderNumberInputWithUnit(
                mainField,
                mainField.id,
                mainValue === 0 ? 0 : mainValue, 
                (val) => handleFieldChange(mainField.id, val)
            )}

            {/* Sub Fields Inputs */}
            {subFields.length > 0 && (
                <div>
                    {subFields.map((subField, idx) => (
                        <div key={subField.id}>
                            {renderNumberInputWithUnit(
                                subField,
                                subField.id,
                                formData[subField.id] || '',
                                (val) => handleFieldChange(subField.id, val)
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* ONLY show error message when condition is wrong - NO calculated value display */}
            {mainValue && isValid === false && !viewFilledMode && (
                <div style={{
                    marginTop: '12px',
                    padding: '8px 12px',
                    background: '#fff1f0',
                    border: '1px solid #ffa39e',
                    borderRadius: '4px',
                    fontSize: '13px',
                    color: '#f5222d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <CloseCircleOutlined />
                    {customValidationMessage}
                </div>
            )}

            {error && (
                <div style={{ color: '#ff4444', fontSize: '12px', marginTop: '4px' }}>
                    {error}
                </div>
            )}
        </div>
    );
};
// Add this BEFORE renderArithmeticField function (around line where other helpers are defined)

const getFieldUnitInfo = (numField) => {
    let unitCategory = null;
    let unitSymbol = null;
    let unitLabel = null;
    let hasUnit = false;
    let unitValue = 1;

    if (numField) {
        if (numField.units_enabled === '1' || numField.units_enabled === 1 || numField.units_enabled === true) {
            hasUnit = true;
            unitCategory = numField.units_category;
            unitSymbol = numField.units_symbol;
            unitLabel = numField.units_selected_unit || numField.units_label;
            unitValue = numField.units_value || 1;
        }
        else if (numField.units && typeof numField.units === 'object') {
            if (numField.units.enabled === '1' || numField.units.enabled === true || numField.units.selectedUnit) {
                hasUnit = true;
                unitCategory = numField.units.category || numField.units.unit_category;
                unitSymbol = numField.units.symbol;
                unitLabel = numField.units.selectedUnit || numField.units.label;
                unitValue = numField.units.value || 1;
            }
        }
        else if (numField.selectedUnit) {
            hasUnit = true;
            unitLabel = numField.selectedUnit;
            unitSymbol = numField.unit_symbol;
            unitCategory = numField.unit_category;
        }
    }

    const displaySymbol = hasUnit ? (unitSymbol || unitLabel || unitCategory) : null;
    const displayLabel = hasUnit ? (unitLabel || unitCategory || 'unit') : '';

    return { hasUnit, displaySymbol, displayLabel, unitCategory, unitValue };
};
const renderArithmeticField = (field) => {
    const label = getFieldLabel(field);
    const helpText = selectedLanguage === 'english' ? field.enHelpText : field.mrHelpText;
    const arithmeticFields = field.arithmeticFields || [];
    const operator = field.arithmeticOperator || 'add';
    const required = isRequired(field);
    const error = validationErrors[field.id];

    // Helper: apply number validation (same as AcceptForms)
    const applyNumberValidation = (fieldData, value) => {
        const validation = fieldData?.validation || {};
        let transformed = value === null || value === undefined ? '' : String(value);
        let errorMsg = null;
        const exactLength = validation.exactLength;
        const isIntegerOnly = validation.integerOnly === true;
        const allowDecimals = validation.allowDecimals !== false && !isIntegerOnly;
        const allowNegative = validation.allowNegative === true;

        if (!value && value !== 0) return { transformed: '', error: null };

        // For integer-only fields: strip decimal points completely
        if (isIntegerOnly) {
            transformed = transformed.replace(/\./g, '');
            if (allowNegative) {
                transformed = transformed.replace(/[^-0-9]/g, '');
                if (transformed.indexOf('-') > 0) transformed = transformed.replace(/-/g, '');
                if (transformed === '-') transformed = '';
            } else {
                transformed = transformed.replace(/[^0-9]/g, '');
            }
            return { transformed: transformed === '' ? '' : transformed, error: null };
        }

        // For decimal fields: allow decimal point and proper formatting
        if (typeof transformed === 'string') {
            // First, remove any invalid characters
            if (allowNegative && allowDecimals) {
                transformed = transformed.replace(/[^-0-9.]/g, '');
            } else if (allowNegative && !allowDecimals) {
                transformed = transformed.replace(/[^-0-9]/g, '');
            } else if (!allowNegative && allowDecimals) {
                transformed = transformed.replace(/[^0-9.]/g, '');
            } else {
                transformed = transformed.replace(/[^0-9]/g, '');
            }
        }

        // Handle multiple decimal points - keep only first one
        if (allowDecimals && typeof transformed === 'string') {
            const decimalCount = (transformed.match(/\./g) || []).length;
            if (decimalCount > 1) {
                const firstIndex = transformed.indexOf('.');
                transformed = transformed.substring(0, firstIndex + 1) +
                              transformed.substring(firstIndex + 1).replace(/\./g, '');
            }
        } else if (!allowDecimals) {
            transformed = transformed.replace(/\./g, '');
        }

        // Handle negative sign placement
        if (typeof transformed === 'string') {
            if (!allowNegative && transformed.includes('-')) {
                errorMsg = "✗ Negative numbers are not allowed";
                transformed = transformed.replace(/-/g, '');
            } else if (allowNegative && transformed.includes('-')) {
                // Ensure negative sign is only at the beginning
                if (transformed.indexOf('-') !== 0) {
                    transformed = '-' + transformed.replace(/-/g, '');
                }
                const negativeCount = (transformed.match(/-/g) || []).length;
                if (negativeCount > 1) {
                    transformed = '-' + transformed.replace(/-/g, '');
                }
            }
        }

        // Exact digit length validation
        if (exactLength && transformed && !errorMsg && typeof transformed === 'string') {
            const digitsOnly = transformed.replace(/[^0-9]/g, '');
            if (digitsOnly.length > exactLength) {
                const allowedDigits = digitsOnly.slice(0, exactLength);
                const hasNegative = transformed.startsWith('-');

                if (allowDecimals && transformed.includes('.')) {
                    const decimalPart = transformed.slice(transformed.indexOf('.') + 1);
                    const limitedDecimal = decimalPart.slice(0, validation.decimalPlaces || decimalPart.length);
                    transformed = (hasNegative ? '-' : '') + allowedDigits + '.' + limitedDecimal;
                } else {
                    transformed = (hasNegative ? '-' : '') + allowedDigits;
                }
            }
        }

        // Apply decimal places limit
        const numValue = parseFloat(transformed);
        if (!isNaN(numValue) && transformed !== '' && typeof transformed === 'string') {
            if (validation.allowZero === false && numValue === 0) {
                errorMsg = "✗ Zero is not allowed";
                transformed = '';
            }
            if (validation.decimalPlaces && validation.decimalPlaces > 0 && allowDecimals && transformed.includes('.')) {
                const parts = transformed.split('.');
                if (parts[1] && parts[1].length > validation.decimalPlaces) {
                    transformed = numValue.toFixed(validation.decimalPlaces);
                }
            }
            if (!allowDecimals && transformed.includes('.')) {
                errorMsg = "✗ Decimals are not allowed";
                transformed = Math.floor(numValue).toString();
            }
        }

        return { transformed: transformed === '' ? '' : transformed, error: errorMsg };
    };

    // Helper to get unit info
    const getFieldUnitInfo = (numField) => {
        let unitCategory = null;
        let unitSymbol = null;
        let unitLabel = null;
        let hasUnit = false;

        if (numField) {
            if (numField.units_enabled === '1' || numField.units_enabled === 1 || numField.units_enabled === true) {
                hasUnit = true;
                unitCategory = numField.units_category;
                unitSymbol = numField.units_symbol;
                unitLabel = numField.units_selected_unit || numField.units_label;
            }
            else if (numField.units && typeof numField.units === 'object') {
                if (numField.units.enabled === '1' || numField.units.enabled === true || numField.units.selectedUnit) {
                    hasUnit = true;
                    unitCategory = numField.units.category || numField.units.unit_category;
                    unitSymbol = numField.units.symbol;
                    unitLabel = numField.units.selectedUnit || numField.units.label;
                }
            }
            else if (numField.selectedUnit) {
                hasUnit = true;
                unitLabel = numField.selectedUnit;
                unitSymbol = numField.unit_symbol;
                unitCategory = numField.unit_category;
            }
        }

        const displaySymbol = hasUnit ? (unitSymbol || unitLabel || unitCategory) : null;
        const displayLabel = hasUnit ? (unitLabel || unitCategory || 'unit') : '';

        return { hasUnit, displaySymbol, displayLabel, unitCategory };
    };

    // Calculate result with validation
    let calculatedResult = 0;
    let validationErrorsList = [];
    let allFieldsValid = true;
    const validatedNumbers = [];

    if (arithmeticFields.length > 0) {
        for (let idx = 0; idx < arithmeticFields.length; idx++) {
            const afield = arithmeticFields[idx];
            const currentValue = formData[afield.id] !== undefined ? formData[afield.id] : '';

            // Skip validation for constant fields (they don't need user input)
            const isConstant = afield.fieldType === 'constant' || afield.constantValue !== undefined;

            if (isConstant) {
                let constantValue = afield.constantValue;
                if (constantValue === undefined) {
                    constantValue = afield.defaultValue || 0;
                }
                const numericValue = parseFloat(constantValue) || 0;
                validatedNumbers.push({ value: numericValue, valid: true, isConstant: true });
                continue;
            }

            // Validate each user input field
            const validationResult = validateFieldValue(afield, currentValue);

            if (!validationResult.valid && currentValue !== '') {
                validationErrorsList.push({
                    field: afield,
                    error: validationResult.message
                });
                allFieldsValid = false;
                validatedNumbers.push({ value: 0, valid: false });
            } else {
                let numericValue = parseFloat(currentValue) || 0;

                // Apply unit conversion if needed
                const unitInfo = getFieldUnitInfo(afield);
                if (unitInfo.hasUnit && unitInfo.unitCategory) {
                    // Unit conversion logic if needed
                }

                validatedNumbers.push({ value: numericValue, valid: true });
            }
        }
    }

    // Calculate only if all fields valid
    if (allFieldsValid && validatedNumbers.length > 0) {
        const numbers = validatedNumbers.map(v => v.value);

        switch (operator) {
            case "add": calculatedResult = numbers.reduce((a, b) => a + b, 0); break;
            case "subtract": calculatedResult = numbers.reduce((a, b) => a - b); break;
            case "multiply": calculatedResult = numbers.reduce((a, b) => a * b, 1); break;
            case "divide":
                if (numbers.slice(1).some(n => n === 0)) {
                    validationErrorsList.push({ error: "Division by zero is not allowed" });
                    allFieldsValid = false;
                } else {
                    calculatedResult = numbers.reduce((a, b) => a / b);
                }
                break;
            case "average": calculatedResult = numbers.length ? numbers.reduce((a, b) => a + b, 0) / numbers.length : 0; break;
            case "percentage":
                if (numbers.length >= 2) {
                    if (numbers[1] === 0) {
                        validationErrorsList.push({ error: "Base value cannot be zero for percentage calculation" });
                        allFieldsValid = false;
                    } else {
                        calculatedResult = (numbers[0] / numbers[1]) * 100;
                    }
                }
                break;
            default: calculatedResult = numbers.reduce((a, b) => a + b, 0);
        }
    }

    // Get unit for result from first arithmetic field
    const getResultUnit = () => {
        if (arithmeticFields.length === 0) return '';
        const firstField = arithmeticFields[0];
        const unitInfo = getFieldUnitInfo(firstField);
        if (unitInfo.hasUnit) {
            if (unitInfo.displaySymbol && unitInfo.displaySymbol !== '') {
                return unitInfo.displaySymbol;
            }
            if (unitInfo.displayLabel && unitInfo.displayLabel !== '') {
                return unitInfo.displayLabel;
            }
            if (unitInfo.unitCategory && unitInfo.unitCategory !== '') {
                return unitInfo.unitCategory;
            }
        }
        return '';
    };

    const resultUnit = getResultUnit();

    // Get result words
    const getResultWords = () => {
        if (!allFieldsValid || calculatedResult === 0) return '';
        const words = numberToWords(calculatedResult, selectedLanguage, 'none');
        return words;
    };
    const resultWords = getResultWords();

    // Render arithmetic number input with validation
    const renderArithmeticNumberInput = (numField, fieldId, value, onChange, showOperatorText = false, operatorText = '') => {
        const unitInfo = getFieldUnitInfo(numField);

        // Apply validation to display value
        const { transformed: validatedValue, error: validationError } = applyNumberValidation(numField, value);

        // Update formData if validation transformed the value
        if (validatedValue !== value && validatedValue !== undefined && value !== '') {
            setTimeout(() => {
                onChange(validatedValue);
            }, 0);
        }

        const displayValue = validationError ? value : validatedValue;
        const showError = validationErrors[fieldId] || validationError;

        const fieldValidation = numField?.validation || {};
        const isIntegerOnly = fieldValidation.integerOnly === true;
        const exactLength = fieldValidation.exactLength;
        const allowNegative = fieldValidation.allowNegative === true;
        const decimalPlaces = fieldValidation.decimalPlaces;

        const getDigitCount = (val) => {
            if (!val && val !== 0) return 0;
            const strVal = String(val);
            return strVal.replace(/[^0-9]/g, '').length;
        };
        const digitCount = getDigitCount(displayValue);

        let fieldWords = '';
        if (displayValue !== '' && displayValue !== null && !isNaN(parseFloat(displayValue)) && !validationError) {
            const numValue = parseFloat(displayValue);
            if (!isNaN(numValue) && numValue !== 0) {
                fieldWords = numberToWords(displayValue, selectedLanguage, unitInfo.unitCategory || 'none');
                if (unitInfo.hasUnit && unitInfo.displayLabel && !fieldWords.includes(unitInfo.displayLabel)) {
                    fieldWords = `${fieldWords} ${unitInfo.displayLabel}`;
                }
            }
        }

        return (
            <div style={{ marginBottom: '12px' }}>
                <div style={{ marginBottom: '4px', fontSize: '13px', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    {showOperatorText && operatorText && (
                        <span style={{ color: '#666', fontSize: '12px', minWidth: '50px' }}>
                            {operatorText}
                        </span>
                    )}
                    <span>
                        {selectedLanguage === 'english' ? numField?.enLabel : numField?.mrLabel}
                        {(selectedLanguage === 'english' ? numField?.enRequired : numField?.mrRequired) &&
                            <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                        {unitInfo.hasUnit && unitInfo.displayLabel && (
                            <span style={{
                                fontWeight: 'normal',
                                fontSize: '13px',
                                color: '#666',
                                marginLeft: '6px'
                            }}>
                                ({selectedLanguage === 'english' ? 'in' : 'मध्ये'} {unitInfo.displayLabel})
                            </span>
                        )}
                    </span>
                </div>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    background: '#fff',
                    border: showError ? '2px solid #ff4444' : '1px solid #ddd',
                    borderRadius: '4px',
                    padding: '4px 8px',
                    marginLeft: showOperatorText ? '58px' : '0'
                }}>
                    <input
                        type="text"
                        inputMode={isIntegerOnly ? "numeric" : "decimal"}
                        value={displayValue}
                        onChange={(e) => {
                            let newValue = e.target.value;

                            // For integer-only fields
                            if (isIntegerOnly) {
                                newValue = newValue.replace(/\./g, '');
                                if (allowNegative) {
                                    newValue = newValue.replace(/[^-0-9]/g, '');
                                    if (newValue.indexOf('-') > 0) newValue = newValue.replace(/-/g, '');
                                    if (newValue === '-') newValue = '';
                                } else {
                                    newValue = newValue.replace(/[^0-9]/g, '');
                                }

                                if (exactLength && newValue !== '' && newValue !== '-') {
                                    let digitsOnly = newValue.replace(/[^0-9]/g, '');
                                    if (digitsOnly.length > exactLength) {
                                        const allowedDigits = digitsOnly.slice(0, exactLength);
                                        const hasNegative = newValue.startsWith('-');
                                        newValue = (hasNegative ? '-' : '') + allowedDigits;
                                    }
                                }

                                onChange(newValue);
                                return;
                            }

                            // For decimal fields - apply validation
                            const { transformed, error: valError } = applyNumberValidation(numField, newValue);

                            if (valError && transformed) {
                                message.error(valError);
                                setValidationErrors(prev => ({
                                    ...prev,
                                    [fieldId]: valError
                                }));
                            } else {
                                setValidationErrors(prev => {
                                    const newErrors = { ...prev };
                                    delete newErrors[fieldId];
                                    return newErrors;
                                });
                            }

                            onChange(transformed);
                        }}
                        style={{
                            flex: 1,
                            padding: '8px',
                            border: 'none',
                            fontSize: '14px',
                            outline: 'none',
                            background: 'transparent'
                        }}
                        disabled={isFormBlocked || viewFilledMode}
                    />
                    {unitInfo.hasUnit && unitInfo.displaySymbol && (
                        <span style={{
                            fontSize: '14px',
                            color: '#999',
                            padding: '0 4px',
                            borderLeft: '1px solid #eee',
                            marginLeft: '4px'
                        }}>
                            {unitInfo.displaySymbol}
                        </span>
                    )}
                </div>


                {/* Exact length indicator */}
                {exactLength && displayValue !== '' && displayValue !== null && displayValue !== 0 && !showError && !viewFilledMode && !isIntegerOnly && (
                    <div style={{
                        fontSize: '10px',
                        color: '#999',
                        marginTop: '2px',
                        marginLeft: showOperatorText ? '58px' : '0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        maxWidth: '180px'
                    }}>
                        <span>
                            {selectedLanguage === 'english' ? 'Digits:' : 'अंक:'} {digitCount}
                        </span>
                        <span style={{
                            color: digitCount > exactLength ? '#ff4444' : '#52c41a',
                            fontWeight: digitCount > exactLength ? 'bold' : 'normal'
                        }}>
                            {digitCount}/{exactLength}
                        </span>
                    </div>
                )}

                {/* Words display */}
                {fieldWords && !showError && !viewFilledMode && (
                    <div style={{
                        marginTop: '6px',
                        marginLeft: showOperatorText ? '58px' : '0',
                        padding: '4px 8px',
                        background: '#f6ffed',
                        border: '1px solid #b7eb8f',
                        borderRadius: '4px',
                        fontSize: '13px'
                    }}>
                        <Space size={4}>
                            <FileTextOutlined style={{ color: '#52c41a', fontSize: '13px' }} />
                            <Text type="secondary" style={{ fontSize: '10px' }}>
                                {selectedLanguage === 'english' ? 'In words:' : 'शब्दांत:'}
                            </Text>
                            <Text style={{ color: '#389e0d', fontSize: '10px' }}>{fieldWords}</Text>
                        </Space>
                    </div>
                )}

                {/* Error display */}
                {showError && (
                    <div style={{ color: '#ff4444', fontSize: '11px', marginTop: '4px', marginLeft: showOperatorText ? '58px' : '0' }}>
                        {validationErrors[fieldId] || validationError}
                    </div>
                )}
            </div>
        );
    };

    if (printMode) {
        return (
            <div key={field.id} className="print-field">
                <span className="print-label">{label}:</span>
                <div style={{ marginLeft: '20px', marginTop: '5px' }}>
                    {arithmeticFields.map((afield) => {
                        const isConstant = afield.fieldType === 'constant' || afield.constantValue !== undefined;
                        const displayValue = isConstant ? (afield.constantValue || afield.defaultValue || 0) : (formData[afield.id] || 'Not filled');
                        return (
                            <div key={afield.id}>
                                <span className="print-label">{getFieldLabel(afield)}:</span>
                                <span className="print-value">{displayValue}</span>
                            </div>
                        );
                    })}
                    <div style={{ marginTop: '10px', fontWeight: 'bold' }}>
                        <span className="print-label">Total {label}:</span>
                        <span className="print-value">
                            {allFieldsValid ? calculatedResult.toFixed(2) : 'Invalid'} {resultUnit}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    // MAIN UI
    return (
        <div key={field.id} style={{ marginBottom: '24px' }}>
            {/* Label */}
            <div style={{
                marginBottom: '6px',
                fontWeight: 'bold',
                fontSize: '14px',
                color: error ? '#ff4444' : '#333'
            }}>
                {label}
                {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
            </div>

            {/* Validation Errors Summary */}
            {validationErrorsList.length > 0 && !allFieldsValid && (
                <div style={{
                    marginBottom: '16px',
                    padding: '12px',
                    background: '#fff1f0',
                    borderRadius: '8px',
                    border: '1px solid #ffa39e'
                }}>
                    <Text strong style={{ color: '#f5222d', display: 'block', marginBottom: '8px' }}>
                        {selectedLanguage === 'english' ? 'Please fix the following errors:' : 'कृपया खालील त्रुटी सुधारा:'}
                    </Text>
                    <ul style={{ margin: 0, paddingLeft: '20px', color: '#f5222d' }}>
                        {validationErrorsList.map((err, idx) => (
                            <li key={idx}>{err.error}</li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Arithmetic Fields */}
            {arithmeticFields.length > 0 && (
                <div>
                    {arithmeticFields.map((afield, idx) => {
                        // Skip rendering constant fields (they are auto-filled)
                        const isConstant = afield.fieldType === 'constant' || afield.constantValue !== undefined;

                        if (isConstant) {
                            // Auto-populate constant value
                            const constantValue = afield.constantValue !== undefined ? afield.constantValue : (afield.defaultValue || 0);
                            if (formData[afield.id] !== constantValue) {
                                setTimeout(() => handleFieldChange(afield.id, constantValue), 0);
                            }
                            return null;
                        }

                        return (
                            <div key={afield.id}>
                                {renderArithmeticNumberInput(
                                    afield,
                                    afield.id,
                                    formData[afield.id] !== undefined ? formData[afield.id] : '',
                                    (val) => handleFieldChange(afield.id, val),
                                    idx > 0,
                                    idx > 0 ? (() => {
                                        const symbols = { add: '+', subtract: '-', multiply: '×', divide: '÷', average: 'avg', percentage: '%' };
                                        return symbols[operator] || '+';
                                    })() : ''
                                )}
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Result section */}
            <div style={{
                marginTop: '12px',
                paddingTop: '8px',
                borderTop: '1px solid #e8e8e8',
                background: allFieldsValid ? '#f6ffed' : '#fff7e6',
                padding: '12px 16px',
                borderRadius: '8px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '6px'
                }}>
                    <span style={{ color: '#333', fontSize: '14px', fontWeight: '500' }}>
                        {selectedLanguage === 'english' ? 'Result:' : 'निकाल:'}
                    </span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{
                            fontWeight: 'bold',
                            fontSize: '18px',
                            color: allFieldsValid ? '#389e0d' : '#d48806'
                        }}>
                            {allFieldsValid ? calculatedResult.toFixed(2) : 'Invalid'}
                        </span>
                        {resultUnit && allFieldsValid && (
                            <span style={{ fontSize: '14px', color: '#333' }}>
                                {resultUnit}
                            </span>
                        )}
                    </div>
                </div>

                {/* Result words display */}
                {resultWords && !viewFilledMode && (
                    <div style={{ marginTop: '8px', padding: '6px 10px', background: '#e6f7ff', borderRadius: '6px' }}>
                        <Text style={{ fontSize: '12px', color: '#333' }}>
                            {resultWords}
                        </Text>
                    </div>
                )}

                {/* Message when inputs are invalid */}
                {!allFieldsValid && (
                    <div style={{ marginTop: '8px', fontSize: '12px', color: '#d48806' }}>
                        {selectedLanguage === 'english'
                            ? 'Please fix validation errors above to see the result'
                            : 'परिणाम पाहण्यासाठी कृपया वरील वैधता त्रुटी सुधारा'}
                    </div>
                )}
            </div>

            {helpText && (
                <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
                    {helpText}
                </div>
            )}

            {error && (
                <div style={{ color: '#ff4444', fontSize: '12px', marginTop: '4px' }}>
                    {error}
                </div>
            )}
        </div>
    );
};
    const renderTextField = (field) => {
    const label = getFieldLabel(field);
    const placeholder = getPlaceholder(field);
    const required = isRequired(field);
    const error = validationErrors[field.id];
    const defaultValue = field.defaultValue || field.importedExistingValue || '';
    const value = formData[field.id] !== undefined ? formData[field.id] : defaultValue;

    const validation = field.validation || {};
    const exactLength = validation.exactLength || null;
    const uppercase = validation.uppercase;
    const lowercase = validation.lowercase;
    const trimInput = validation.trimInput;

    const handleTextChange = (e) => {
        let newValue = e.target.value;

        // Apply exact length limit
        if (exactLength && newValue.length > exactLength) {
            newValue = newValue.slice(0, exactLength);
        }

        // Apply case transformation
        let processedValue = newValue;
        if (uppercase) processedValue = newValue.toUpperCase();
        if (lowercase) processedValue = newValue.toLowerCase();

        // 🔥 CRITICAL FIX: Always update the field first
        handleFieldChange(field.id, processedValue);

        // Then validate and show error (but don't block the update)
        const validationResult = validateFieldValue(field, processedValue);
        if (!validationResult.valid && processedValue !== '') {
            setValidationErrors(prev => ({
                ...prev,
                [field.id]: validationResult.message
            }));
        } else {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[field.id];
                return newErrors;
            });
        }
    };

    if (printMode) {
        return (
            <div key={field.id} className="print-field">
                <span className="print-label">{label}:</span>
                <span className="print-value">{value || 'Not filled'}</span>
            </div>
        );
    }

    return (
        <div key={field.id} style={{ marginBottom: '16px' }}>
            <div style={{
                marginBottom: '6px',
                fontWeight: 'bold',
                fontSize: '13px',
                color: error ? '#ff4444' : '#333',
            }}>
                {label}
                {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
            </div>
            <input
                type="text"
                maxLength={exactLength || undefined}
                value={value}
                onChange={handleTextChange}
                placeholder={placeholder}
                style={{
                    width: '100%',
                    padding: '8px',
                    border: error ? '2px solid #ff4444' : '1px solid #ddd',
                    borderRadius: '4px',
                    fontSize: '14px',
                    outline: 'none',
                    ...(uppercase ? { textTransform: 'uppercase' } : {}),
                    ...(lowercase ? { textTransform: 'lowercase' } : {})
                }}
            />

            {exactLength && value && value.length > 0 && !error && (
                <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                    <span>{value.length}/{exactLength} characters</span>
                </div>
            )}

            {error && (
                <div style={{
                    color: '#ff4444',
                    fontSize: '12px',
                    marginTop: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    backgroundColor: '#ffebee',
                    padding: '6px 10px',
                    borderRadius: '4px'
                }}>
                    <ExclamationCircleOutlined />
                    {error}
                </div>
            )}
        </div>
    );
};

const renderNumberField = (field) => {
    const label = getFieldLabel(field);
    const placeholder = getPlaceholder(field);
    const required = isRequired(field);
    const error = validationErrors[field.id];
    const defaultValue = field.defaultValue || field.importedExistingValue || '';
    const value = formData[field.id] !== undefined ? formData[field.id] : defaultValue;

    // Get validation rules
    const validation = field.validation || {};
    const exactLength = validation.exactLength || null;
    const decimalPlaces = validation.decimalPlaces !== undefined ? validation.decimalPlaces : null;
    const integerOnly = validation.integerOnly === true;
    const allowDecimals = validation.allowDecimals !== false && !integerOnly;
    const allowNegative = validation.allowNegative === true;

    // Get unit info
    let hasUnit = false;
    let unitCategory = null;
    let unitSymbol = null;
    let unitLabel = null;

    if (field.units && typeof field.units === 'object') {
        if (field.units.enabled === true || field.units.selectedUnit) {
            hasUnit = true;
            unitCategory = field.units.category || field.units.unit_category;
            unitSymbol = field.units.symbol;
            unitLabel = field.units.label || field.units.selectedUnit;
        }
    }
    if (!hasUnit && (field.units_category && field.units_category !== 'none')) {
        hasUnit = true;
        unitCategory = field.units_category;
        unitSymbol = field.units_symbol;
        unitLabel = field.units_label || field.units_selected_unit;
    }
    if (!hasUnit && (field.selectedUnit || field.selectedUnitObject)) {
        hasUnit = true;
        if (field.selectedUnitObject) {
            unitCategory = field.selectedUnitObject.unit_category;
            unitSymbol = field.selectedUnitObject.unit_symbol;
            unitLabel = field.selectedUnitObject.unit_name;
        } else {
            unitLabel = field.selectedUnit;
        }
    }

    const displaySymbol = hasUnit ? (unitSymbol || unitLabel || unitCategory) : null;
    const unitDisplayText = hasUnit ? (unitLabel || unitCategory || '') : '';

    const handleNumberChange = (e) => {
        let newValue = e.target.value;

        // :fire: Allow empty string
        if (newValue === '') {
            handleFieldChange(field.id, '');
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[field.id];
                return newErrors;
            });
            return;
        }

        // :fire::fire::fire: BLOCK DECIMAL POINT IF DECIMALS NOT ALLOWED
        if (!allowDecimals && newValue.includes('.')) {
            // Don't allow decimal point at all
            return;
        }

        // :fire: Allow only valid characters based on settings
        let sanitizedValue = '';
        let hasDecimal = false;
        let minusAdded = false;

        for (let i = 0; i < newValue.length; i++) {
            const char = newValue[i];

            // Handle minus sign (only at beginning if allowed)
            if (char === '-' && allowNegative && !minusAdded && i === 0) {
                sanitizedValue += char;
                minusAdded = true;
                continue;
            }

            // Handle decimal point (if decimals allowed and not already added)
            if (char === '.' && allowDecimals && !hasDecimal) {
                sanitizedValue += char;
                hasDecimal = true;
                continue;
            }

            // Handle digits
            if (/[0-9]/.test(char)) {
                sanitizedValue += char;
                continue;
            }

            // Skip any other characters
        }

        newValue = sanitizedValue;

        // Apply exact length validation on digits only
        if (exactLength && newValue !== '') {
            // Count only digits (remove decimal point and minus sign)
            let digitsOnly = newValue.replace(/[^0-9]/g, '');

            if (digitsOnly.length > exactLength) {
                const allowedDigits = digitsOnly.slice(0, exactLength);
                const hasMinus = newValue.startsWith('-');
                const decimalIndex = newValue.indexOf('.');

                if (decimalIndex !== -1 && allowDecimals) {
                    const decimalPart = newValue.slice(decimalIndex + 1);
                    const limitedDecimal = decimalPart.slice(0, decimalPlaces || decimalPart.length);
                    newValue = (hasMinus ? '-' : '') + allowedDigits + '.' + limitedDecimal;
                } else {
                    newValue = (hasMinus ? '-' : '') + allowedDigits;
                }
            }
        }

        // Apply decimal places limit
        if (allowDecimals && decimalPlaces !== undefined && decimalPlaces !== null && newValue.includes('.')) {
            const parts = newValue.split('.');
            if (parts[1] && parts[1].length > decimalPlaces) {
                const limitedDecimal = parts[1].slice(0, decimalPlaces);
                newValue = parts[0] + '.' + limitedDecimal;
            }
        }

        // Store as STRING to preserve leading zeros
        handleFieldChange(field.id, newValue);

        // Validate
        const validationResult = validateFieldValue(field, newValue);
        if (!validationResult.valid && newValue !== '') {
            setValidationErrors(prev => ({
                ...prev,
                [field.id]: validationResult.message
            }));
        } else {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[field.id];
                return newErrors;
            });
        }
    };

    const getDigitCount = (val) => {
        if (!val && val !== 0) return 0;
        const strValue = String(val);
        return strValue.replace(/[^0-9]/g, '').length;
    };

    // Words with unit
    let words = '';
    if (value !== '' && value !== null && value !== undefined) {
        const numValue = parseFloat(value);
        if (!isNaN(numValue) && numValue !== 0) {
            const unitForConversion = (hasUnit && unitCategory && unitCategory !== 'none') ? unitCategory : 'none';
            words = numberToWords(value, selectedLanguage, unitForConversion);
            if (hasUnit && unitDisplayText && !words.includes(unitDisplayText)) {
                words = `${words} ${unitDisplayText}`;
            }
        }
    }

    if (printMode) {
        return (
            <div key={field.id} className="print-field">
                <span className="print-label">{label}:</span>
                <span className="print-value">
                    {value !== '' && value !== null && value !== undefined ? value : 'Not filled'}
                    {hasUnit && displaySymbol && ` ${displaySymbol}`}
                </span>
            </div>
        );
    }

    return (
        <div key={field.id} style={{ marginBottom: '24px' }}>
            <div style={{
                marginBottom: '6px',
                fontWeight: 'bold',
                fontSize: '13px',
                color: error ? '#ff4444' : '#333',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                <span>
                    {label}
                    {hasUnit && unitDisplayText && (
                        <span style={{
                            fontWeight: 'normal',
                            fontSize: '13px',
                            color: '#666',
                            marginLeft: '6px'
                        }}>
                            ({selectedLanguage === 'english' ? 'in' : 'मध्ये'} {unitDisplayText})
                        </span>
                    )}
                    {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                </span>
            </div>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: '#fff',
                border: error ? '2px solid #ff4444' : '1px solid #ddd',
                borderRadius: '4px',
                padding: '4px 8px'
            }}>
                <input
                    type="text"
                    inputMode="numeric"
                    value={value}
                    onChange={handleNumberChange}
                    placeholder={placeholder}
                    style={{
                        flex: 1,
                        padding: '8px',
                        border: 'none',
                        fontSize: '14px',
                        outline: 'none',
                        background: 'transparent'
                    }}
                    disabled={isFormBlocked || viewFilledMode}
                />
                {hasUnit && displaySymbol && (
                    <span style={{
                        fontSize: '14px',
                        color: '#999',
                        padding: '0 4px',
                        borderLeft: '1px solid #eee',
                        marginLeft: '4px'
                    }}>
                        {displaySymbol}
                    </span>
                )}
            </div>

           

            {exactLength && value !== '' && value !== null && value !== undefined && !viewFilledMode && (
                <div style={{
                    fontSize: '11px',
                    color: '#999',
                    marginTop: '4px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <span>
                        {selectedLanguage === 'english' ? 'Digits:' : 'अंक:'} {getDigitCount(value)}
                    </span>
                    <span style={{
                        color: getDigitCount(value) > exactLength ? '#ff4444' : '#52c41a',
                        fontWeight: getDigitCount(value) > exactLength ? 'bold' : 'normal'
                    }}>
                        {getDigitCount(value)}/{exactLength}
                    </span>
                </div>
            )}

            {value !== '' && value !== null && value !== undefined && !error && !viewFilledMode && words && (
                <div style={{
                    marginTop: '12px',
                    padding: '12px 16px',
                    background: '#f6ffed',
                    border: '1px solid #b7eb8f',
                    borderRadius: '8px',
                    fontSize: '13px',
                    color: '#389e0d'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                        <FileTextOutlined style={{ color: '#52c41a' }} />
                        <span style={{ fontWeight: '500' }}>
                            {selectedLanguage === 'english' ? 'In Words:' : 'शब्दांमध्ये:'}
                        </span>
                    </div>
                    <div style={{ paddingLeft: '24px', fontStyle: 'italic' }}>
                        {words}
                    </div>
                </div>
            )}

            {error && (
                <div style={{
                    color: '#ff4444',
                    fontSize: '12px',
                    marginTop: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    backgroundColor: '#ffebee',
                    padding: '6px 10px',
                    borderRadius: '4px'
                }}>
                    <ExclamationCircleOutlined />
                    {error}
                </div>
            )}
        </div>
    );
};
    // DATE FIELD RENDERER WITH COMPARISON SUPPORT & DEFAULT VALUE
    const renderDateField = (field) => {
        const label = getFieldLabel(field);
        const required = isRequired(field);
        const error = validationErrors[field.id];
        const defaultValue = field.defaultValue || field.importedExistingValue || '';
        const value = formData[field.id] !== undefined ? formData[field.id] : defaultValue;

        const enableComparison = field.enableDateComparison === true;
        const comparisonType = field.comparisonType || 'single';
        const comparisonOperator = field.comparisonOperator || 'equals';
        const compareWithDate = field.compareWithDate;
        const compareWithFieldId = field.compareWithFieldId;
        const startDate = field.startDate;
        const endDate = field.endDate;
        const customValidationMessage = field.customValidationMessage;

        const handleDateChange = (e) => {
            const newValue = e.target.value;
            const validationResult = validateFieldValue(field, newValue);

            if (!validationResult.valid) {
                setValidationErrors(prev => ({
                    ...prev,
                    [field.id]: validationResult.message
                }));
                return;
            }

            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[field.id];
                return newErrors;
            });

            handleFieldChange(field.id, newValue);
        };

        const getComparisonDisplay = () => {
            if (!enableComparison) return null;

            if (comparisonOperator === 'current_date') {
                return (
                    <Tag color="green" style={{ marginLeft: '8px', fontSize: '11px' }}>
                        <CalendarOutlined /> Compare with Today
                    </Tag>
                );
            }

            if (comparisonType === 'single' && compareWithDate) {
                const operatorLabel = DATE_COMPARISON_OPERATORS.find(op => op.value === comparisonOperator)?.label || comparisonOperator;
                return (
                    <Tag color="blue" style={{ marginLeft: '8px', fontSize: '11px' }}>
                        <SwapOutlined /> {operatorLabel} {compareWithDate}
                    </Tag>
                );
            }

            if (comparisonType === 'range' && startDate && endDate) {
                return (
                    <Tag color="orange" style={{ marginLeft: '8px', fontSize: '11px' }}>
                        <SwapOutlined /> Between {startDate} and {endDate}
                    </Tag>
                );
            }

            if (comparisonType === 'field' && compareWithFieldId) {
                const compareField = currentForm?.schema?.find(f => f.id === compareWithFieldId);
                const compareFieldLabel = compareField ? getFieldLabel(compareField) : compareWithFieldId;
                const operatorLabel = DATE_COMPARISON_OPERATORS.find(op => op.value === comparisonOperator)?.label || comparisonOperator;
                return (
                    <Tag color="purple" style={{ marginLeft: '8px', fontSize: '11px' }}>
                        <SwapOutlined /> {operatorLabel} {compareFieldLabel}
                    </Tag>
                );
            }

            return null;
        };

        if (printMode) {
            return (
                <div key={field.id} className="print-field">
                    <span className="print-label">{label}:</span>
                    <span className="print-value">{value || 'Not filled'}</span>
                </div>
            );
        }

        return (
            <div key={field.id} style={{ marginBottom: '16px' }}>
                <div style={{
                    marginBottom: '6px',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    color: error ? '#ff4444' : '#333',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '4px'
                }}>
                    <span>
                        {label}
                        {required && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                    </span>
                    {getComparisonDisplay()}
                </div>
                <input
                    type="date"
                    value={value}
                    onChange={handleDateChange}
                    style={{
                        width: '100%',
                        padding: '8px',
                        border: error ? '2px solid #ff4444' : '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px',
                        outline: 'none'
                    }}
                    disabled={isFormBlocked || viewFilledMode}
                />
                {error && (
                    <div style={{
                        color: '#ff4444',
                        fontSize: '12px',
                        marginTop: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        backgroundColor: '#ffebee',
                        padding: '6px 10px',
                        borderRadius: '4px'
                    }}>
                        <ExclamationCircleOutlined />
                        {error}
                    </div>
                )}
                {enableComparison && value && !error && (
                    <div style={{
                        marginTop: '4px',
                        fontSize: '11px',
                        color: '#52c41a',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                    }}>
                        <CheckCircleOutlined />
                        <span>
                            {comparisonOperator === 'current_date'
                                ? (selectedLanguage === 'english' ? '✓ Valid compared to today' : '✓ आजच्या तारखेशी तुलना योग्य')
                                : (selectedLanguage === 'english' ? '✓ Date comparison passed' : '✓ तारीख तुलना यशस्वी')}
                        </span>
                    </div>
                )}
            </div>
        );
    };

    const renderParagraph = (field) => {
        const label = getFieldLabel(field);
        const value = formData[field.id] || '';

        if (printMode) {
            return (
                <div key={field.id} className="print-field">
                    <span className="print-label">{label}:</span>
                    <div style={{ marginLeft: '10px', marginTop: '5px', whiteSpace: 'pre-wrap' }}>{value || 'Not filled'}</div>
                </div>
            );
        }

        return (
            <div key={field.id} style={{ marginBottom: '16px' }}>
                <div style={{
                    marginBottom: '6px',
                    fontWeight: 'bold',
                    fontSize: '14px'
                }}>
                    {label}
                </div>
                <textarea
                    value={value}
                    onChange={(e) => handleFieldChange(field.id, e.target.value)}
                    placeholder={label || "Enter description..."}
                    rows={4}
                    style={{
                        width: '100%',
                        padding: '10px 12px',
                        fontSize: '14px',
                        lineHeight: '1.6',
                        border: '1px solid #d9d9d9',
                        borderRadius: '6px',
                        backgroundColor: '#ffffff',
                        color: '#333',
                        resize: 'vertical',
                        fontFamily: 'inherit'
                    }}
                    disabled={isFormBlocked || viewFilledMode}
                />
            </div>
        );
    };

    const renderHeading = (field, children = []) => {
        const label = getFieldLabel(field);
        const headingLevel = field.headingLevel || 1;

        if (printMode) {
            return (
                <div key={field.id} className="print-field">
                    <h3 style={{ margin: '0 0 5px 0', fontSize: headingLevel === 1 ? '24px' : '20px' }}>{label}</h3>
                    {children.length > 0 && (
                        <div style={{ marginLeft: '20px', marginTop: '10px' }}>
                            {children.map(child => renderField(child))}
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div key={field.id} style={{
                marginBottom: '20px',
                marginTop: field.parentId ? '20px' : '30px',
            }}>
                <div style={{
                    borderBottom: headingLevel === 1 ? '3px solid #fa8c16' : '2px solid #ffd591',
                    paddingBottom: headingLevel === 1 ? '12px' : '8px',
                    marginLeft: headingLevel === 2 ? '24px' : 0
                }}>
                    {headingLevel === 1 ? (
                        <h2 style={{
                            margin: 0,
                            color: '#1f1f1f',
                            fontSize: '24px',
                            fontWeight: 600
                        }}>
                            {label}
                        </h2>
                    ) : (
                        <h3 style={{
                            margin: 0,
                            color: '#2c3e50',
                            fontSize: '20px',
                            fontWeight: 500
                        }}>
                            {label}
                        </h3>
                    )}

                    {(field.enHelpText || field.mrHelpText) && (
                        <div style={{
                            marginTop: '4px',
                            fontSize: '13px',
                            color: '#666',
                            fontStyle: 'italic'
                        }}>
                            {selectedLanguage === 'english' ? field.enHelpText : field.mrHelpText}
                        </div>
                    )}
                </div>

                {children.length > 0 && (
                    <div style={{
                        marginLeft: headingLevel === 1 ? '24px' : '0',
                        marginTop: '16px',
                        paddingLeft: headingLevel === 1 ? '16px' : '0',
                        borderLeft: headingLevel === 1 ? '2px dashed #fa8c16' : 'none'
                    }}>
                        {children.map(child => renderField(child))}
                    </div>
                )}
            </div>
        );
    };

   const renderSubField = (field) => {
    if (!field) return null;

    if (printMode) {
        return (
            <div key={field.id} style={{ marginBottom: '8px', marginLeft: '20px' }}>
                <span className="print-label">{getFieldLabel(field)}:</span>
                <span className="print-value">
                    {field.type === 'file' || field.type === 'image'
                        ? (formData[field.id]?.length > 0 ? `${formData[field.id].length} file(s)` : 'Not filled')
                        : formData[field.id] || 'Not filled'}
                </span>
            </div>
        );
    }

    const error = validationErrors[field.id];

    switch (field.type) {
        case 'text':
            return (
                <div key={field.id} style={{ marginBottom: '8px' }}>
                    {/* ✅ लेबल काढून टाकले - कारण बाहेर आधीच आहे */}
                    <input
                        type="text"
                        value={formData[field.id] || ''}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            const validationResult = validateFieldValue(field, newValue);

                            if (!validationResult.valid) {
                                setValidationErrors(prev => ({
                                    ...prev,
                                    [field.id]: validationResult.message
                                }));
                                return;
                            }

                            setValidationErrors(prev => {
                                const newErrors = { ...prev };
                                delete newErrors[field.id];
                                return newErrors;
                            });

                            handleFieldChange(field.id, newValue);
                        }}
                        placeholder={getPlaceholder(field)}
                        style={{
                            width: '100%',
                            padding: '8px',
                            border: error ? '2px solid #ff4444' : '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '14px',
                            outline: 'none'
                        }}
                        disabled={isFormBlocked || viewFilledMode}
                    />
                    {error && (
                        <div style={{
                            color: '#ff4444',
                            fontSize: '12px',
                            marginTop: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            backgroundColor: '#ffebee',
                            padding: '6px 10px',
                            borderRadius: '4px'
                        }}>
                            <ExclamationCircleOutlined />
                            {error}
                        </div>
                    )}
                </div>
            );

        case 'number':
            // Get unit data for subfield number fields
            let unitCategory = null;
            let unitSymbol = null;
            let unitLabel = null;
            let hasUnit = false;

            // Check for units in the field
            if (field.units_enabled === '1' || field.units_enabled === 1 || field.units_enabled === true) {
                hasUnit = true;
                unitCategory = field.units_category;
                unitSymbol = field.units_symbol;
                unitLabel = field.units_label || field.units_selected_unit;
            }

            // Also check nested units object
            if (!hasUnit && field.units && typeof field.units === 'object') {
                if (field.units.enabled === true || field.units.enabled === '1') {
                    hasUnit = true;
                    unitCategory = field.units.category || field.units.unit_category;
                    unitSymbol = field.units.symbol;
                    unitLabel = field.units.label || field.units.selectedUnit;
                }
            }

            // Check direct properties
            if (!hasUnit && (field.units_category && field.units_category !== 'none')) {
                hasUnit = true;
                unitCategory = field.units_category;
                unitSymbol = field.units_symbol;
                unitLabel = field.units_label || field.units_selected_unit;
            }

            // Display symbol for input
            const displaySymbol = hasUnit ? (unitSymbol || unitLabel || unitCategory) : null;

            // Get unit text for display
            const getUnitLabelText = () => {
                if (!hasUnit) return '';
                if (unitLabel && unitLabel !== 'none') return unitLabel;
                if (unitSymbol && unitSymbol !== 'none') return unitSymbol;
                if (unitCategory && unitCategory !== 'none') return unitCategory;
                return '';
            };

            const unitDisplayText = getUnitLabelText();
            const subFieldValue = formData[field.id] !== undefined ? formData[field.id] : '';

            // Validation result
            const validationResult = validateFieldValue(field, subFieldValue);
            const showError = error || (!validationResult.valid && subFieldValue !== '');

            return (
                <div key={field.id} style={{ marginBottom: '8px' }}>
                    {/* ✅ लेबल काढून टाकले - कारण बाहेर आधीच आहे */}
                    {/* Number input field */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: '#fff',
                        border: showError ? '2px solid #ff4444' : '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '4px 8px'
                    }}>
                        <input
                            type="number"
                            value={subFieldValue}
                            onChange={(e) => {
                                let newValue = e.target.value;
                                if (newValue === '') {
                                    handleFieldChange(field.id, '');
                                    setValidationErrors(prev => {
                                        const newErrors = { ...prev };
                                        delete newErrors[field.id];
                                        return newErrors;
                                    });
                                    return;
                                }

                                const floatValue = parseFloat(newValue);
                                const validationResult = validateFieldValue(field, newValue);

                                if (!validationResult.valid) {
                                    setValidationErrors(prev => ({
                                        ...prev,
                                        [field.id]: validationResult.message
                                    }));
                                    return;
                                }

                                setValidationErrors(prev => {
                                    const newErrors = { ...prev };
                                    delete newErrors[field.id];
                                    return newErrors;
                                });

                                handleFieldChange(field.id, isNaN(floatValue) ? newValue : floatValue);
                            }}
                            placeholder={getPlaceholder(field)}
                            style={{
                                flex: 1,
                                padding: '8px',
                                border: 'none',
                                fontSize: '14px',
                                outline: 'none',
                                background: 'transparent'
                            }}
                            disabled={isFormBlocked || viewFilledMode}
                        />
                        {hasUnit && displaySymbol && (
                            <span style={{
                                fontSize: '14px',
                                color: '#999',
                                padding: '0 4px',
                                borderLeft: '1px solid #eee',
                                marginLeft: '4px'
                            }}>
                                {displaySymbol}
                            </span>
                        )}
                    </div>

                    {/* Error display */}
                    {showError && (
                        <div style={{
                            color: '#ff4444',
                            fontSize: '12px',
                            marginTop: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            backgroundColor: '#ffebee',
                            padding: '6px 10px',
                            borderRadius: '4px'
                        }}>
                            <ExclamationCircleOutlined />
                            {error || validationResult.message}
                        </div>
                    )}
                </div>
            );

        case 'date':
            return (
                <div key={field.id} style={{ marginBottom: '8px' }}>
                    {/* ✅ लेबल काढून टाकले */}
                    <input
                        type="date"
                        value={formData[field.id] || ''}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            const validationResult = validateFieldValue(field, newValue);

                            if (!validationResult.valid) {
                                setValidationErrors(prev => ({
                                    ...prev,
                                    [field.id]: validationResult.message
                                }));
                                return;
                            }

                            setValidationErrors(prev => {
                                const newErrors = { ...prev };
                                delete newErrors[field.id];
                                return newErrors;
                            });

                            handleFieldChange(field.id, newValue);
                        }}
                        style={{
                            width: '100%',
                            padding: '8px',
                            border: error ? '2px solid #ff4444' : '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '14px',
                            outline: 'none'
                        }}
                        disabled={isFormBlocked || viewFilledMode}
                    />
                    {error && (
                        <div style={{
                            color: '#ff4444',
                            fontSize: '12px',
                            marginTop: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            backgroundColor: '#ffebee',
                            padding: '6px 10px',
                            borderRadius: '4px'
                        }}>
                            <ExclamationCircleOutlined />
                            {error}
                        </div>
                    )}
                </div>
            );

        case 'dropdown':
            const subOptions = getOptions(field);
            const allowSearch = field.allowSearch === true;
            const allowMultiSelect = field.allowMultiSelect === true;
            return (
                <div key={field.id} style={{ marginBottom: '8px' }}>
                    {/* ✅ लेबल काढून टाकले */}
                    <Select
                        placeholder={getPlaceholder(field) || (selectedLanguage === 'english' ? 'Select option...' : 'पर्याय निवडा...')}
                        style={{ width: '100%' }}
                        value={formData[field.id]}
                        onChange={(val) => handleFieldChange(field.id, val)}
                        disabled={isFormBlocked || viewFilledMode}
                        allowClear={!isRequired(field)}
                        showSearch={allowSearch}
                        mode={allowMultiSelect ? 'multiple' : undefined}
                        optionFilterProp="children"
                        getPopupContainer={(trigger) => trigger.parentNode}
                    >
                        {subOptions.map((option, idx) => (
                            <Option key={idx} value={option}>
                                {option}
                            </Option>
                        ))}
                    </Select>
                    {error && (
                        <div style={{
                            color: '#ff4444',
                            fontSize: '12px',
                            marginTop: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            backgroundColor: '#ffebee',
                            padding: '6px 10px',
                            borderRadius: '4px'
                        }}>
                            <ExclamationCircleOutlined />
                            {error}
                        </div>
                    )}
                </div>
            );

        case 'file':
        case 'image':
            return renderFileUploadField(field);

        default:
            return null;
    }
};

const renderFormulaField = (field) => {
    const label = getFieldLabel(field);
    const formulaSteps = field.formulaSteps || [];
    const stepCombineOp = field.stepCombineOperator || 'add';
    const isLogicalCombine = ['equals', 'not_equals', 'greater_than', 'less_than',
                               'greater_than_equal', 'less_than_equal'].includes(stepCombineOp);
    const isNoneCombine = stepCombineOp === 'none';
    const showResult = field.showResult !== false;
    const finalResultLabel = field.finalResultLabel || { en: 'Final Result', mr: 'अंतिम निकाल' };
    const finalFalseMessage = field.finalFalseMessage || '';

    // Helper to get unit info
    const getFieldUnitInfo = (fieldData) => {
        let unitCategory = null;
        let unitSymbol = null;
        let unitLabel = null;
        let hasUnit = false;

        if (fieldData) {
            if (fieldData.units_enabled === '1' || fieldData.units_enabled === 1 || fieldData.units_enabled === true) {
                hasUnit = true;
                unitCategory = fieldData.units_category;
                unitSymbol = fieldData.units_symbol;
                unitLabel = fieldData.units_selected_unit || fieldData.units_label;
            }
            else if (fieldData.units && typeof fieldData.units === 'object') {
                if (fieldData.units.enabled === '1' || fieldData.units.enabled === true || fieldData.units.selectedUnit) {
                    hasUnit = true;
                    unitCategory = fieldData.units.category || fieldData.units.unit_category;
                    unitSymbol = fieldData.units.symbol;
                    unitLabel = fieldData.units.selectedUnit || fieldData.units.label;
                }
            }
            else if (fieldData.selectedUnit) {
                hasUnit = true;
                unitLabel = fieldData.selectedUnit;
                unitSymbol = fieldData.unit_symbol;
                unitCategory = fieldData.unit_category;
            }
        }

        const displaySymbol = hasUnit ? (unitSymbol || unitLabel || unitCategory) : null;
        const displayUnitForWords = hasUnit ? (unitCategory || unitLabel || 'none') : 'none';

        return { hasUnit, displaySymbol, displayUnitForWords, unitLabel, unitCategory };
    };

    // Helper to get constant value
    const getConstantValue = (fieldData) => {
        if (!fieldData) return 0;
        if (fieldData.constantValue !== undefined && fieldData.constantValue !== null) {
            return fieldData.constantValue;
        }
        if (fieldData.defaultValue !== undefined && fieldData.defaultValue !== null) {
            const numVal = parseFloat(fieldData.defaultValue);
            return isNaN(numVal) ? 0 : numVal;
        }
        if (fieldData.value !== undefined && fieldData.value !== null) {
            const numVal = parseFloat(fieldData.value);
            return isNaN(numVal) ? 0 : numVal;
        }
        return 0;
    };

    // Helper: apply number validation
    const applyNumberValidation = (fieldData, value) => {
        const validation = fieldData?.validation || {};
        let transformed = value === null || value === undefined ? '' : String(value);
        let error = null;
        const exactLength = validation.exactLength;
        const isIntegerOnly = validation.integerOnly === true;
        const allowDecimals = validation.allowDecimals !== false && !isIntegerOnly;
        const allowNegative = validation.allowNegative === true;

        if (!value && value !== 0) return { transformed: '', error: null };

        if (isIntegerOnly) {
            transformed = transformed.replace(/\./g, '');
            if (allowNegative) {
                transformed = transformed.replace(/[^-0-9]/g, '');
                if (transformed.indexOf('-') > 0) transformed = transformed.replace(/-/g, '');
                if (transformed === '-') transformed = '';
            } else {
                transformed = transformed.replace(/[^0-9]/g, '');
            }
            return { transformed: transformed === '' ? '' : transformed, error: null };
        }

        if (typeof transformed === 'string') {
            if (allowNegative && allowDecimals) {
                transformed = transformed.replace(/[^-0-9.]/g, '');
            } else if (allowNegative && !allowDecimals) {
                transformed = transformed.replace(/[^-0-9]/g, '');
            } else if (!allowNegative && allowDecimals) {
                transformed = transformed.replace(/[^0-9.]/g, '');
            } else {
                transformed = transformed.replace(/[^0-9]/g, '');
            }
        }

        if (allowDecimals && typeof transformed === 'string') {
            const decimalCount = (transformed.match(/\./g) || []).length;
            if (decimalCount > 1) {
                const firstIndex = transformed.indexOf('.');
                transformed = transformed.substring(0, firstIndex + 1) + 
                              transformed.substring(firstIndex + 1).replace(/\./g, '');
            }
        } else if (!allowDecimals) {
            transformed = transformed.replace(/\./g, '');
        }

        if (typeof transformed === 'string') {
            if (!allowNegative && transformed.includes('-')) {
                error = "✗ Negative numbers are not allowed";
                transformed = transformed.replace(/-/g, '');
            } else if (allowNegative && transformed.includes('-')) {
                if (transformed.indexOf('-') !== 0) {
                    transformed = '-' + transformed.replace(/-/g, '');
                }
                const negativeCount = (transformed.match(/-/g) || []).length;
                if (negativeCount > 1) {
                    transformed = '-' + transformed.replace(/-/g, '');
                }
            }
        }

        if (exactLength && transformed && !error && typeof transformed === 'string') {
            const digitsOnly = transformed.replace(/[^0-9]/g, '');
            if (digitsOnly.length > exactLength) {
                const allowedDigits = digitsOnly.slice(0, exactLength);
                const hasNegative = transformed.startsWith('-');
                
                if (allowDecimals && transformed.includes('.')) {
                    const decimalPart = transformed.slice(transformed.indexOf('.') + 1);
                    const limitedDecimal = decimalPart.slice(0, validation.decimalPlaces || decimalPart.length);
                    transformed = (hasNegative ? '-' : '') + allowedDigits + '.' + limitedDecimal;
                } else {
                    transformed = (hasNegative ? '-' : '') + allowedDigits;
                }
            }
        }

        const numValue = parseFloat(transformed);
        if (!isNaN(numValue) && transformed !== '' && typeof transformed === 'string') {
            if (validation.allowZero === false && numValue === 0) {
                error = "✗ Zero is not allowed";
                transformed = '';
            }
            if (validation.decimalPlaces && validation.decimalPlaces > 0 && allowDecimals && transformed.includes('.')) {
                const parts = transformed.split('.');
                if (parts[1] && parts[1].length > validation.decimalPlaces) {
                    transformed = numValue.toFixed(validation.decimalPlaces);
                }
            }
            if (!allowDecimals && transformed.includes('.')) {
                error = "✗ Decimals are not allowed";
                transformed = Math.floor(numValue).toString();
            }
        }

        return { transformed: transformed === '' ? '' : transformed, error };
    };

    const getValueForCalculation = (fieldData) => {
        if (fieldData.isStepResultReference === true) {
            const sourceStepId = fieldData.sourceStepId;
            if (sourceStepId) {
                if (formData[`step_${sourceStepId}_result`] !== undefined) {
                    return parseFloat(formData[`step_${sourceStepId}_result`]) || 0;
                }
                if (formData[sourceStepId] !== undefined) {
                    return parseFloat(formData[sourceStepId]) || 0;
                }
                const sourceStep = formulaSteps.find(s => s.id === sourceStepId);
                if (sourceStep) {
                    return calculateStepResult(sourceStep);
                }
                return 0;
            }
            return 0;
        }

        if (fieldData.fieldType === 'constant') {
            return getConstantValue(fieldData);
        }
        
        let lookupId = fieldData.id;
        if (fieldData.isExternalReference === true && fieldData.sourceFieldId) {
            lookupId = fieldData.sourceFieldId;
        }
        
        const value = formData[lookupId];
        
        if (value === undefined || value === null || value === '') {
            return null;
        }
        
        const numVal = parseFloat(value);
        if (isNaN(numVal)) {
            return null;
        }
        
        return numVal;
    };

    const calculateStepResult = (step) => {
        const fields = step.arithmeticFields || [];
        if (fields.length === 0) return 0;

        let result = 0;
        let isFirst = true;
        const operator = step.combineOperator || 'add';
        const isLogical = isLogicalOperator(operator);

        if (isLogical) {
            let hasEmptyValue = false;
            for (const fieldData of fields) {
                const value = getValueForCalculation(fieldData);
                if (value === null || value === undefined) {
                    hasEmptyValue = true;
                    break;
                }
            }
            if (hasEmptyValue) {
                return 0;
            }
        }

        for (const fieldData of fields) {
            let value = getValueForCalculation(fieldData);
            
            if (value === null || value === undefined) {
                value = 0;
            }

            if (isFirst) {
                result = value;
                isFirst = false;
            } else {
                switch (operator) {
                    case 'add': result += value; break;
                    case 'subtract': result -= value; break;
                    case 'multiply': result *= value; break;
                    case 'divide': result = value !== 0 ? result / value : 0; break;
                    case 'percentage': result = value !== 0 ? (result / value) * 100 : 0; break;
                    case 'equals': result = (result === value) ? 1 : 0; break;
                    case 'not_equals': result = (result !== value) ? 1 : 0; break;
                    case 'greater_than': result = (result > value) ? 1 : 0; break;
                    case 'less_than': result = (result < value) ? 1 : 0; break;
                    case 'greater_than_equal': result = (result >= value) ? 1 : 0; break;
                    case 'less_than_equal': result = (result <= value) ? 1 : 0; break;
                    default: result += value;
                }
            }
        }
        
        return result;
    };

    const calculateFinalResult = () => {
        if (formulaSteps.length === 0) return 0;

        const stepResults = [];
        for (const step of formulaSteps) {
            stepResults.push(calculateStepResult(step));
        }

        if (stepResults.length === 1) return stepResults[0];
        if (stepCombineOp === 'none') return stepResults[0];

        let finalResultVal = stepResults[0];
        for (let i = 1; i < stepResults.length; i++) {
            switch (stepCombineOp) {
                case 'add': finalResultVal += stepResults[i]; break;
                case 'subtract': finalResultVal -= stepResults[i]; break;
                case 'multiply': finalResultVal *= stepResults[i]; break;
                case 'divide': finalResultVal = stepResults[i] !== 0 ? finalResultVal / stepResults[i] : 0; break;
                case 'percentage': finalResultVal = stepResults[i] !== 0 ? (finalResultVal / stepResults[i]) * 100 : 0; break;
                case 'equals': finalResultVal = finalResultVal === stepResults[i] ? 1 : 0; break;
                case 'not_equals': finalResultVal = finalResultVal !== stepResults[i] ? 1 : 0; break;
                case 'greater_than': finalResultVal = finalResultVal > stepResults[i] ? 1 : 0; break;
                case 'less_than': finalResultVal = finalResultVal < stepResults[i] ? 1 : 0; break;
                case 'greater_than_equal': finalResultVal = finalResultVal >= stepResults[i] ? 1 : 0; break;
                case 'less_than_equal': finalResultVal = finalResultVal <= stepResults[i] ? 1 : 0; break;
                default: finalResultVal += stepResults[i];
            }
        }
        return finalResultVal;
    };

    const finalResult = calculateFinalResult();

    const getCombineSymbol = () => {
        if (stepCombineOp === 'none') return '||';
        switch(stepCombineOp) {
            case 'add': return '+';
            case 'subtract': return '-';
            case 'multiply': return '×';
            case 'divide': return '÷';
            case 'percentage': return '%';
            case 'equals': return '==';
            case 'not_equals': return '≠';
            case 'greater_than': return '>';
            case 'less_than': return '<';
            case 'greater_than_equal': return '≥';
            case 'less_than_equal': return '≤';
            default: return '+';
        }
    };

    const getStepResultLabel = (step) => {
        return selectedLanguage === 'english'
            ? (step.resultLabel?.en || `${step.name} Result`)
            : (step.resultLabel?.mr || `${step.name} चे निकाल`);
    };

    const getFinalResultWords = () => {
        if (isLogicalCombine) return '';
        if (finalResult === 0 || isNaN(finalResult)) return '';
        const words = numberToWords(finalResult, selectedLanguage, 'none');
        return words;
    };
    const finalResultWords = getFinalResultWords();

    const getStepLogicalError = (step, stepResult) => {
        const stepIsLogical = isLogicalOperator(step.combineOperator);
        const stepFalseMessage = step.falseMessage || '';
        
        if (!stepIsLogical || !stepFalseMessage || stepResult !== 0) {
            return null;
        }
        
        const fields = step.arithmeticFields || [];
        const hasEmptyField = fields.some(fieldData => {
            if (fieldData.isStepResultReference === true) {
                const sourceStepId = fieldData.sourceStepId;
                if (sourceStepId) {
                    const sourceStep = formulaSteps.find(s => s.id === sourceStepId);
                    if (sourceStep) {
                        const sourceFields = sourceStep.arithmeticFields || [];
                        return sourceFields.some(f => {
                            const val = getValueForCalculation(f);
                            return val === null || val === undefined;
                        });
                    }
                }
                return false;
            }
            const val = getValueForCalculation(fieldData);
            return val === null || val === undefined;
        });
        
        if (!hasEmptyField && stepResult === 0 && stepFalseMessage) {
            return stepFalseMessage;
        }
        
        return null;
    };

    const getFinalLogicalError = () => {
        if (!isLogicalCombine || finalResult !== 0 || !finalFalseMessage) {
            return null;
        }
        
        let hasEmptyField = false;
        for (const step of formulaSteps) {
            const fields = step.arithmeticFields || [];
            for (const fieldData of fields) {
                let val;
                if (fieldData.isStepResultReference === true) {
                    const sourceStepId = fieldData.sourceStepId;
                    if (sourceStepId) {
                        const sourceStep = formulaSteps.find(s => s.id === sourceStepId);
                        if (sourceStep) {
                            const sourceFields = sourceStep.arithmeticFields || [];
                            for (const f of sourceFields) {
                                val = getValueForCalculation(f);
                                if (val === null || val === undefined) {
                                    hasEmptyField = true;
                                    break;
                                }
                            }
                        }
                    }
                } else {
                    val = getValueForCalculation(fieldData);
                }
                if (val === null || val === undefined) {
                    hasEmptyField = true;
                    break;
                }
            }
            if (hasEmptyField) break;
        }
        
        if (!hasEmptyField && finalResult === 0 && finalFalseMessage) {
            return finalFalseMessage;
        }
        
        return null;
    };

    const getDigitCount = (val) => {
        if (!val && val !== 0) return 0;
        const strVal = String(val);
        return strVal.replace(/[^0-9]/g, '').length;
    };

    // PRINT MODE
    if (printMode) {
        return (
            <div key={field.id} style={{ marginBottom: '24px' }}>
                <div style={{ marginBottom: '12px', fontWeight: 'bold', fontSize: '16px', borderBottom: '1px solid #ccc', paddingBottom: '6px' }}>
                    {label}
                </div>

                {formulaSteps.length === 0 ? (
                    <div style={{ padding: '10px 0', color: '#999' }}>No formula steps configured</div>
                ) : (
                    <>
                        {formulaSteps.map((step, stepIdx) => {
                            const stepFields = step.arithmeticFields || [];
                            const stepResult = calculateStepResult(step);
                            const stepResultLabel = getStepResultLabel(step);
                            
                            const visibleFields = stepFields.filter(f => {
                                if (f.isSharedReference === true) return false;
                                if (f.isExternalReference === true) return false;
                                return true;
                            });

                            return (
                                <div key={step.id} style={{ marginBottom: '20px', marginLeft: '16px' }}>
                                    <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '8px' }}>
                                        {stepIdx + 1}. {step.name}
                                    </div>

                                    <div style={{ marginLeft: '24px' }}>
                                        {visibleFields.map((fieldData) => {
                                            const displayValue = getValueForCalculation(fieldData);
                                            const isConstant = fieldData.fieldType === 'constant';
                                            const unitInfo = getFieldUnitInfo(fieldData);

                                            return (
                                                <div key={fieldData.id} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                                    <span style={{ minWidth: '120px' }}>
                                                        {selectedLanguage === 'english' ? fieldData.enLabel : fieldData.mrLabel}:
                                                    </span>
                                                    <span style={{ padding: '6px 10px', border: '1px solid #ccc', borderRadius: '3px', minWidth: '100px', display: 'inline-block', background: '#fafafa' }}>
                                                        {displayValue}
                                                    </span>
                                                    {unitInfo.hasUnit && unitInfo.displaySymbol && (
                                                        <span style={{ fontSize: '13px', color: '#666' }}>{unitInfo.displaySymbol}</span>
                                                    )}
                                                    {isConstant && (
                                                        <span style={{ fontSize: '11px', color: '#999' }}>(Constant)</span>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>

                                    <div style={{ marginTop: '10px', marginLeft: '24px', paddingLeft: '8px', borderLeft: '2px solid #ccc' }}>
                                        {stepResultLabel}: {typeof stepResult === 'number' ? stepResult.toFixed(2) : stepResult}
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}
            </div>
        );
    }

    // EDIT MODE - Main UI
    return (
        <div key={field.id} style={{ marginBottom: '32px' }}>
            {formulaSteps.length === 0 ? (
                <div style={{
                    textAlign: 'center',
                    padding: '40px',
                    background: '#fafafa',
                    borderRadius: '8px'
                }}>
                    <Text type="secondary">No formula steps configured</Text>
                </div>
            ) : (
                <>
                    {formulaSteps.map((step, stepIdx) => {
                        const stepFields = step.arithmeticFields || [];
                        const stepResult = calculateStepResult(step);
                        const stepResultLabel = getStepResultLabel(step);
                        const stepLogicalError = getStepLogicalError(step, stepResult);
                        
                        const visibleFields = stepFields.filter(f => {
                            if (f.isSharedReference === true) return false;
                            if (f.isExternalReference === true) return false;
                            return true;
                        });

                        const showStepResult = step.showStepResult !== false;
                        
                        const isDefaultStepName = step.name && /^Step \d+$/.test(step.name);
                        const shouldShowStepHeading = !isDefaultStepName && step.name && step.name.trim() !== '';
                        
                        if (!showStepResult && stepLogicalError) {
                            return (
                                <div key={step.id} style={{
                                    marginBottom: '16px',
                                    padding: '12px',
                                    background: '#ffebee',
                                    border: '1px solid #ffcdd2',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <CloseCircleOutlined style={{ color: '#c62828' }} />
                                    <Text strong style={{ color: '#c62828' }}>
                                        {stepLogicalError}
                                    </Text>
                                </div>
                            );
                        }

                        if (!showStepResult && !stepLogicalError) {
                            return null;
                        }

                        return (
                            <div key={step.id} style={{
                                marginBottom: '16px',
                                padding: '0px',
                                background: 'transparent',
                                borderRadius: '0px',
                                border: 'none'
                            }}>
                                {/* Step Name - फक्त custom name असल्यासच दाखवा */}
                                {shouldShowStepHeading && (
                                    <div style={{
                                        marginBottom: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        flexWrap: 'wrap'
                                    }}>
                                        <Text strong style={{ fontSize: '14px' }}>
                                            {step.name}
                                        </Text>
                                        {stepFields.some(f => f.isStepResultReference === true) && (
                                            <Tag color="purple" icon={<ShareAltOutlined />}>
                                                Uses Step Results
                                            </Tag>
                                        )}
                                    </div>
                                )}

                                {/* Fields - नेहमी दाखवा */}
                                <div style={{ 
                                    marginLeft: '0px',
                                    marginTop: '0px'
                                }}>
                                    {visibleFields.map((fieldData, fieldIdx) => {
                                        const isStepResultRef = fieldData.isStepResultReference === true;
                                        const currentValue = formData[fieldData.id] !== undefined ? formData[fieldData.id] : '';
                                        const isConstant = fieldData.fieldType === 'constant';
                                        const unitInfo = getFieldUnitInfo(fieldData);
                                        
                                        let displayValue = currentValue;
                                        let isReadOnly = false;
                                        
                                        if (isStepResultRef) {
                                            isReadOnly = true;
                                            const sourceStepId = fieldData.sourceStepId;
                                            if (sourceStepId) {
                                                const stepResultValue = calculateStepResult(
                                                    formulaSteps.find(s => s.id === sourceStepId) || { arithmeticFields: [] }
                                                );
                                                displayValue = stepResultValue;
                                                if (formData[fieldData.id] !== stepResultValue) {
                                                    setTimeout(() => {
                                                        handleFieldChange(fieldData.id, stepResultValue);
                                                    }, 0);
                                                }
                                            }
                                        }
                                        
                                        const fieldValidation = fieldData.validation || {};
                                        const isIntegerOnly = fieldValidation.integerOnly === true;
                                        const exactLength = fieldValidation.exactLength;
                                        const allowNegative = fieldValidation.allowNegative === true;
                                        const decimalPlaces = fieldValidation.decimalPlaces;
                                        const allowDecimals = fieldValidation.allowDecimals !== false && !isIntegerOnly;

                                        let validationError = null;
                                        let validatedValue = displayValue;
                                        if (!isStepResultRef) {
                                            const { transformed, error } = applyNumberValidation(fieldData, displayValue);
                                            validatedValue = transformed;
                                            validationError = error;
                                        }
                                        
                                        const showError = validationErrors[fieldData.id] || validationError;
                                        
                                        const digitCount = getDigitCount(validatedValue);

                                        let stepFieldWords = '';
                                        if (validatedValue !== '' && validatedValue !== null && !isNaN(parseFloat(validatedValue)) && !validationError) {
                                            const numValue = parseFloat(validatedValue);
                                            if (!isNaN(numValue) && numValue !== 0) {
                                                stepFieldWords = numberToWords(validatedValue, selectedLanguage, unitInfo.displayUnitForWords);
                                                if (unitInfo.hasUnit && unitInfo.unitLabel && !stepFieldWords.includes(unitInfo.unitLabel)) {
                                                    stepFieldWords = `${stepFieldWords} ${unitInfo.unitLabel}`;
                                                }
                                            }
                                        }

                                        return (
                                            <div key={fieldData.id} style={{ marginBottom: '12px' }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '12px',
                                                    flexWrap: 'wrap',
                                                    marginBottom: '4px'
                                                }}>
                                                    <Text style={{ minWidth: '150px', fontSize: '13px', fontWeight: '500' }}>
                                                        {selectedLanguage === 'english' ? fieldData.enLabel : fieldData.mrLabel}:
                                                        {fieldData.enRequired && !isConstant && <span style={{ color: '#ff4444', marginLeft: '4px' }}>*</span>}
                                                        {unitInfo.hasUnit && unitInfo.unitLabel && (
                                                            <span style={{
                                                                fontWeight: 'normal',
                                                                fontSize: '11px',
                                                                color: '#666',
                                                                marginLeft: '6px'
                                                            }}>
                                                                ({selectedLanguage === 'english' ? 'in' : 'मध्ये'} {unitInfo.unitLabel})
                                                            </span>
                                                        )}
                                                        {isConstant && (
                                                            <Tag color="gold" style={{ marginLeft: '8px', fontSize: '9px', padding: '0px 6px' }}>
                                                                Constant
                                                            </Tag>
                                                        )}
                                                        {isStepResultRef && (
                                                            <Tag color="magenta" style={{ marginLeft: '8px', fontSize: '9px' }}>
                                                                <ShareAltOutlined /> Step Result
                                                            </Tag>
                                                        )}
                                                        {isReadOnly && isStepResultRef && (
                                                            <Tag color="cyan" style={{ marginLeft: '4px', fontSize: '9px' }}>
                                                                Auto-calculated
                                                            </Tag>
                                                        )}
                                                    </Text>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <input
                                                            type="text"
                                                            inputMode={isIntegerOnly ? "numeric" : "decimal"}
                                                            value={isStepResultRef ? (typeof displayValue === 'number' ? displayValue : 0) : displayValue}
                                                            onChange={(e) => {
                                                                if (isStepResultRef) {
                                                                    message.warning(selectedLanguage === 'english'
                                                                        ? 'This is an auto-calculated step result and cannot be edited'
                                                                        : 'हे स्वयं-गणना केलेले स्टेप रिझल्ट आहे आणि ते संपादित करू शकत नाही');
                                                                    return;
                                                                }
                                                                
                                                                let newValue = e.target.value;
                                                                
                                                                if (isIntegerOnly) {
                                                                    newValue = newValue.replace(/\./g, '');
                                                                    if (allowNegative) {
                                                                        newValue = newValue.replace(/[^-0-9]/g, '');
                                                                        if (newValue.indexOf('-') > 0) newValue = newValue.replace(/-/g, '');
                                                                        if (newValue === '-') newValue = '';
                                                                    } else {
                                                                        newValue = newValue.replace(/[^0-9]/g, '');
                                                                    }
                                                                    
                                                                    if (exactLength && newValue !== '' && newValue !== '-') {
                                                                        let digitsOnly = newValue.replace(/[^0-9]/g, '');
                                                                        if (digitsOnly.length > exactLength) {
                                                                            const allowedDigits = digitsOnly.slice(0, exactLength);
                                                                            const hasNegative = newValue.startsWith('-');
                                                                            newValue = (hasNegative ? '-' : '') + allowedDigits;
                                                                        }
                                                                    }
                                                                    
                                                                    handleFieldChange(fieldData.id, newValue);
                                                                    return;
                                                                }
                                                                
                                                                if (!isConstant) {
                                                                    const { transformed, error } = applyNumberValidation(fieldData, newValue);
                                                                    
                                                                    if (error && transformed) {
                                                                        message.error(error);
                                                                        setValidationErrors(prev => ({
                                                                            ...prev,
                                                                            [fieldData.id]: error
                                                                        }));
                                                                    } else {
                                                                        setValidationErrors(prev => {
                                                                            const newErrors = { ...prev };
                                                                            delete newErrors[fieldData.id];
                                                                            return newErrors;
                                                                        });
                                                                    }
                                                                    
                                                                    handleFieldChange(fieldData.id, transformed);
                                                                    return;
                                                                }
                                                                
                                                                if (isConstant) {
                                                                    message.warning(selectedLanguage === 'english'
                                                                        ? 'This is a constant field and cannot be edited'
                                                                        : 'हे कॉन्स्टंट फील्ड आहे आणि ते संपादित करू शकत नाही');
                                                                    return;
                                                                }
                                                                
                                                                handleFieldChange(fieldData.id, newValue);
                                                            }}
                                                            style={{
                                                                width: '150px',
                                                                padding: '6px 10px',
                                                                border: showError ? '1px solid #ff4444' : (isStepResultRef ? '1px solid #d3adf7' : '1px solid #d9d9d9'),
                                                                borderRadius: '4px',
                                                                fontSize: '13px',
                                                                outline: 'none',
                                                                backgroundColor: isStepResultRef ? '#f9f0ff' : (isConstant ? '#f5f5f5' : '#ffffff'),
                                                                cursor: (isStepResultRef || isConstant || isFormBlocked || viewFilledMode) ? 'not-allowed' : 'text',
                                                                color: isStepResultRef ? '#722ed1' : '#333'
                                                            }}
                                                            disabled={isStepResultRef || isConstant || isFormBlocked || viewFilledMode}
                                                        />
                                                        {unitInfo.hasUnit && unitInfo.displaySymbol && (
                                                            <span style={{
                                                                fontSize: '12px',
                                                                color: '#666',
                                                                background: 'transparent',
                                                                padding: '0px 4px'
                                                            }}>
                                                                {unitInfo.displaySymbol}
                                                            </span>
                                                        )}
                                                        {isStepResultRef && (
                                                            <AntTooltip title={`From step: ${fieldData.sourceStepName || fieldData.sourceStepId}`}>
                                                                <InfoCircleOutlined style={{ color: '#722ed1', fontSize: '14px' }} />
                                                            </AntTooltip>
                                                        )}
                                                    </div>
                                                </div>

                                                {exactLength && displayValue !== '' && displayValue !== null && displayValue !== 0 && !showError && !viewFilledMode && !isConstant && !isIntegerOnly && !isStepResultRef && (
                                                    <div style={{
                                                        fontSize: '10px',
                                                        color: '#999',
                                                        marginTop: '2px',
                                                        marginLeft: '162px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        maxWidth: '180px'
                                                    }}>
                                                        <span>
                                                            {selectedLanguage === 'english' ? 'Digits:' : 'अंक:'} {digitCount}
                                                        </span>
                                                        <span style={{
                                                            color: digitCount > exactLength ? '#ff4444' : '#52c41a',
                                                            fontWeight: digitCount > exactLength ? 'bold' : 'normal'
                                                        }}>
                                                            {digitCount}/{exactLength}
                                                        </span>
                                                    </div>
                                                )}

                                                {stepFieldWords && !showError && !viewFilledMode && !isConstant && !isStepResultRef && (
                                                    <div style={{
                                                        marginTop: '6px',
                                                        marginLeft: '162px',
                                                        padding: '4px 8px',
                                                        background: '#f6ffed',
                                                        border: '1px solid #b7eb8f',
                                                        borderRadius: '4px',
                                                        fontSize: '13px'
                                                    }}>
                                                        <Space size={4}>
                                                            <FileTextOutlined style={{ color: '#52c41a', fontSize: '13px' }} />
                                                            <Text type="secondary" style={{ fontSize: '10px' }}>
                                                                {selectedLanguage === 'english' ? 'In words:' : 'शब्दांत:'}
                                                            </Text>
                                                            <Text style={{ color: '#389e0d', fontSize: '10px' }}>{stepFieldWords}</Text>
                                                        </Space>
                                                    </div>
                                                )}

                                                {showError && !isConstant && !isStepResultRef && (
                                                    <div style={{
                                                        marginTop: '4px',
                                                        marginLeft: '162px',
                                                        color: '#ff4444',
                                                        fontSize: '11px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px'
                                                    }}>
                                                        <ExclamationCircleOutlined />
                                                        {validationErrors[fieldData.id] || validationError}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* Step Result - फक्त error message (box नाही) */}
                                {stepLogicalError ? (
                                    <div style={{
                                        marginTop: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        color: '#c62828',
                                        marginLeft: '0px'
                                    }}>
                                        <CloseCircleOutlined style={{ color: '#c62828' }} />
                                        <Text strong style={{ color: '#c62828', fontSize: '13px' }}>
                                            {stepLogicalError}
                                        </Text>
                                    </div>
                                ) : (
                                    !isLogicalOperator(step.combineOperator) && (
                                        <div style={{
                                            marginTop: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px',
                                            flexWrap: 'wrap',
                                            paddingTop: '8px',
                                            borderTop: '1px dashed #e8e8e8',
                                            marginLeft: '0px'
                                        }}>
                                            <Text style={{ fontSize: '13px', color: '#666' }}>
                                                {stepResultLabel}:
                                            </Text>
                                            <div style={{
                                                padding: '4px 12px',
                                                background: '#f5f5f5',
                                                border: '1px solid #d9d9d9',
                                                borderRadius: '4px'
                                            }}>
                                                <Text style={{ fontSize: '13px' }}>
                                                    {typeof stepResult === 'number' ? stepResult.toFixed(2) : stepResult}
                                                </Text>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        );
                    })}

                    {/* Final Result */}
                    {(() => {
                        const finalLogicalError = getFinalLogicalError();
                        
                        if (isLogicalCombine) {
                            if (finalLogicalError) {
                                return (
                                    <div style={{
                                        marginTop: '20px',
                                        padding: '12px 16px',
                                        background: '#ffebee',
                                        border: '1px solid #ffcdd2',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <CloseCircleOutlined style={{ color: '#c62828', fontSize: '18px' }} />
                                        <Text strong style={{ color: '#c62828', fontSize: '14px' }}>
                                            {finalLogicalError}
                                        </Text>
                                    </div>
                                );
                            }
                            return null;
                        }
                        
                        if (formulaSteps.length >= 2 && !isNoneCombine && showResult) {
                            return (
                                <div style={{
                                    marginTop: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '12px',
                                    padding: '12px 16px',
                                    background: '#f6ffed',
                                    border: '1px solid #b7eb8f',
                                    borderRadius: '8px'
                                }}>
                                    <Text style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                                        {selectedLanguage === 'english' ? finalResultLabel.en : finalResultLabel.mr}:
                                    </Text>
                                    <div style={{
                                        padding: '6px 12px',
                                        background: '#ffffff',
                                        border: '1px solid #d9d9d9',
                                        borderRadius: '4px'
                                    }}>
                                        <Text style={{ fontSize: '14px', fontWeight: '500' }}>
                                            {(finalResult || 0).toFixed(2)}
                                        </Text>
                                    </div>
                                    {finalResultWords && (
                                        <Text type="secondary" style={{ fontSize: '11px' }}>
                                            ({finalResultWords})
                                        </Text>
                                    )}
                                </div>
                            );
                        }
                        return null;
                    })()}

                    {(field.enHelpText || field.mrHelpText) && (
                        <Text type="secondary" style={{ fontSize: '12px', marginTop: '16px', display: 'block', textAlign: 'center', fontStyle: 'italic' }}>
                            {selectedLanguage === 'english' ? field.enHelpText : field.mrHelpText}
                        </Text>
                    )}
                </>
            )}
        </div>
    );
};


    const renderField = (field) => {
        if (!field) return null;

        const children = currentForm?.schema?.filter(f => f.parentId === field.id) || [];


         // ✅ ADD THIS - FORMULA FIELD HANDLER (heading च्या आधी)
if (field.type === 'formula') {
        return renderFormulaField(field);
    }

        if (field.type === 'heading') {
            const headingLevel = field.headingLevel || 1;

            return (
                <div key={field.id} style={{
                    marginBottom: '20px',
                    marginTop: field.parentId ? '15px' : '25px',
                    marginLeft: headingLevel === 2 ? '24px' :
                              headingLevel === 3 ? '48px' :
                              headingLevel >= 4 ? '72px' : '0'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: headingLevel === 1 ? '16px' : '12px'
                    }}>
                        <div style={{ flex: 1 }}>
                            {headingLevel === 1 && (
                                <h2 style={{
                                    margin: 0,
                                    fontSize: '24px',
                                    fontWeight: 600,
                                    color: '#1f1f1f',
                                    borderBottom: '3px solid #fa8c16',
                                    paddingBottom: '8px'
                                }}>
                                    {getFieldLabel(field)}
                                </h2>
                            )}

                            {headingLevel === 2 && (
                                <h3 style={{
                                    margin: 0,
                                    fontSize: '20px',
                                    fontWeight: 500,
                                    color: '#2c3e50',
                                    borderBottom: '2px solid #ffd591',
                                    paddingBottom: '6px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <span style={{
                                        display: 'inline-block',
                                        width: '4px',
                                        height: '20px',
                                        backgroundColor: '#fa8c16',
                                        marginRight: '8px',
                                        borderRadius: '2px'
                                    }} />
                                    {getFieldLabel(field)}
                                </h3>
                            )}

                            {headingLevel === 3 && (
                                <h4 style={{
                                    margin: 0,
                                    fontSize: '18px',
                                    fontWeight: 500,
                                    color: '#34495e',
                                    borderBottom: '1px dashed #ffe7ba',
                                    paddingBottom: '4px',
                                    fontStyle: 'italic',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <span style={{
                                        display: 'inline-block',
                                        width: '3px',
                                        height: '16px',
                                        backgroundColor: '#ffa940',
                                        marginRight: '8px',
                                        borderRadius: '2px'
                                    }} />
                                    {getFieldLabel(field)}
                                </h4>
                            )}

                            {headingLevel >= 4 && (
                                <div style={{
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    color: '#5d6d7e',
                                    borderBottom: '1px dotted #f0f0f0',
                                    paddingBottom: '4px',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    <span style={{ marginRight: '8px', color: '#95a5a6' }}>•</span>
                                    {getFieldLabel(field)}
                                </div>
                            )}

                            {(field.enHelpText || field.mrHelpText) && (
                                <div style={{
                                    marginTop: '4px',
                                    fontSize: '13px',
                                    color: '#666',
                                    fontStyle: 'italic',
                                    paddingLeft: headingLevel === 1 ? '0' : '20px'
                                }}>
                                    {selectedLanguage === 'english' ? field.enHelpText : field.mrHelpText}
                                </div>
                            )}
                        </div>
                    </div>

                    {children.length > 0 && (
                        <div style={{
                            marginLeft: headingLevel === 1 ? '24px' :
                                      headingLevel === 2 ? '24px' :
                                      headingLevel === 3 ? '24px' : '16px',
                            borderLeft: headingLevel === 1 ? '2px solid #f0f0f0' :
                                        headingLevel === 2 ? '2px solid #f0f0f0' :
                                        headingLevel === 3 ? '1px dashed #f0f0f0' : 'none',
                            paddingLeft: '16px'
                        }}>
                            {children.map(child => renderField(child))}
                        </div>
                    )}
                </div>
            );
        }

        const renderFieldWithPrefix = (content) => {

    let childrenFields = [];
    if (field.type !== 'checkbox' && field.type !== 'radio') {
        childrenFields = currentForm?.schema?.filter(f => f.parentId === field.id) || [];
    }

    return (
        <div style={{
            marginBottom: '16px',
            marginLeft: field.parentId ? '48px' : '0',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '8px'
        }}>
            <div style={{ flex: 1 }}>
                {content}
                {/* ✅ फक्त checkbox/radio नसलेल्या fields साठी children render करा */}
                {childrenFields.length > 0 && (
                    <div style={{ marginTop: '16px', marginLeft: '24px' }}>
                        {childrenFields.map(child => renderField(child))}
                    </div>
                )}
            </div>
        </div>
    );
};

        switch (field.type) {
            case 'dropdown':
                return renderFieldWithPrefix(renderDropdownField(field));
            case 'radio':
                return renderFieldWithPrefix(renderRadioField(field));
            case 'checkbox':
                return renderFieldWithPrefix(renderCheckboxField(field));
            case 'comparison':
                return renderFieldWithPrefix(renderComparisonField(field));
            case 'arithmetic':
                return renderFieldWithPrefix(renderArithmeticField(field));
            case 'text':
                return renderFieldWithPrefix(renderTextField(field));
            case 'number':
                return renderFieldWithPrefix(renderNumberField(field));
            case 'date':
                return renderFieldWithPrefix(renderDateField(field));
            case 'paragraph':
                return renderFieldWithPrefix(renderParagraph(field));
            case 'file':
                return renderFieldWithPrefix(renderFileUploadField(field));
            case 'image':
                return renderFieldWithPrefix(renderImageUploadField(field));
            default:
                return null;
        }
    };

const FrequencySelectionModal = ({
  showFrequencyModal, onClose, pendingFormId, formMetadata,
  currentUser, selectedLanguage, API_BASE, onPeriodSelect
}) => {
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [periods, setPeriods] = useState([]);
  const [periodStatuses, setPeriodStatuses] = useState({});
  const [loading, setLoading] = useState(false);

  const frequencies = formMetadata?.frequency_configs || [];

  // :fire: FIX: Hide frequencies that have 'custom' in the name
  const availableFrequencies = frequencies.filter(f => {
    // Get the frequency name from various possible fields
    const frequencyName = (f.custom || f.periodName || f.type || f.label || '').toLowerCase();
    // Hide if the name contains 'custom'
    if (frequencyName.includes('custom')) {
      console.log(':no_entry_sign: Hiding custom frequency:', frequencyName);
      return false;
    }
    return true;
  });

  // Table columns for frequencies list
  const frequencyColumns = [
    {
      title: selectedLanguage === 'english' ? 'Time Window' : 'कालावधी',
      dataIndex: 'custom',
      key: 'custom',
      render: (text, record) => {
        // Frequency name दाखवा
        const frequencyName = record.custom || record.periodName || record.type || 'Time Window';
        return (
          <div>
            <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{frequencyName}</span>
            {/* Date display commented out - not needed
            {record.schedule?.date && (
              <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
                ({record.schedule.date})
              </div>
            )}
            */}
          </div>
        );
      }
    },
    // Schedule Time column - completely removed/commented out
    // {
    //   title: selectedLanguage === 'english' ? 'Schedule Time' : 'नियोजित वेळ',
    //   dataIndex: 'schedule',
    //   key: 'schedule',
    //   width: 120,
    //   render: (schedule) => {
    //     if (schedule?.time) {
    //       return <Tag color="green"><ClockCircleOutlined /> {schedule.time}</Tag>;
    //     }
    //     return '-';
    //   }
    // },
    {
      title: selectedLanguage === 'english' ? 'Action' : 'कृती',
      key: 'action',
      width: 100,
      align: 'center',
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            setSelectedFrequency(record);
            generateSinglePeriod(record);
          }}
        >
          {selectedLanguage === 'english' ? 'Select' : 'निवडा'}
        </Button>
      )
    }
  ];

  const generateSinglePeriod = async (freq) => {
  setLoading(true);

  // const schedule = freq.schedule || {};
  // const assignedDate = schedule.date;
  // const assignedTime = schedule.time || '09:00';

  // if (!assignedDate) {
  //   message.error(selectedLanguage === 'english'
  //     ? 'No date assigned for this frequency'
  //     : 'या वारंवारतेसाठी कोणतीही तारीख नियुक्त केलेली नाही');
  //   setLoading(false);
  //   return;
  // }

  const frequencyName = freq.custom || freq.periodName || freq.type || 'Period';
  const periodLabel = frequencyName;

  console.log('📅 Frequency Name:', frequencyName);
  console.log('📅 Period Label (sending directly):', periodLabel);

  // 🔥 FIX: Select केल्यावर थेट onPeriodSelect कॉल करा (Period टेबल शिवाय)
  onPeriodSelect({
    type: freq.type || 'standard',
    schedule: freq.schedule || {},
    periodLabel: periodLabel,
    confirmed_at: new Date().toISOString()
  }, null);

  // Modal बंद करा
  onClose();
  setLoading(false);
};

  const handlePeriodSelect = (period, statusInfo) => {
    console.log(':dart: handlePeriodSelect called with period:', period);

    const selectedPeriodLabel = period?.label || period?.periodLabel || period?.frequencyName;

    console.log(':date: Selected Period Label:', selectedPeriodLabel);

    if (!selectedPeriodLabel) {
      message.error(selectedLanguage === 'english'
        ? 'Invalid period selected'
        : 'अवैध कालावधी निवडला');
      return;
    }

    onPeriodSelect({
      type: selectedFrequency?.type || 'standard',
      schedule: selectedFrequency?.schedule,
      periodLabel: selectedPeriodLabel,
      confirmed_at: new Date().toISOString()
    }, statusInfo);

    onClose();
  };

  if (!showFrequencyModal) return null;

  // Step 1: Select Frequency - Simple Table View
  if (!selectedFrequency) {
    return (
      <Modal
        open={showFrequencyModal}
        onCancel={() => {
          setSelectedFrequency(null);
          setPeriods([]);
          onClose();
        }}
        width={700}
        title={
          <Space>
            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
              {selectedLanguage === 'english' ? 'Select Time Window' : 'कालावधी निवडा'}
            </span>
          </Space>
        }
        footer={null}
        centered
      >
        <div style={{ padding: '8px 0' }}>
          {availableFrequencies.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px' }}>
              <ClockCircleOutlined style={{ fontSize: 48, color: '#999' }} />
              <p style={{ marginTop: 16, color: '#666' }}>
                {selectedLanguage === 'english'
                  ? 'No time windows available for this form'
                  : 'या फॉर्मसाठी कोणतेही कालावधी उपलब्ध नाहीत'}
              </p>
            </div>
          ) : (
            <Table
              dataSource={availableFrequencies}
              columns={frequencyColumns}
              rowKey="custom"
              pagination={false}
              bordered
              size="middle"
            />
          )}
        </div>
      </Modal>
    );
  }

  // Step 2: Show Period (Single period - Table View only)
  return (
    <Modal
      open={showFrequencyModal}
      onCancel={() => {
        setSelectedFrequency(null);
        setPeriods([]);
        onClose();
      }}
      width={700}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Button
            size="small"
            onClick={() => setSelectedFrequency(null)}
            icon={<ArrowLeftOutlined />}
          >
            {selectedLanguage === 'english' ? 'Back' : 'मागे'}
          </Button>
          <span style={{ fontWeight: 'bold' }}>{selectedFrequency.custom || selectedFrequency.periodName || selectedFrequency.type}</span>
        </div>
      }
      footer={null}
      centered
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px' }}>
          <Spin size="large" />
          <p style={{ marginTop: 16, color: '#666' }}>
            {selectedLanguage === 'english' ? 'Loading...' : 'लोड करत आहे...'}
          </p>
        </div>
      ) : periods.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px' }}>
          <CalendarOutlined style={{ fontSize: 48, color: '#999' }} />
          <p style={{ marginTop: 16, color: '#666' }}>
            {selectedLanguage === 'english'
              ? 'No period available for this frequency'
              : 'या वारंवारतेसाठी कोणताही कालावधी उपलब्ध नाही'}
          </p>
        </div>
      ) : (
        <Table
          dataSource={periods.map(period => {
            const statusInfo = periodStatuses[period.periodLabel];
            const isSubmitted = statusInfo?.status === 'filled' || statusInfo?.status === 'submitted' || statusInfo?.status === 'approve';
            const isDraft = statusInfo?.status === 'draft';
            const now = new Date();
            const periodDateTime = new Date(period.date);
            const scheduleTime = period.schedule?.time || '09:00';
            const [hours, minutes] = scheduleTime.split(':').map(Number);
            periodDateTime.setHours(hours, minutes, 0, 0);

            let status = '';
            let statusColor = '';
            let canFill = false;

            if (isSubmitted) {
              status = selectedLanguage === 'english' ? 'Submitted' : 'सबमिट केले';
              statusColor = 'green';
              canFill = false;
            } else if (isDraft) {
              status = selectedLanguage === 'english' ? 'Draft' : 'मसुदा';
              statusColor = 'orange';
              canFill = true;
            } else if (now >= periodDateTime) {
              status = selectedLanguage === 'english' ? 'Live Now' : 'आता उपलब्ध';
              statusColor = 'red';
              canFill = true;
            } else {
              const diffHours = Math.ceil((periodDateTime - now) / (1000 * 60 * 60));
              status = selectedLanguage === 'english'
                ? `Available in ${diffHours} hours`
                : `${diffHours} तासांनी उपलब्ध`;
              statusColor = 'blue';
              canFill = false;
            }

            return {
              key: period.value,
              period: period.label,
              date: period.date.toLocaleDateString(),
              time: scheduleTime,
              status: status,
              statusColor: statusColor,
              canFill: canFill,
              periodData: period,
              statusInfo: statusInfo
            };
          })}
          columns={[
            {
              title: selectedLanguage === 'english' ? 'Period' : 'कालावधी',
              dataIndex: 'period',
              key: 'period',
              width: 200
            },
            {
              title: selectedLanguage === 'english' ? 'Date' : 'तारीख',
              dataIndex: 'date',
              key: 'date',
              width: 120
            },
            {
              title: selectedLanguage === 'english' ? 'Time' : 'वेळ',
              dataIndex: 'time',
              key: 'time',
              width: 100
            },
            {
              title: selectedLanguage === 'english' ? 'Status' : 'स्थिती',
              dataIndex: 'status',
              key: 'status',
              width: 150,
              render: (text, record) => (
                <Tag color={record.statusColor}>{text}</Tag>
              )
            },
            {
              title: selectedLanguage === 'english' ? 'Action' : 'कृती',
              key: 'action',
              width: 120,
              align: 'center',
              render: (_, record) => (
                <Button
                  type={record.canFill ? 'primary' : 'default'}
                  disabled={!record.canFill}
                  onClick={() => handlePeriodSelect(record.periodData, record.statusInfo)}
                  size="small"
                  style={record.status === 'Live Now' ? { background: '#f5222d', borderColor: '#f5222d' } : {}}
                >
                  {record.canFill
                    ? (selectedLanguage === 'english' ? 'Fill Now' : 'आता भरा')
                    : (selectedLanguage === 'english' ? 'Locked' : 'बंद')}
                </Button>
              )
            }
          ]}
          rowKey="key"
          pagination={false}
          bordered
          size="middle"
        />
      )}
    </Modal>
  );
};
    useEffect(() => {
        fetchCurrentUser();
    }, []);

    useEffect(() => {
        if (currentUser?.id) {
            fetchAllForms();
        }
    }, [currentUser]);

    const getCurrentDateTime = () => {
        const now = new Date();
        const date = now.toLocaleDateString();
        const time = now.toLocaleTimeString();
        return { date, time };
    };

    if (userLoading) {
        return (
            <div style={{ fontFamily: 'system-ui, sans-serif' }}>
                <Navbar onMenuClick={() => setSbCollapsed(!sbCollapsed)} />
                <div style={{ display: 'flex' }}>
                    {/* <Sidebar collapsed={sbCollapsed} setCollapsed={setSbCollapsed} extraContent={renderSLACard()} /> */}
                    <div style={{ flex: 1, padding: '20px', marginLeft: sbCollapsed ? '50px' : '50px', marginTop: '80px' }}>
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                            <p style={{ marginTop: '16px' }}>Loading user information...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!currentUser) {
        return (
            <div style={{ fontFamily: 'system-ui, sans-serif' }}>
                <Navbar onMenuClick={() => setSbCollapsed(!sbCollapsed)} />
                <div style={{ display: 'flex' }}>
                    {/* <Sidebar collapsed={sbCollapsed} setCollapsed={setSbCollapsed} extraContent={renderSLACard()} /> */}
                    <div style={{ flex: 1, padding: '20px', marginLeft: sbCollapsed ? '50px' : '50px', marginTop: '80px' }}>
                        <div style={{ maxWidth: '400px', margin: '100px auto', textAlign: 'center' }}>
                            <h2>Login Required</h2>
                            <p>Please login to access forms</p>
                            <Button type="primary" onClick={() => navigate('/login')}>Go to Login</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (loading) {
        return (
            <div style={{ fontFamily: 'system-ui, sans-serif' }}>
                <Navbar onMenuClick={() => setSbCollapsed(!sbCollapsed)} />
                <div style={{ display: 'flex' }}>
                    {/* <Sidebar collapsed={sbCollapsed} setCollapsed={setSbCollapsed} extraContent={renderSLACard()} /> */}
                    <div style={{ flex: 1, padding: '20px', marginLeft: sbCollapsed ? '50px' : '50px', marginTop: '80px' }}>
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                            <p style={{ marginTop: '16px' }}>Loading forms...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const { date, time } = getCurrentDateTime();
    const newFormsCount = activeForms.filter(f => f.isNew).length;
    const formsToDisplay = showOnlyNew ? activeForms.filter(f => f.isNew) : activeForms;

    return (
        <div style={{ fontFamily: 'system-ui, sans-serif' }}>
            <style>{blinkStyles}</style>

            <Navbar onMenuClick={() => setSbCollapsed(!sbCollapsed)} />
            <div style={{ display: 'flex' }}>
                {/* <Sidebar collapsed={sbCollapsed} setCollapsed={setSbCollapsed} extraContent={renderSLACard()} /> */}
               <div className="form-app-main" style={{
    flex: 1,
    padding: '20px',
    marginLeft: sbCollapsed ? '50px' : '50px',
    marginTop: '80px',
    background: '#f5f5f5',
    minHeight: 'calc(100vh - 60px)'
}}>
                    <style>{printStyles}</style>

                    <Modal
                        open={entryLimitModal}
                        footer={null}
                        closable={false}
                        width={400}
                        centered
                    >
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <CloseOutlined style={{ fontSize: '48px', color: '#ff4d4f', marginBottom: '16px' }} />
                            <h3>{selectedLanguage === 'english' ? 'Entry Limit Reached' : 'एंट्री मर्यादा पूर्ण'}</h3>
                            <p style={{ color: '#666', marginBottom: '24px' }}>
                                {selectedLanguage === 'english'
                                    ? `You have reached the maximum limit of ${formMetadata?.max_entries_per_user} entries for this form.`
                                    : `तुम्ही या फॉर्मसाठी कमाल ${formMetadata?.max_entries_per_user} एंट्रीची मर्यादा पूर्ण केली आहे.`}
                            </p>
                            <Button type="primary" onClick={() => {
                                setEntryLimitModal(false);
                                setViewMode('list');
                                setCurrentForm(null);
                            }}>
                                {selectedLanguage === 'english' ? 'Back to Forms' : 'फॉर्म्सकडे परत'}
                            </Button>
                        </div>
                    </Modal>

                    {formMetadata?.entry_type === 'multi' && (
                        <Modal
                            open={showEntrySelector}
                            footer={null}
                            onCancel={() => {
                                setShowEntrySelector(false);
                                setViewMode('list');
                                setCurrentForm(null);
                            }}
                            width={600}
                            title={
                                <Space>
                                    <CopyFilled style={{ color: '#722ed1' }} />
                                    {selectedLanguage === 'english' ? 'Select Entry' : 'एंट्री निवडा'}
                                </Space>
                            }
                            centered
                        >
                            <div style={{ padding: '20px' }}>
                                <div style={{ marginBottom: '24px' }}>
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        onClick={createNewEntry}
                                        size="large"
                                        block
                                        disabled={isMultiEntryLimitReached}
                                        style={{
                                            background: isMultiEntryLimitReached ? '#cccccc' : '#52c41a',
                                            borderColor: isMultiEntryLimitReached ? '#cccccc' : '#52c41a',
                                            height: '50px',
                                            fontSize: '16px'
                                        }}
                                    >
                                        {selectedLanguage === 'english' ? 'Create New Entry' : 'नवीन एंट्री तयार करा'}
                                    </Button>
                                </div>

                                <Divider>
                                    <Tag color="blue">{entries.length} {selectedLanguage === 'english' ? 'Existing Entries' : 'विद्यमान एंट्रीज'}</Tag>
                                </Divider>

                                {entries.length === 0 ? (
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '40px 20px',
                                        background: '#f9f9f9',
                                        borderRadius: '8px'
                                    }}>
                                        <FieldTimeOutlined style={{ fontSize: '32px', color: '#999', marginBottom: '12px' }} />
                                        <p style={{ color: '#666' }}>
                                            {selectedLanguage === 'english'
                                                ? 'No existing entries found. Create a new entry to start.'
                                                : 'कोणतीही विद्यमान एंट्री सापडली नाही. सुरू करण्यासाठी नवीन एंट्री तयार करा.'}
                                        </p>
                                    </div>
                                ) : (
                                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                        {entries.map(entry => (
                                            <div
                                                key={entry.id}
                                                onClick={() => loadEntry(entry.id)}
                                                style={{
                                                    padding: '16px',
                                                    marginBottom: '12px',
                                                    border: '1px solid #e8e8e8',
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s',
                                                    background: entry.status === 'submitted' ? '#f6ffed' : 'white',
                                                    borderColor: entry.status === 'submitted' ? '#b7eb8f' : '#e8e8e8'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
                                                onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                            >
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div>
                                                        <Space>
                                                            {entry.status === 'submitted' && (
                                                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                                            )}
                                                            <strong style={{ fontSize: '16px' }}>
                                                                {entry.entry_number || `Entry #${entry.id}`}
                                                            </strong>
                                                            {formMetadata?.frequency?.enabled && entry.frequency_period && (
                                                                <Tag color="blue" icon={<ClockCircleOutlined />}>
                                                                    {entry.frequency_period}
                                                                </Tag>
                                                            )}
                                                        </Space>
                                                        <div style={{ marginTop: '4px', fontSize: '13px', color: '#666' }}>
                                                            {selectedLanguage === 'english' ? 'Last updated:' : 'शेवटचे अपडेट:'} {new Date(entry.entry_date || entry.created_at).toLocaleString()}
                                                        </div>
                                                    </div>
                                                    <Tag color={entry.status === 'submitted' ? 'green' : 'orange'}>
                                                        {entry.status === 'submitted'
                                                            ? (selectedLanguage === 'english' ? 'Submitted' : 'सबमिट केले')
                                                            : (selectedLanguage === 'english' ? 'Draft' : 'मसुदा')}
                                                    </Tag>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </Modal>
                    )}

                    {/* 🆕 Frequency Selection Modal */}

<FrequencySelectionModal
  showFrequencyModal={showFrequencyModal}
  onClose={() => {
    setShowFrequencyModal(false);
    setViewMode('list');
    setCurrentForm(null);
  }}
  pendingFormId={pendingFormId}
  formMetadata={formMetadata}
  currentUser={currentUser}
  selectedLanguage={selectedLanguage}
  API_BASE={API_BASE}
  onPeriodSelect={(periodData, statusInfo) => {
    console.log('🔍 onPeriodSelect received periodData:', periodData);

    // 🔥 फक्त periodLabel वापरा
    const selectedPeriodLabel = periodData?.periodLabel;

    console.log('📅 Selected Period Label:', selectedPeriodLabel);

    const scheduleSelection = {
      type: periodData?.type || formMetadata?.frequency?.type || 'custom',
      schedule: periodData?.schedule || formMetadata?.frequency?.schedule,
      periodLabel: selectedPeriodLabel,  // ← हेच main field आहे
      confirmed_at: periodData?.confirmed_at || new Date().toISOString()
    };

    console.log('📦 scheduleSelection being sent:', scheduleSelection);

    // Load form with selected period label
    if (selectedPeriodLabel) {
      loadFormFieldsAfterFrequency(pendingFormId, scheduleSelection);
    } else {
      console.error('❌ No period label selected!');
      message.error(selectedLanguage === 'english'
        ? 'Invalid period selected'
        : 'अवैध कालावधी निवडला');
    }
    setShowFrequencyModal(false);
  }}
/>

                    {viewMode === 'list' && (
                        <div className="forms-container" style={{
    maxWidth: '800px',
    margin: '0 auto',
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    overflow: 'hidden'
}}>
                           <div className="form-list-header" style={{
    padding: '20px',
    background: '#f8f9fa',
    borderBottom: '1px solid #dee2e6',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}}>
                                <div>
                                    <h2 style={{ margin: 0 }}>
                                        📋 {showOnlyNew ? 'New Forms' : 'Available Forms'}
                                        {showOnlyNew && <span style={{ fontSize: '14px', fontWeight: 'normal', marginLeft: '8px', color: '#ff4d4f' }}>({newFormsCount})</span>}
                                    </h2>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                        Last updated: {new Date(lastLoaded).toLocaleTimeString()}
                                    </div>
                                </div>
                                <Space>
                                    <Badge count={newFormsCount} overflowCount={99} offset={[-5, 5]}>
                                        <Button
                                            size="small"
                                            icon={<StarFilled />}
                                            onClick={() => setShowOnlyNew(!showOnlyNew)}
                                            type={showOnlyNew ? "primary" : "default"}
                                            style={{
                                                color: showOnlyNew ? 'white' : '#faad14',
                                                background: showOnlyNew ? '#ff4d4f' : 'transparent',
                                                borderColor: showOnlyNew ? '#ff4d4f' : '#faad14'
                                            }}
                                        >
                                            {showOnlyNew ? 'Showing New' : `New (${newFormsCount})`}
                                        </Button>
                                    </Badge>
                                </Space>
                            </div>

                            {allForms.length > activeForms.length && !showOnlyNew && (
                                <div style={{
                                    fontSize: '13px',
                                    color: '#dc3545',
                                    margin: '10px 20px',
                                    padding: '8px 12px',
                                    background: '#fff3f3',
                                    borderRadius: '4px',
                                    border: '1px solid #ffcdd2'
                                }}>
                                    ⚠️ {allForms.length - activeForms.length} form(s) are currently inactive and not shown
                                </div>
                            )}

                            {formsToDisplay.length === 0 ? (
                                <div style={{ textAlign: 'center', padding: '40px' }}>
                                    {showOnlyNew ? (
                                        <>
                                            <StarFilled style={{ fontSize: '48px', color: '#ffd700', marginBottom: '16px' }} />
                                            <p style={{ color: '#666', fontSize: '16px' }}>No new forms available</p>
                                            <Button type="primary" onClick={() => setShowOnlyNew(false)} style={{ marginTop: '8px' }}>
                                                Show all forms
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <p style={{ color: '#666' }}>No active forms available</p>
                                            {allForms.length > 0 && (
                                                <p style={{ color: '#999', fontSize: '13px' }}>
                                                    {allForms.length} form(s) exist but are inactive
                                                </p>
                                            )}
                                        </>
                                    )}
                                </div>
                            ) : (
                                formsToDisplay.map(form => {
                                    const formViolations = slaViolations.filter(v => v.form_id === form.id);
                                    const hasExpiring = expiringForms.some(e => e.form_id === form.id);
                                    const hasExpired = expiredForms.some(e => e.form_id === form.id);
                                    const isSubmitted = form.userSubmissionStatus === 'submitted';
                                    const isLimitReached = form.userSubmissionStatus === 'limit_reached';
                                    const isBlocked = isSubmitted || isLimitReached;
                                    const formDeadline = formsDeadlines[form.id];
                                    const deadlineStatus = formDeadline ? getDeadlineStatus(formDeadline) : null;

                                    let deadlineClass = '';
                                    if (hasExpired) {
                                        deadlineClass = 'deadline-today';
                                    } else if (hasExpiring) {
                                        const expiringViolation = expiringForms.find(e => e.form_id === form.id);
                                        if (expiringViolation?.daysLeft === 0) {
                                            deadlineClass = 'deadline-today';
                                        } else if (expiringViolation?.daysLeft === 1) {
                                            deadlineClass = 'deadline-tomorrow';
                                        } else if (expiringViolation?.daysLeft === 2) {
                                            deadlineClass = 'deadline-2days';
                                        } else {
                                            deadlineClass = 'deadline-urgent';
                                        }
                                    } else if (deadlineStatus) {
                                        deadlineClass = deadlineStatus.class;
                                    }

                                    return (
                                        <div key={form.id} className={deadlineClass} style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '16px',
                                            marginBottom: '8px',
                                            border: '1px solid #e8e8e8',
                                            borderRadius: '8px',
                                            transition: 'all 0.2s',
                                            cursor: 'pointer',
                                            backgroundColor: 'white'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
                                        onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
                                        >
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontWeight: '500', fontSize: '16px', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                                    {form.form_name}

                                                    {form.isNew && (
                                                        <AntTooltip title={selectedLanguage === 'english' ? 'Created in last 24 hours' : 'गेल्या २४ तासांत तयार केले'}>
                                                            <span className="new-badge">
                                                                <StarFilled style={{ fontSize: '10px', marginRight: '4px' }} />
                                                                NEW
                                                            </span>
                                                        </AntTooltip>
                                                    )}

                                                    {/* {form.entry_type === 'multi' && (
                                                        <Tag color="purple" style={{ marginLeft: '8px' }}>
                                                            <CopyFilled /> Multi Entry {form.max_entries_per_user > 0 ? `(Max: ${form.max_entries_per_user})` : ''}
                                                        </Tag>
                                                    )}

                                                    {form.entry_type !== 'multi' && (
                                                        <Tag color="blue" style={{ marginLeft: '8px' }}>
                                                            <FileOutlined /> Single Entry
                                                        </Tag>
                                                    )}

                                                    {form.frequency?.enabled && (
                                                        <Tag color="blue" style={{ marginLeft: '4px' }}>
                                                            <ClockCircleOutlined /> {form.frequency.type}
                                                        </Tag>
                                                    )} */}

                                                    {/* <span style={{
                                                        marginLeft: '8px',
                                                        fontSize: '11px',
                                                        padding: '2px 6px',
                                                        background: '#d4edda',
                                                        borderRadius: '10px',
                                                        color: '#155724',
                                                        border: '1px solid #c3e6cb'
                                                    }}>
                                                        Active
                                                    </span>
                                                     */}
                                                    {isSubmitted && form.entry_type !== 'multi' && (
                                                        <Tag color="green" style={{ marginLeft: '8px' }}>
                                                            <CheckCircleOutlined /> Submitted
                                                        </Tag>
                                                    )}

                                                    {isLimitReached && form.entry_type === 'multi' && (
                                                        <Tag color="orange" style={{ marginLeft: '8px' }}>
                                                            <ExclamationCircleOutlined /> Max Entries Reached
                                                        </Tag>
                                                    )}
                                                </div>

                                                {formViolations.length > 0 && (
                                                    <div style={{ marginTop: '8px' }}>
                                                        {formViolations.map((violation, idx) => {
                                                            const vDeadlineStatus = getDeadlineStatus(violation.expected_deadline);
                                                            return (
                                                                <AntTooltip key={idx} title={
                                                                    <div>
                                                                        <div>Stage: {violation.stage_name || `Stage ${violation.stage_index}`}</div>
                                                                        <div>Deadline: {new Date(violation.expected_deadline).toLocaleString()}</div>
                                                                        {violation.violated_at && <div>Violated: {new Date(violation.violated_at).toLocaleString()}</div>}
                                                                        {violation.escalation_triggered && <div>Escalated to: {violation.escalation_to}</div>}
                                                                    </div>
                                                                }>
                                                                    <div style={{
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        padding: '2px 8px',
                                                                        background: vDeadlineStatus?.status === 'expired' ? '#ffebee' :
                                                                                   vDeadlineStatus?.status === 'today' ? '#ffebee' :
                                                                                   vDeadlineStatus?.status === 'tomorrow' ? '#fff3e0' : '#e8f5e9',
                                                                        borderRadius: '12px',
                                                                        fontSize: '11px',
                                                                        marginRight: '8px',
                                                                        marginBottom: '4px',
                                                                        border: '1px solid',
                                                                        borderColor: vDeadlineStatus?.status === 'expired' ? '#ffcdd2' :
                                                                                   vDeadlineStatus?.status === 'today' ? '#ffcdd2' :
                                                                                   vDeadlineStatus?.status === 'tomorrow' ? '#ffe0b2' : '#c8e6c9'
                                                                    }}>
                                                                        <CalendarOutlined style={{
                                                                            color: vDeadlineStatus?.status === 'expired' ? '#c62828' :
                                                                                   vDeadlineStatus?.status === 'today' ? '#c62828' :
                                                                                   vDeadlineStatus?.status === 'tomorrow' ? '#e65100' : '#2e7d32'
                                                                        }} />
                                                                        <span style={{
                                                                            color: vDeadlineStatus?.status === 'expired' ? '#c62828' :
                                                                                   vDeadlineStatus?.status === 'today' ? '#c62828' :
                                                                                   vDeadlineStatus?.status === 'tomorrow' ? '#e65100' : '#2e7d32',
                                                                            fontWeight: 'bold'
                                                                        }}>
                                                                            {vDeadlineStatus?.status === 'expired' && `${vDeadlineStatus.days} days overdue`}
                                                                            {vDeadlineStatus?.status === 'today' && 'Due today!'}
                                                                            {vDeadlineStatus?.status === 'tomorrow' && 'Due tomorrow!'}
                                                                            {vDeadlineStatus?.status === '2days' && '2 days left'}
                                                                            {vDeadlineStatus?.status === 'soon' && `${vDeadlineStatus.days} days left`}
                                                                        </span>
                                                                    </div>
                                                                </AntTooltip>
                                                            );
                                                        })}
                                                    </div>
                                                )}

                                                {formDeadline && formViolations.length === 0 && (
                                                    <div style={{ marginTop: '8px' }}>
                                                        <AntTooltip title={`Deadline: ${new Date(formDeadline).toLocaleString()}`}>
                                                            <div style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '4px',
                                                                padding: '2px 8px',
                                                                background: deadlineStatus?.status === 'expired' ? '#ffebee' :
                                                                           deadlineStatus?.status === 'today' ? '#ffebee' :
                                                                           deadlineStatus?.status === 'tomorrow' ? '#fff3e0' : '#e8f5e9',
                                                                borderRadius: '12px',
                                                                fontSize: '11px',
                                                                border: '1px solid',
                                                                borderColor: deadlineStatus?.status === 'expired' ? '#ffcdd2' :
                                                                           deadlineStatus?.status === 'today' ? '#ffcdd2' :
                                                                           deadlineStatus?.status === 'tomorrow' ? '#ffe0b2' : '#c8e6c9'
                                                            }}>
                                                                <CalendarOutlined style={{
                                                                    color: deadlineStatus?.status === 'expired' ? '#c62828' :
                                                                           deadlineStatus?.status === 'today' ? '#c62828' :
                                                                           deadlineStatus?.status === 'tomorrow' ? '#e65100' : '#2e7d32'
                                                                }} />
                                                                <span style={{
                                                                    color: deadlineStatus?.status === 'expired' ? '#c62828' :
                                                                           deadlineStatus?.status === 'today' ? '#c62828' :
                                                                           deadlineStatus?.status === 'tomorrow' ? '#e65100' : '#2e7d32',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    {deadlineStatus?.status === 'expired' && `${deadlineStatus.days} days overdue`}
                                                                    {deadlineStatus?.status === 'today' && 'Due today!'}
                                                                    {deadlineStatus?.status === 'tomorrow' && 'Due tomorrow!'}
                                                                    {deadlineStatus?.status === '2days' && '2 days left'}
                                                                    {deadlineStatus?.status === 'soon' && `${deadlineStatus.days} days left`}
                                                                </span>
                                                            </div>
                                                        </AntTooltip>
                                                    </div>
                                                )}

                                                {/* <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                                    📅 Created: {new Date(form.created_at).toLocaleDateString()}
                                                    {form.isNew && ' (New)'}
                                                </div> */}
                                            </div>

                                            {checkingSubmissions[form.id] === true ? (
                                                <Button
                                                    disabled
                                                    style={{
                                                        minWidth: '120px',
                                                        marginLeft: '16px'
                                                    }}
                                                >
                                                    <Spin size="small" /> Checking...
                                                </Button>
                                            ) : (
                                                <Button
                                                    type={isBlocked ? "default" : "primary"}
                                                    onClick={() => {
                                                        console.log('🖱️ Form clicked:', form.id, form.form_name);
                                                        loadFormToFill(form.id);
                                                    }}
                                                    style={{
                                                        background: isBlocked ? '#f0f0f0' : '#28a745',
                                                        borderColor: isBlocked ? '#d9d9d9' : '#28a745',
                                                        color: isBlocked ? '#666' : 'white',
                                                        minWidth: '120px',
                                                        marginLeft: '16px'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!isBlocked) {
                                                            e.currentTarget.style.background = '#218838';
                                                            e.currentTarget.style.borderColor = '#218838';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isBlocked) {
                                                            e.currentTarget.style.background = '#28a745';
                                                            e.currentTarget.style.borderColor = '#28a745';
                                                        }
                                                    }}
                                                >
                                                    {isBlocked
                                                        ? (selectedLanguage === 'english' ? 'View Submitted' : 'सबमिट केलेले पहा')
                                                        : (selectedLanguage === 'english' ? 'Fill Form' : 'फॉर्म भरा')}
                                                </Button>
                                            )}
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    )}

                    {viewMode === 'fill' && currentForm && (
                        <div ref={formRef} className={printMode ? 'printable-area fill-form-container' : 'fill-form-container'} style={{
    maxWidth: '800px',
    margin: '0 auto',
    background: 'white',
    borderRadius: '8px',
    padding: '24px',
    boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
}}>
                            {printMode && (
                                <div className="print-header">
                                    <div className="print-header-left">
                                        <h2>{currentForm.form_name}</h2>

                                        <p><strong>Submitted by:</strong> {currentUser?.name || currentUser?.username || 'User'}</p>
                                        {/* <p><strong>Role:</strong> {currentUser?.role || 'User'}</p> */}
                                        <p><strong>Date:</strong> {date}</p>
                                        <p><strong>Time:</strong> {time}</p>
                                        {formMetadata?.entry_type === 'multi' && currentEntryId && (
                                            <p><strong>Entry Number:</strong> {entries.find(e => e.id === currentEntryId)?.entry_number || currentEntryId}</p>
                                        )}
                                    </div>
                                    <div className="print-signature">
                                        <div style={{ marginBottom: '10px' }}>
                                            <strong>Authorized Signature</strong>
                                        </div>
                                        <div className="signature-line">
                                            (Sign here)
                                        </div>
                                    </div>
                                </div>
                            )}

<div className="fill-header no-print" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>                                <Space>
                                    <Button
                                        onClick={() => {
                                            if (formMetadata?.entry_type === 'multi') {
                                                setShowEntrySelector(true);
                                                setFormData({});
                                                setCurrentEntryId(null);
                                                setIsFormBlocked(false);
                                                setViewFilledMode(false);
                                            } else {
                                                setViewMode('list');
                                                setCurrentForm(null);
                                                setFormData({});
                                                setIsFormBlocked(false);
                                                setViewFilledMode(false);
                                                setSubmittedFormData(null);
                                            }
                                        }}
                                    >
                                        ← {formMetadata?.entry_type === 'multi' ? 'Back to Entries' : 'Back to Forms'}
                                    </Button>
                                    {formMetadata?.entry_type === 'multi' && currentEntryId && (
                                        <Tag color="purple" style={{ padding: '4px 12px', fontSize: '13px' }}>
                                            <CopyFilled /> {selectedLanguage === 'english' ? 'Editing Entry:' : 'एंट्री एडिट करत आहे:'} {entries.find(e => e.id === currentEntryId)?.entry_number || currentEntryId}
                                        </Tag>
                                    )}
                                    {viewFilledMode && (
                                        <Tag color="green" style={{ fontSize: '13px', padding: '4px 12px' }}>
                                            <EyeOutlined /> {selectedLanguage === 'english' ? 'View Only Mode' : 'फक्त पाहण्यासाठी मोड'}
                                        </Tag>
                                    )}
                                    {isMultiEntryLimitReached && !viewFilledMode && (
                                        <Tag color="orange" style={{ fontSize: '13px', padding: '4px 12px' }}>
                                            <ExclamationCircleOutlined /> {selectedLanguage === 'english' ? 'Entry Limit Reached' : 'एंट्री मर्यादा पूर्ण'}
                                        </Tag>
                                    )}
                                </Space>
                                <h2 style={{ margin: 0, color: '#333' }}>
                                    {currentForm.form_name}
                                    {formMetadata?.entry_type === 'multi' && (
                                        <Tag color="purple" style={{ marginLeft: '10px' }}>
                                            <CopyFilled /> Multi Entry
                                        </Tag>
                                    )}
                                    {formMetadata?.frequency?.enabled && (
                                        <Tag color="blue" style={{ marginLeft: '4px' }}>

                                        </Tag>
                                    )}
                                    {formMetadata?.is_existing_table && (
                                        <span style={{
                                            marginLeft: '10px',
                                            fontSize: '12px',
                                            fontWeight: 'normal',
                                            padding: '2px 8px',
                                            background: '#e6f7ff',
                                            borderRadius: '12px',
                                            color: '#ffffff',
                                            border: '1px solid #91d5ff'
                                        }}>
                                            Using source table
                                        </span>
                                    )}

                                </h2>
                                <Button
                                    onClick={handlePrint}
                                    icon={<EyeOutlined />}
                                >
                                    Print Form
                                </Button>
                            </div>

        {/* {!printMode && formMetadata?.frequency?.enabled && formMetadata?.frequency?.schedule && (
            <div style={{
                marginTop: '-12px',
                marginBottom: '20px',
                padding: '10px 16px',
                background: 'linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)',
                borderRadius: '8px',
                border: '1px solid #91d5ff',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                flexWrap: 'wrap'
            }}>
                <ClockCircleOutlined style={{ color: '#1890ff', fontSize: '16px' }} />
                <Text strong style={{ color: '#0050b3' }}>
                    {selectedLanguage === 'english' ? 'Schedule:' : 'वेळापत्रक:'}
                </Text>
                <Text style={{ color: '#003a8c' }}>
                    {(() => {
                        const schedule = formMetadata.frequency.schedule;
                        const lang = selectedLanguage;
                        const time = schedule.time || '09:00';
                        const frequencyType = formMetadata.frequency.type;
                        const customName = formMetadata.frequency.custom;

                        if (frequencyType === 'custom') {
                            const scheduleDate = schedule.date || '';
                            if (scheduleDate) {
                                return lang === 'english'
                                    ? `${customName || 'Custom'}: ${scheduleDate} at ${time}`
                                    : `${customName || 'सानुकूल'}: ${scheduleDate} रोजी ${time} वाजता`;
                            }
                            return lang === 'english'
                                ? `${customName || 'Custom'}: at ${time}`
                                : `${customName || 'सानुकूल'}: ${time} वाजता`;
                        }

                        if (frequencyType === 'daily') {
                            return lang === 'english' ? `Daily at ${time}` : `दररोज ${time} वाजता`;
                        }
                        if (frequencyType === 'weekly') {
                            const weekdays = {
                                monday: { en: 'Monday', mr: 'सोमवार' },
                                tuesday: { en: 'Tuesday', mr: 'मंगळवार' },
                                wednesday: { en: 'Wednesday', mr: 'बुधवार' },
                                thursday: { en: 'Thursday', mr: 'गुरुवार' },
                                friday: { en: 'Friday', mr: 'शुक्रवार' },
                                saturday: { en: 'Saturday', mr: 'शनिवार' },
                                sunday: { en: 'Sunday', mr: 'रविवार' }
                            };
                            const weekday = schedule.weekday || 'monday';
                            const weekdayName = weekdays[weekday]?.[lang === 'english' ? 'en' : 'mr'] || weekday;
                            return lang === 'english' ? `Every ${weekdayName} at ${time}` : `दर ${weekdayName} रोजी ${time} वाजता`;
                        }
                        if (frequencyType === 'monthly') {
                            const date = schedule.date || 1;
                            const selectionType = schedule.monthlySelectionType || 'date';
                            if (selectionType === 'day') {
                                const weekdaysList = {
                                    monday: { en: 'Monday', mr: 'सोमवार' },
                                    tuesday: { en: 'Tuesday', mr: 'मंगळवार' },
                                    wednesday: { en: 'Wednesday', mr: 'बुधवार' },
                                    thursday: { en: 'Thursday', mr: 'गुरुवार' },
                                    friday: { en: 'Friday', mr: 'शुक्रवार' },
                                    saturday: { en: 'Saturday', mr: 'शनिवार' },
                                    sunday: { en: 'Sunday', mr: 'रविवार' }
                                };
                                const dayOfWeek = schedule.dayOfWeek || 'monday';
                                const weekNumber = schedule.weekNumber || 'first';
                                const weekNumberText = lang === 'english' ?
                                    (weekNumber === 'first' ? 'first' : weekNumber === 'second' ? 'second' : weekNumber === 'third' ? 'third' : weekNumber === 'fourth' ? 'fourth' : weekNumber) :
                                    (weekNumber === 'first' ? 'पहिल्या' : weekNumber === 'second' ? 'दुसऱ्या' : weekNumber === 'third' ? 'तिसऱ्या' : weekNumber === 'fourth' ? 'चौथ्या' : weekNumber);
                                const dayName = weekdaysList[dayOfWeek]?.[lang === 'english' ? 'en' : 'mr'] || dayOfWeek;
                                return lang === 'english'
                                    ? `Every ${weekNumberText} ${dayName} of the month at ${time}`
                                    : `दर महिन्याच्या ${weekNumberText} ${dayName} रोजी ${time} वाजता`;
                            }
                            const ordinal = (n) => {
                                if (n === 1) return '1st';
                                if (n === 2) return '2nd';
                                if (n === 3) return '3rd';
                                return `${n}th`;
                            };
                            return lang === 'english'
                                ? `On the ${ordinal(date)} day of every month at ${time}`
                                : `दर महिन्याच्या ${date} तारखेला ${time} वाजता`;
                        }
                        if (frequencyType === 'quarterly') {
                            const everyN = schedule.everyNMonths || 3;
                            return lang === 'english' ? `Every ${everyN} months at ${time}` : `दर ${everyN} महिन्यांनी ${time} वाजता`;
                        }
                        if (frequencyType === 'half_yearly') {
                            return lang === 'english' ? `Every 6 months at ${time}` : `दर 6 महिन्यांनी ${time} वाजता`;
                        }
                        if (frequencyType === 'yearly') {
                            const month = schedule.month || 1;
                            const day = schedule.date || 1;
                            const monthsList = {
                                1: { en: 'January', mr: 'जानेवारी' },
                                2: { en: 'February', mr: 'फेब्रुवारी' },
                                3: { en: 'March', mr: 'मार्च' },
                                4: { en: 'April', mr: 'एप्रिल' },
                                5: { en: 'May', mr: 'मे' },
                                6: { en: 'June', mr: 'जून' },
                                7: { en: 'July', mr: 'जुलै' },
                                8: { en: 'August', mr: 'ऑगस्ट' },
                                9: { en: 'September', mr: 'सप्टेंबर' },
                                10: { en: 'October', mr: 'ऑक्टोबर' },
                                11: { en: 'November', mr: 'नोव्हेंबर' },
                                12: { en: 'December', mr: 'डिसेंबर' }
                            };
                            const monthName = monthsList[month]?.[lang === 'english' ? 'en' : 'mr'] || month;
                            return lang === 'english'
                                ? `Yearly on ${monthName} ${day} at ${time}`
                                : `दरवर्षी ${monthName} ${day} तारखेला ${time} वाजता`;
                        }

                        return lang === 'english' ? `Scheduled at ${time}` : `${time} वाजता नियोजित`;
                    })()}
                </Text>
            </div>
        )} */}

                            {!printMode && !viewFilledMode && (
                                <div className="progress-container" style={{ marginBottom: '24px' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
        <span style={{ fontSize: '14px', color: '#666' }}>
            {selectedLanguage === 'english' ? 'Form Completion' : 'फॉर्म पूर्णता'}
        </span>
        <span style={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: progress === 100 ? '#52c41a' : '#1890ff'
        }}>
            {progress}%
        </span>
    </div>
    <div style={{
        width: '100%',
        height: '8px',
        backgroundColor: '#f0f0f0',
        borderRadius: '4px',
        overflow: 'hidden'
    }}>
        <div style={{
            width: `${progress}%`,
            height: '100%',
            backgroundColor: progress === 100 ? '#52c41a' : '#1890ff',
            borderRadius: '4px',
            transition: 'width 0.3s ease-in-out'
        }} />
    </div>
    {progress < 100 && (
        <div style={{
            fontSize: '12px',
            color: '#999',
            marginTop: '4px',
            textAlign: 'right'
        }}>
            {selectedLanguage === 'english'
                ? `${100 - progress}% remaining`
                : `${100 - progress}% बाकी`}
        </div>
    )}
</div>
                            )}

                            {isMultiEntryLimitReached && !viewFilledMode && formMetadata?.entry_type === 'multi' && (
                                <div style={{
                                    background: '#fff7e6',
                                    border: '1px solid #ffd591',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    marginBottom: '20px',
                                    textAlign: 'center'
                                }}>
                                    <Space>
                                        <ExclamationCircleOutlined style={{ color: '#fa8c16', fontSize: '20px' }} />
                                        <Text strong style={{ color: '#d46b08' }}>
                                            {selectedLanguage === 'english'
                                                ? `You have reached the maximum limit of ${formMetadata?.max_entries_per_user} entries for this form.`
                                                : `तुम्ही या फॉर्मसाठी कमाल ${formMetadata?.max_entries_per_user} एंट्रीची मर्यादा पूर्ण केली आहे.`}
                                        </Text>
                                    </Space>
                                </div>
                            )}

                            {!printMode && !viewFilledMode && Object.keys(validationErrors).length > 0 && (
                                <div style={{
                                    background: '#fff1f0',
                                    border: '1px solid #ffa39e',
                                    borderRadius: '4px',
                                    padding: '16px',
                                    marginBottom: '20px'
                                }}>
                                    <strong style={{ color: '#f5222d', display: 'block', marginBottom: '8px' }}>
                                        {selectedLanguage === 'english' ? 'Please fix the following errors:' : 'कृपया खालील त्रुटी सुधारा:'}
                                    </strong>
                                    <ul style={{ margin: 0, paddingLeft: '20px', color: '#f5222d' }}>
                                        {Object.values(validationErrors).map((error, i) => (
                                            <li key={i}>{error}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            <div>
                                {currentForm.schema
                                    ?.filter(f => !f.parentId)
                                    .map(field => renderField(field))}
                            </div>

                            {!printMode && !viewFilledMode && !isMultiEntryLimitReached && (
                                <div className="confirmation-box" style={{
    marginBottom: '24px',
    marginTop: '24px',
    padding: '20px 24px',
    background: 'linear-gradient(135deg, #fef9e7 0%, #fff3e0 100%)',
    border: '2px solid #ff9800',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(255, 152, 0, 0.15)',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    transition: 'all 0.3s ease',
    cursor: 'pointer'
}}
onClick={() => setConfirmSubmit(!confirmSubmit)}
onMouseEnter={(e) => {
    e.currentTarget.style.boxShadow = '0 6px 16px rgba(255, 152, 0, 0.25)';
    e.currentTarget.style.transform = 'translateY(-2px)';
}}
onMouseLeave={(e) => {
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 152, 0, 0.15)';
    e.currentTarget.style.transform = 'translateY(0)';
}}>
                                    <div style={{
                                        position: 'relative',
                                        width: '28px',
                                        height: '28px'
                                    }}>
                                        <Checkbox
                                            checked={confirmSubmit}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                setConfirmSubmit(e.target.checked);
                                            }}
                                            style={{
                                                transform: 'scale(1.3)',
                                                position: 'absolute',
                                                top: '2px',
                                                left: '2px'
                                            }}
                                            disabled={isFormBlocked}
                                        />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <div style={{
                                            fontSize: '18px',
                                            fontWeight: '600',
                                            color: '#e65100',
                                            marginBottom: '4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            <CheckCircleOutlined style={{ color: '#ff9800' }} />
                                            <span>
                                                {selectedLanguage === 'english'
                                                    ? 'Final Confirmation'
                                                    : 'अंतिम पुष्टीकरण'}
                                            </span>
                                        </div>
                                        <div style={{
                                            fontSize: '15px',
                                            color: '#bf360c',
                                            lineHeight: '1.5',
                                            paddingLeft: '4px'
                                        }}>
                                            {selectedLanguage === 'english'
                                                ? '✓ मी प्रमाणित करतो / करते की वरील सर्व माहिती बरोबर आहे.'
                                                : '✓मी प्रमाणित करतो / करते की वरील सर्व माहिती बरोबर आहे.'}
                                        </div>

                                        {!confirmSubmit && !isFormBlocked && (
                                            <div style={{
                                                marginTop: '8px',
                                                fontSize: '13px',
                                                color: '#f57c00',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                background: 'rgba(255, 152, 0, 0.1)',
                                                padding: '6px 12px',
                                                borderRadius: '20px',
                                                width: 'fit-content'
                                            }}>
                                                <InfoCircleOutlined />
                                                <span>
                                                    {selectedLanguage === 'english'
                                                        ? 'Please confirm to enable submission'
                                                        : 'कृपया सबमिट करण्यासाठी पुष्टी करा'}
                                                </span>
                                            </div>
                                        )}



                                        {isFormBlocked && (
                                            <div style={{
                                                marginTop: '8px',
                                                fontSize: '13px',
                                                color: '#c62828',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                background: 'rgba(198, 40, 40, 0.1)',
                                                padding: '6px 12px',
                                                borderRadius: '20px',
                                                width: 'fit-content'
                                            }}>
                                                <ExclamationCircleOutlined />
                                                <span>
                                                    {selectedLanguage === 'english'
                                                        ? 'This form cannot be submitted anymore'
                                                        : 'हा फॉर्म आता सबमिट करू शकत नाही'}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {printMode && (
                                <div className="print-footer">
                                    <p>{selectedLanguage === 'english' ? 'This is a computer generated print. No signature is required.' : 'ही संगणकावर तयार केलेली प्रिंट आहे. कोणत्याही स्वाक्षरीची आवश्यकता नाही.'}</p>
                                </div>
                            )}

                            {!printMode && !viewFilledMode && !isMultiEntryLimitReached && (
                               <div className="button-group" style={{
    display: 'flex',
    gap: '16px',
    marginTop: '32px',
    marginBottom: '20px'
}}>
                                    <Button
                                        onClick={() => saveFormData('draft')}
                                        disabled={isSubmitting || isFormBlocked}
                                        size="large"
                                        block
                                        style={{
                                            height: '48px',
                                            fontSize: '16px',
                                            borderRadius: '8px',
                                            border: '2px solid #d9d9d9',
                                            background: '#ffffff'
                                        }}
                                    >
                                        {isSubmitting ? (
                                            <Space>
                                                <LoadingOutlined spin />
                                                {selectedLanguage === 'english' ? 'Saving...' : 'जतन करत आहे...'}
                                            </Space>
                                        ) : (
                                            <Space>
                                                <SaveOutlined />
                                                {selectedLanguage === 'english' ? 'Save Draft' : 'मसुदा जतन करा'}
                                            </Space>
                                        )}
                                    </Button>

                                    <Button
                                        type="primary"
                                        onClick={() => saveFormData('filled')}
                                        disabled={isSubmitting || !confirmSubmit || isFormBlocked}
                                        size="large"
                                        block
                                        style={{
                                            height: '48px',
                                            fontSize: '16px',
                                            borderRadius: '8px',
                                            background: (!confirmSubmit || isFormBlocked) ? '#cccccc' : 'linear-gradient(135deg, #28a745 0%, #218838 100%)',
                                            border: 'none',
                                            boxShadow: (!confirmSubmit || isFormBlocked) ? 'none' : '0 4px 12px rgba(40, 167, 69, 0.3)',
                                            cursor: (!confirmSubmit || isFormBlocked) ? 'not-allowed' : 'pointer',
                                            transition: 'all 0.3s ease',
                                            opacity: (!confirmSubmit || isFormBlocked) ? 0.7 : 1
                                        }}
                                        onMouseEnter={(e) => {
                                            if (confirmSubmit && !isFormBlocked) {
                                                e.currentTarget.style.background = 'linear-gradient(135deg, #218838 0%, #1e7e34 100%)';
                                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(40, 167, 69, 0.4)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (confirmSubmit && !isFormBlocked) {
                                                e.currentTarget.style.background = 'linear-gradient(135deg, #28a745 0%, #218838 100%)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(40, 167, 69, 0.3)';
                                            }
                                        }}
                                    >
                                        {isSubmitting ? (
                                            <Space>
                                                <LoadingOutlined spin />
                                                {selectedLanguage === 'english' ? 'Submitting...' : 'सबमिट करत आहे...'}
                                            </Space>
                                        ) : (
                                            <Space>
                                                <CheckCircleOutlined />
                                                {selectedLanguage === 'english' ? 'Submit Form' : 'फॉर्म सबमिट करा'}
                                            </Space>
                                        )}
                                    </Button>
                                </div>
                            )}

                            {(viewFilledMode || isMultiEntryLimitReached) && (
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            setViewMode('list');
                                            setCurrentForm(null);
                                            setFormData({});
                                            setIsFormBlocked(false);
                                            setViewFilledMode(false);
                                            setIsMultiEntryLimitReached(false);
                                        }}
                                        size="large"
                                    >
                                        {selectedLanguage === 'english' ? 'Back to Forms' : 'फॉर्म्सकडे परत'}
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}


                </div>
            </div>
        </div>
    );
};

export default FormApp;